/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: any;
  Metadata: any;
  PositiveDecimal: any;
  StringOrFloat: any;
  Time: any;
  Upload: any;
  _Any: any;
};

export enum AtpctpActionType {
  COMMIT = 'COMMIT',
  ROLLBACK = 'ROLLBACK'
}

export type AtpctpConfirmInputType = {
  items: Array<InputMaybe<AtpctpConfirmItemInputType>>;
};

export type AtpctpConfirmItemInputType = {
  action?: InputMaybe<AtpctpActionType>;
  iplanRequestParams?: InputMaybe<IplanRequireAttentionRequestParamsInput>;
  lineId?: InputMaybe<Scalars['ID']>;
  listItems?: InputMaybe<Array<InputMaybe<AtpctpListItemsInput>>>;
  materialVariantCode?: InputMaybe<Scalars['String']>;
  materialVariantDescription?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  originalItemNo?: InputMaybe<Scalars['String']>;
  originalPlant?: InputMaybe<Scalars['String']>;
  originalQuantity?: InputMaybe<Scalars['Float']>;
  originalRequestDate?: InputMaybe<Scalars['Date']>;
  uniqueId?: InputMaybe<Scalars['String']>;
};

export type AtpctpListItemsInput = {
  atpCtp?: InputMaybe<Scalars['String']>;
  atpCtpDetail?: InputMaybe<Scalars['String']>;
  blockCode?: InputMaybe<Scalars['String']>;
  confirmDate?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  onHandStock?: InputMaybe<Scalars['Boolean']>;
  orderType?: InputMaybe<Scalars['String']>;
  paperMachine?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  runCode?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type AtpctpRequestOrderLineInput = {
  itemNo?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
};

export type AcceptConfirmDateInput = {
  /** A list of RequireAttentionItems items, each containing request_date want to accept */
  lines: Array<AcceptConfirmDateItemInput>;
};

export type AcceptConfirmDateItemInput = {
  requestDate: Scalars['Date'];
  /** ID of the pi product. */
  uniqueId: Scalars['ID'];
};

export type AcceptConfirmDateRequireAttentionInput = {
  lines: Array<AcceptConfirmDateRequireAttentionItemsInput>;
};

export type AcceptConfirmDateRequireAttentionItemsInput = {
  id: Scalars['ID'];
  itemNo?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
};

/** An enumeration. */
export enum AccountErrorCode {
  ACCOUNT_NOT_CONFIRMED = 'ACCOUNT_NOT_CONFIRMED',
  ACTIVATE_OWN_ACCOUNT = 'ACTIVATE_OWN_ACCOUNT',
  ACTIVATE_SUPERUSER_ACCOUNT = 'ACTIVATE_SUPERUSER_ACCOUNT',
  CF_TURNSTILE_VERIFY_INVALID = 'CF_TURNSTILE_VERIFY_INVALID',
  CHANNEL_INACTIVE = 'CHANNEL_INACTIVE',
  DEACTIVATE_OWN_ACCOUNT = 'DEACTIVATE_OWN_ACCOUNT',
  DEACTIVATE_SUPERUSER_ACCOUNT = 'DEACTIVATE_SUPERUSER_ACCOUNT',
  DELETE_NON_STAFF_USER = 'DELETE_NON_STAFF_USER',
  DELETE_OWN_ACCOUNT = 'DELETE_OWN_ACCOUNT',
  DELETE_STAFF_ACCOUNT = 'DELETE_STAFF_ACCOUNT',
  DELETE_SUPERUSER_ACCOUNT = 'DELETE_SUPERUSER_ACCOUNT',
  DUPLICATED_INPUT_ITEM = 'DUPLICATED_INPUT_ITEM',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INACTIVE = 'INACTIVE',
  INVALID = 'INVALID',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  JWT_DECODE_ERROR = 'JWT_DECODE_ERROR',
  JWT_INVALID_CSRF_TOKEN = 'JWT_INVALID_CSRF_TOKEN',
  JWT_INVALID_TOKEN = 'JWT_INVALID_TOKEN',
  JWT_MISSING_TOKEN = 'JWT_MISSING_TOKEN',
  JWT_SIGNATURE_EXPIRED = 'JWT_SIGNATURE_EXPIRED',
  LEFT_NOT_MANAGEABLE_PERMISSION = 'LEFT_NOT_MANAGEABLE_PERMISSION',
  MISSING_CHANNEL_SLUG = 'MISSING_CHANNEL_SLUG',
  NOT_FOUND = 'NOT_FOUND',
  OUT_OF_SCOPE_GROUP = 'OUT_OF_SCOPE_GROUP',
  OUT_OF_SCOPE_PERMISSION = 'OUT_OF_SCOPE_PERMISSION',
  OUT_OF_SCOPE_USER = 'OUT_OF_SCOPE_USER',
  PASSWORD_ENTIRELY_NUMERIC = 'PASSWORD_ENTIRELY_NUMERIC',
  PASSWORD_TOO_COMMON = 'PASSWORD_TOO_COMMON',
  PASSWORD_TOO_SHORT = 'PASSWORD_TOO_SHORT',
  PASSWORD_TOO_SIMILAR = 'PASSWORD_TOO_SIMILAR',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type AddProductToOrderInput = {
  contractMaterialId: Scalars['ID'];
  materialVariantId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
};

export type AddSplitOrderLineItemInput = {
  id?: InputMaybe<Scalars['Int']>;
  itemNo?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  requestDate?: InputMaybe<Scalars['Date']>;
};

export type AgencyInput = {
  /** Distribution Channel */
  distributionChannelId?: InputMaybe<Scalars['ID']>;
  /** Division */
  divisionId?: InputMaybe<Scalars['ID']>;
  /** Order Type */
  orderType?: InputMaybe<ScgExportOrderType>;
  /** Sales Group */
  salesGroupId?: InputMaybe<Scalars['ID']>;
  /** Sale office */
  salesOfficeId?: InputMaybe<Scalars['ID']>;
  /** Sales Org */
  salesOrganizationId?: InputMaybe<Scalars['ID']>;
};

export type AlterMaterialFilterInput = {
  grade?: InputMaybe<Scalars['String']>;
  gram?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type AlternatedMaterialFilterInput = {
  createBy?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<DateRangeInput>;
  errorType?: InputMaybe<Scalars['String']>;
  newGradeGram?: InputMaybe<Scalars['String']>;
  newMaterial?: InputMaybe<Scalars['String']>;
  oldGradeGram?: InputMaybe<Scalars['String']>;
  oldMaterial?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<DateRangeInput>;
  saleOrganization?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<Scalars['Int']>>;
};

export enum AlternatedMaterialOsSortField {
  ALTERNATED_MATERIAL = 'ALTERNATED_MATERIAL',
  DIA = 'DIA',
  LAST_UPDATED_BY = 'LAST_UPDATED_BY',
  LAST_UPDATED_DATE = 'LAST_UPDATED_DATE',
  MATERIAL_INPUT = 'MATERIAL_INPUT',
  PRIORITY = 'PRIORITY',
  SALE_ORG = 'SALE_ORG',
  SOLD_TO = 'SOLD_TO',
  TYPE = 'TYPE'
}

export enum AlternatedMaterialSortField {
  ORDER_NO = 'ORDER_NO'
}

export type AlternatedMaterialSortInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort alternatedMaterial by the selected field. */
  field: AlternatedMaterialSortField;
};

export type AlternativeMaterialAddInput = {
  /** A list of Material Os, each containing information about an Alternative Material. */
  lines: Array<AlternativeMaterialItemInput>;
  /** ID of the Material Own. */
  materialOwnId?: InputMaybe<Scalars['ID']>;
  /** ID of the Sale Organization. */
  saleOrganizationId: Scalars['ID'];
  /** ID of the sold to. */
  soldToId: Scalars['ID'];
  /** Type of the Alternative Material. */
  type: Scalars['String'];
};

export type AlternativeMaterialEditInput = {
  /** A list of alternative material os items, each containing information about an item in the Alternative Material. */
  lines: Array<AlternativeMaterialItemInput>;
  /** ID of the Material Own. */
  materialOwnId?: InputMaybe<Scalars['ID']>;
  /** ID of the Sale Organization. */
  saleOrganizationId: Scalars['ID'];
  /** ID of the sold to. */
  soldToId: Scalars['ID'];
};

export type AlternativeMaterialItemInput = {
  /** Diameter of the Material Os. */
  dia?: InputMaybe<Scalars['String']>;
  /** ID of the Material Os. */
  materialOsId?: InputMaybe<Scalars['ID']>;
  /** Priority of the Alternative Material. */
  priority: Scalars['Int'];
};

export type AlternativeMaterialOsInput = {
  /** Specifies the direction in which to sort alter material os. */
  direction: OrderDirection;
  /** Sort alternatedMaterial by the selected field. */
  field: AlternatedMaterialOsSortField;
};

export type ArOutstandingInput = {
  /** Sales Org. Code */
  saleOrgCode: Scalars['String'];
  /** Sold To Code */
  soldToCode: Scalars['String'];
};

/** An enumeration. */
export enum AreaUnitsEnum {
  SQ_CM = 'SQ_CM',
  SQ_FT = 'SQ_FT',
  SQ_INCH = 'SQ_INCH',
  SQ_KM = 'SQ_KM',
  SQ_M = 'SQ_M',
  SQ_YD = 'SQ_YD'
}

export type CancelDeleteCipOrderLinesInput = {
  itemNo: Scalars['String'];
  status: CipCancelItemStatus;
};

export type CancelDeleteOrderLinesInput = {
  itemNo: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export enum CancelItem {
  CANCEL_93 = 'CANCEL_93',
  DELETE = 'DELETE'
}

export type CartFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  inputSearch?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type CartPiFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type CashSaleFileInput = {
  documentType?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
};

export type CashSaleInput = {
  arAmount?: InputMaybe<Scalars['Float']>;
  balanceAmount?: InputMaybe<Scalars['Float']>;
  balanceFlag?: InputMaybe<Scalars['Boolean']>;
  cashAmount?: InputMaybe<Scalars['Float']>;
  cashFlag?: InputMaybe<Scalars['Boolean']>;
  feeAbsorbFlag?: InputMaybe<Scalars['Boolean']>;
  feeAmount?: InputMaybe<Scalars['Float']>;
  feeType?: InputMaybe<Scalars['String']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  orderAmount?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  withHoldTax?: InputMaybe<Scalars['Float']>;
};

export type ChangeExportOrderLineAddProductInput = {
  orderlinesId: Array<InputMaybe<Scalars['ID']>>;
  piProduct: Scalars['ID'];
  quantity: Scalars['Float'];
};

export enum ChangeExportRejectReason {
  CANCEL_93 = 'CANCEL_93',
  DELETE = 'DELETE'
}

export type ChangeOrderAtpctpRequestOrderLineInput = {
  itemNo?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  orderNo?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderAddNewItemItemDetails = {
  additionalData?: InputMaybe<ChangeOrderItemDetailsAdditionalDataInput>;
  itemNo: Scalars['String'];
  orderInformation?: InputMaybe<ChangeOrderItemDetailsOrderInformationInput>;
  refDocIt?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderAddNewOrderLineInput = {
  listNewItems?: InputMaybe<Array<InputMaybe<ChangeOrderAddNewItemItemDetails>>>;
  orderHeaders?: InputMaybe<ChangeOrderHeaderFixedDataInput>;
};

export type ChangeOrderEditInput = {
  header?: InputMaybe<ChangeOrderHeaderInput>;
  itemDetails?: InputMaybe<Array<InputMaybe<ChangeOrderItemDetailsInput>>>;
  status?: InputMaybe<ScgOrderStatus>;
};

export type ChangeOrderHeaderAdditionalDataInput = {
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  productionInformation?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderHeaderFixedDataInput = {
  billToCode?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  shipToCode?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderHeaderInput = {
  additionalData?: InputMaybe<ChangeOrderHeaderAdditionalDataInput>;
  fixedData?: InputMaybe<ChangeOrderHeaderFixedDataInput>;
  partner?: InputMaybe<ChangeOrderHeaderPartnerInput>;
};

export type ChangeOrderHeaderPartnerInput = {
  billTo?: InputMaybe<Scalars['String']>;
  customerGroup1?: InputMaybe<Scalars['ID']>;
  customerGroup2?: InputMaybe<Scalars['ID']>;
  customerGroup3?: InputMaybe<Scalars['ID']>;
  customerGroup4?: InputMaybe<Scalars['ID']>;
  incoterms1?: InputMaybe<Scalars['ID']>;
  /** dd/mm/YYYY */
  poDate?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderItemDetailsAdditionalDataInput = {
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  /** Input code */
  shipToParty?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderItemDetailsInput = {
  additionalData?: InputMaybe<ChangeOrderItemDetailsAdditionalDataInput>;
  cancelItem?: InputMaybe<CancelItem>;
  iplanDetails?: InputMaybe<ChangeOrderItemDetailsIplanDetailsInput>;
  itemNo?: InputMaybe<Scalars['String']>;
  /** Check if the order line is newly created */
  new?: InputMaybe<Scalars['Boolean']>;
  orderInformation?: InputMaybe<ChangeOrderItemDetailsOrderInformationInput>;
  /** input item_no of order line original */
  splitFrom?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderItemDetailsIplanDetailsInput = {
  consignmentLocation?: InputMaybe<Scalars['String']>;
  inputParameter?: InputMaybe<InquiryMethodType>;
};

export type ChangeOrderItemDetailsOrderInformationInput = {
  deliveryTolerance?: InputMaybe<DeliveryTolerance>;
  itemCategory?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  reasonForChangeRequestDate?: InputMaybe<ReasonForChangeRequestDateEnum>;
  /** input format DD/MM/YYYY */
  requestDate?: InputMaybe<Scalars['String']>;
  /** Input code */
  route?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<WeightUnitEnum>;
};

export enum ChangeOrderOrderStatus {
  ALL = 'ALL',
  CANCELLED = 'CANCELLED',
  COMPLETED_DELIVERY = 'COMPLETED_DELIVERY',
  COMPLETED_ORDER = 'COMPLETED_ORDER',
  CREDIT_CASH_ISSUE = 'CREDIT_CASH_ISSUE',
  PARTIAL_COMMITTED_ORDER = 'PARTIAL_COMMITTED_ORDER',
  PARTIAL_DELIVERY = 'PARTIAL_DELIVERY',
  READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
  RECEIVED_ORDER = 'RECEIVED_ORDER'
}

export type ChangeOrderShipToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

export type ChangeOrderSoldToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

export enum ChangeOrderStatusEnum {
  ALL = 'ALL',
  COMPLETE = 'COMPLETE',
  OPEN = 'OPEN'
}

export type CheckoutAtpctpConfirmInputType = {
  items: Array<InputMaybe<CheckoutAtpctpConfirmItemInputType>>;
};

export type CheckoutAtpctpConfirmItemInputType = {
  action?: InputMaybe<AtpctpActionType>;
  calculatedItemNo?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  listItems?: InputMaybe<Array<InputMaybe<CheckoutAtpctpItemBaseListItemInput>>>;
  materialVariantCode: Scalars['String'];
  materialVariantDescription?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  originalItemNo: Scalars['String'];
  originalPlant?: InputMaybe<Scalars['String']>;
  originalQuantity: Scalars['Float'];
  originalRequestDate: Scalars['String'];
};

export type CheckoutAtpctpItemBaseListItemInput = {
  atpCtp?: InputMaybe<Scalars['String']>;
  atpCtpDetail?: InputMaybe<Scalars['String']>;
  blockCode?: InputMaybe<Scalars['String']>;
  confirmDate?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  onHandStock?: InputMaybe<Scalars['Boolean']>;
  orderType?: InputMaybe<Scalars['String']>;
  paperMachine?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  runCode?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CheckoutAtpctpRequestOrderLineInput = {
  consignmentLocation?: InputMaybe<Scalars['String']>;
  inquiryMethod?: InputMaybe<InquiryMethodType>;
  itemNo?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  orderNo?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['String']>;
};

export enum CheckoutLineOrderField {
  CONTRACT = 'CONTRACT',
  PRICE = 'PRICE',
  REMAIN = 'REMAIN',
  TOTAL = 'TOTAL'
}

export type CheckoutLineSortingInput = {
  /** Specifies the direction in which to sort checkout lines. */
  direction: OrderDirection;
  /** Specifies the field in which to sort checkout lines. */
  field: CheckoutLineOrderField;
};

export enum CipCancelItemStatus {
  CANCEL = 'Cancel',
  DELETE = 'Delete'
}

export type CipChangeOrderEditInput = {
  headerDetails?: InputMaybe<CipChangeOrderHeaderInput>;
  /** A list of order lines, each containing information about an item in the order. */
  itemDetails?: InputMaybe<Array<CipChangeOrderItemDetailsInput>>;
};

export type CipChangeOrderHeaderInput = {
  billTo?: InputMaybe<Scalars['String']>;
  cash?: InputMaybe<Scalars['String']>;
  cpNeed?: InputMaybe<Scalars['Boolean']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  fromHeader?: InputMaybe<Scalars['String']>;
  headerNote1?: InputMaybe<Scalars['String']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  priceDate?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  saleGroupCode?: InputMaybe<Scalars['String']>;
  salesEmployee?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  taxClass?: InputMaybe<Scalars['String']>;
  totalItems?: InputMaybe<Scalars['Int']>;
  unLoadingPoint?: InputMaybe<Scalars['String']>;
};

export type CipChangeOrderItemDetailsInput = {
  assignedQuantity?: InputMaybe<Scalars['String']>;
  batchChoiceFlag?: InputMaybe<Scalars['Boolean']>;
  batchNo?: InputMaybe<Scalars['String']>;
  confirmQuantity?: InputMaybe<Scalars['String']>;
  deliveryTolOver?: InputMaybe<Scalars['StringOrFloat']>;
  deliveryTolUnder?: InputMaybe<Scalars['StringOrFloat']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  itemNote?: InputMaybe<Scalars['String']>;
  lotNo?: InputMaybe<Scalars['String']>;
  manualPriceFlag?: InputMaybe<Scalars['Boolean']>;
  materialNo?: InputMaybe<Scalars['String']>;
  /** information about One Time Customer Ship TO */
  otcShipTo?: InputMaybe<CipOrderOtcPartnerInput>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  poDetail?: InputMaybe<Scalars['String']>;
  poItemNo?: InputMaybe<Scalars['String']>;
  prItemText?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  priceDate?: InputMaybe<Scalars['Date']>;
  pricePerUnit?: InputMaybe<Scalars['StringOrFloat']>;
  productionFlag?: InputMaybe<Scalars['String']>;
  productionMemo?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  saleQtyFactor?: InputMaybe<Scalars['Int']>;
  saleText1?: InputMaybe<Scalars['String']>;
  saleText2?: InputMaybe<Scalars['String']>;
  saleText3?: InputMaybe<Scalars['String']>;
  saleText4?: InputMaybe<Scalars['String']>;
  sapConfirmQty?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CipHeaderShipTosFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CipOrderErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  OUTDATED = 'OUTDATED',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type CipOrderInformationInput = {
  billTo?: InputMaybe<Scalars['String']>;
  cash?: InputMaybe<Scalars['String']>;
  customerGroup1Id?: InputMaybe<Scalars['ID']>;
  customerGroup2Id?: InputMaybe<Scalars['ID']>;
  customerGroup3Id?: InputMaybe<Scalars['ID']>;
  customerGroup4Id?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deliveryBlock?: InputMaybe<Scalars['String']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  fromHeader?: InputMaybe<Scalars['String']>;
  headerNote1?: InputMaybe<Scalars['String']>;
  incotermsId?: InputMaybe<Scalars['ID']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  /** information about One Time Customer Bill TO */
  otcBillTo?: InputMaybe<CipOrderOtcPartnerInput>;
  /** information about One Time Customer Ship TO */
  otcShipTo?: InputMaybe<CipOrderOtcPartnerInput>;
  /** information about One Time Customer Sold TO */
  otcSoldTo?: InputMaybe<CipOrderOtcPartnerInput>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  poDate?: InputMaybe<Scalars['Date']>;
  poNumber?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  route?: InputMaybe<Scalars['String']>;
  salesEmployee?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
  taxClass?: InputMaybe<Scalars['String']>;
  unloadingPoint?: InputMaybe<Scalars['String']>;
};

export type CipOrderLineInput = {
  batchChoiceFlag?: InputMaybe<Scalars['Boolean']>;
  batchNo?: InputMaybe<Scalars['String']>;
  bomFlag?: InputMaybe<Scalars['Boolean']>;
  bomMaterialId?: InputMaybe<Scalars['String']>;
  deliveryTolOver?: InputMaybe<Scalars['StringOrFloat']>;
  deliveryTolUnder?: InputMaybe<Scalars['StringOrFloat']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  /** id of order line */
  id?: InputMaybe<Scalars['ID']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  itemNote?: InputMaybe<Scalars['String']>;
  lotNo?: InputMaybe<Scalars['String']>;
  manualPriceFlag?: InputMaybe<Scalars['Boolean']>;
  materialNo?: InputMaybe<Scalars['String']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  poItemNo?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  poNoExternal?: InputMaybe<Scalars['String']>;
  prItemText?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  priceDate?: InputMaybe<Scalars['Date']>;
  pricePerUnit?: InputMaybe<Scalars['Float']>;
  productInformation?: InputMaybe<Scalars['String']>;
  productionFlag?: InputMaybe<Scalars['String']>;
  productionMemo?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  requestDateChangeReason?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  saleText1?: InputMaybe<Scalars['String']>;
  saleText2?: InputMaybe<Scalars['String']>;
  saleText3?: InputMaybe<Scalars['String']>;
  saleText4?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type CipOrderOrganizationalDataInput = {
  distributionChannelCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  saleGroupCode?: InputMaybe<Scalars['String']>;
  saleOfficeCode?: InputMaybe<Scalars['String']>;
  saleOrganizationCode?: InputMaybe<Scalars['String']>;
  salesEmployee?: InputMaybe<Scalars['String']>;
};

export type CipOrderOtcPartnerInput = {
  branchId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  faxNo?: InputMaybe<Scalars['String']>;
  faxNoExt?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mobileNo?: InputMaybe<Scalars['String']>;
  name1?: InputMaybe<Scalars['String']>;
  name2?: InputMaybe<Scalars['String']>;
  name3?: InputMaybe<Scalars['String']>;
  name4?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  street3?: InputMaybe<Scalars['String']>;
  street4?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxNumber1?: InputMaybe<Scalars['String']>;
  taxNumber2?: InputMaybe<Scalars['String']>;
  telephoneExtension?: InputMaybe<Scalars['String']>;
  telephoneNo?: InputMaybe<Scalars['String']>;
  transportZoneCode?: InputMaybe<Scalars['String']>;
  transportZoneName?: InputMaybe<Scalars['String']>;
};

export type CipOrderUpdateInput = {
  /** A list of order lines, each containing information about an item in the order. */
  lines?: InputMaybe<Array<CipOrderLineInput>>;
  orderInformation?: InputMaybe<CipOrderInformationInput>;
  /** information about order organization data */
  orderOrganizationData?: InputMaybe<CipOrderOrganizationalDataInput>;
  status?: InputMaybe<ScgOrderStatus>;
};

/** An enumeration. */
export enum CognitoErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type ContractCheckoutCreateInput = {
  /** ID of the contract. */
  contractId: Scalars['ID'];
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<ContractCheckoutLineInput>;
  /** ID of the contract. */
  userId: Scalars['ID'];
};

/** An enumeration. */
export enum ContractCheckoutErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  CONTRACT_ERROR = 'CONTRACT_ERROR',
  DUPLICATE_ORDER = 'DUPLICATE_ORDER',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  OUTDATED = 'OUTDATED',
  PRODUCT_GROUP_ERROR = 'PRODUCT_GROUP_ERROR',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type ContractCheckoutLineInput = {
  /** ID of the contract material */
  contractMaterialId?: InputMaybe<Scalars['ID']>;
  /** price positive */
  price?: InputMaybe<Scalars['PositiveDecimal']>;
  /** ID of the contract. */
  productId: Scalars['ID'];
  /** The number of items purchased. */
  quantity: Scalars['Float'];
  /** ID of the product variant. */
  variantId?: InputMaybe<Scalars['ID']>;
};

export type ContractCheckoutLineUpdateInput = {
  /** ID of the contract. */
  id: Scalars['ID'];
  /** price positive */
  price?: InputMaybe<Scalars['PositiveDecimal']>;
  /** ID of the contract. */
  productId: Scalars['ID'];
  /** The number of items purchased. */
  quantity: Scalars['Int'];
  /** ID of the product variant. */
  selected: Scalars['Boolean'];
  /** ID of the product variant. */
  variantId: Scalars['ID'];
};

export type ContractCheckoutUpdateInput = {
  /** ID of the contract. */
  contractId?: InputMaybe<Scalars['ID']>;
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<ContractCheckoutLineUpdateInput>;
  /** ID of the contract. */
  userId?: InputMaybe<Scalars['ID']>;
};

export enum ContractCheckoutsSortField {
  /** Sort contract checkouts by lines count. */
  LINES_COUNT = 'LINES_COUNT'
}

export type ContractCheckoutsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort contractCheckouts by the selected field. */
  field: ContractCheckoutsSortField;
};

export type ContractOrderCreateInput = {
  /** A list of order lines, each containing information about an item in the order. */
  lines: Array<ContractOrderLineInput>;
  orderInformation?: InputMaybe<OrderInformationInput>;
};

export type ContractOrderLineInput = {
  checkoutLineId?: InputMaybe<Scalars['ID']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  materialNo?: InputMaybe<Scalars['String']>;
  overDeliveryTol?: InputMaybe<Scalars['Float']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  poNoExternal?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  requestDateChangeReason?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  splitItems?: InputMaybe<Array<InputMaybe<ContractOrderLineSplitInput>>>;
  underDeliveryTol?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ContractOrderLineSplitInput = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  requestDate?: InputMaybe<Scalars['Date']>;
};

export type ContractOrderLineUpdateInput = {
  checkoutLineId?: InputMaybe<Scalars['ID']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  /** id of order line */
  id: Scalars['ID'];
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  materialNo?: InputMaybe<Scalars['String']>;
  overDeliveryTol?: InputMaybe<Scalars['Float']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  poNoExternal?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  requestDateChangeReason?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  splitItems?: InputMaybe<Array<InputMaybe<ContractOrderLineSplitInput>>>;
  underDeliveryTol?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ContractOrderLinesUpdateInput = {
  billTo?: InputMaybe<Scalars['String']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  materialNo?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  route?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type ContractOrderUpdateInput = {
  /** A list of order lines, each containing information about an item in the order. */
  lines: Array<ContractOrderLineUpdateInput>;
  orderInformation?: InputMaybe<OrderInformationInput>;
  /** information about order organization data */
  orderOrganizationData?: InputMaybe<OrderOrganizationalDataInput>;
  status?: InputMaybe<ScgOrderStatus>;
};

export enum ContractsSortField {
  /** Sort contracts by contract no. */
  CONTRACT_NO = 'CONTRACT_NO'
}

export type ContractsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort contracts by the selected field. */
  field: ContractsSortField;
};

export type CountryFilterInput = {
  /** Boolean for filtering countries by having shipping zone assigned.If 'true', return countries with shipping zone assigned.If 'false', return countries without any shipping zone assigned.If the argument is not provided (null), return all countries. */
  attachedToShippingZones?: InputMaybe<Scalars['Boolean']>;
};

export type CpOrderLineInput = {
  itemNo?: InputMaybe<Scalars['String']>;
  manualPriceFlag?: InputMaybe<Scalars['Boolean']>;
  plant?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
};

export type CpOrderUpdateInput = {
  /** A list of order lines, each containing information about an item in the order. */
  lines?: InputMaybe<Array<CpOrderLineInput>>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type CreateCustomerOrderInput = {
  /** Order lines */
  lines: Array<CustomerOrderLineInput>;
  orderInformation: CustomerOrderInformationInput;
};

export type CreditLimitInput = {
  contractNo?: InputMaybe<Scalars['String']>;
  salesOrgCode?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
};

export type CustomerBlockInput = {
  contractNo?: InputMaybe<Scalars['String']>;
  saleOrganizationCode?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
};

export type CustomerCartCreateInput = {
  /** ID of the customer contract. */
  customerContractId: Scalars['ID'];
  /** ID of the customer. */
  customerId: Scalars['ID'];
  /** A list of cart items, each containing information about an item in the cart. */
  lines: Array<CustomerCartItemInput>;
  /** ID of the sold to. */
  soldToId: Scalars['ID'];
};

export type CustomerCartItemInput = {
  /** ID of the contract material id. */
  contractMaterialId?: InputMaybe<Scalars['ID']>;
  /** ID of the customer product. */
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  /** ID of the customer product variant. */
  variantId?: InputMaybe<Scalars['ID']>;
};

export type CustomerCartLineQuantityInput = {
  /** ID of the cart line. */
  id: Scalars['ID'];
  materialVariantId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
};

export type CustomerCartLinesUpdateQuantityInput = {
  /** A list of cart lines, each containing information about an item in the cart. */
  lines: Array<CustomerCartLineQuantityInput>;
};

export type CustomerCartUpdateInput = {
  /** A list of cart items, each containing information about an item in the cart. */
  lines: Array<CustomerCartItemInput>;
};

export enum CustomerCartsSortField {
  /** Sort customer carts by lines count. */
  LINES_COUNT = 'LINES_COUNT'
}

export type CustomerCartsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort customerCarts by the selected field. */
  field: CustomerCartsSortField;
};

export type CustomerCompanyFilterInput = {
  businessUnit?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type CustomerContractFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum CustomerContractsSortField {
  /** Sort contracts by code. */
  CODE = 'CODE'
}

export type CustomerContractsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort contracts by the selected field. */
  field: CustomerContractsSortField;
};

export type CustomerFilterInput = {
  dateJoined?: InputMaybe<DateRangeInput>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  numberOfOrders?: InputMaybe<IntRangeInput>;
  placedOrders?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type CustomerLmsReportDateInput = {
  gte?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type CustomerLmsReportInput = {
  deliveryDate?: InputMaybe<CustomerLmsReportDateInput>;
  materialNo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poNo?: InputMaybe<Scalars['String']>;
  saleOrganization?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CustomerMaterialCodeNameFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

/** Input type for customer material data. */
export type CustomerMaterialInput = {
  distributionChannelCode?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  salesOrganizationCode?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
  soldToMaterialCode?: InputMaybe<Scalars['String']>;
};

/** Input type for customer material item data. */
export type CustomerMaterialItemInput = {
  materialCode: Scalars['String'];
  soldToMaterialCode: Scalars['String'];
};

export type CustomerMaterialUploadInput = {
  distributionChannel: Scalars['String'];
  saleOrgCode: Scalars['String'];
  soldToCode: Scalars['String'];
};

export type CustomerOrderConfirmationFilterInput = {
  companyName?: InputMaybe<Array<Scalars['String']>>;
  distributionChannel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  materialGroup?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  orderCreateDate?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export enum CustomerOrderConfirmationSortField {
  SO_NO = 'SO_NO'
}

export type CustomerOrderConfirmationSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort orderConfirmation by the selected field. */
  field: CustomerOrderConfirmationSortField;
};

export type CustomerOrderFilterInput = {
  bu?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<DateRangeInput>;
  dpNo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  materialCodeName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  requestDeliveryDate?: InputMaybe<DateRangeInput>;
  saleGroup?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type CustomerOrderInformationInput = {
  contractId: Scalars['ID'];
};

export type CustomerOrderInformationUpdateInput = {
  billTo?: InputMaybe<Scalars['String']>;
  confirm?: InputMaybe<Scalars['Boolean']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderNo?: InputMaybe<Scalars['String']>;
  remarkForInvoice?: InputMaybe<Scalars['String']>;
  remarkForLogistic?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<Scalars['Date']>;
  shipTo?: InputMaybe<Scalars['String']>;
  unloadingPoint?: InputMaybe<Scalars['String']>;
};

export type CustomerOrderLineInput = {
  cartItemId: Scalars['ID'];
  contractProductId: Scalars['ID'];
  quantity: Scalars['Float'];
  variantId?: InputMaybe<Scalars['ID']>;
};

export type CustomerOrderLineUpdateInput = {
  /** Id of order line */
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
  requestDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type CustomerOrderLinesUpdateInput = {
  applyAll?: InputMaybe<Scalars['Boolean']>;
  lines?: InputMaybe<Array<CustomerOrderLineUpdateInput>>;
  requestDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export enum CustomerOrderSortField {
  SO_NO = 'SO_NO'
}

export type CustomerOrderSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort customerOrders by the selected field. */
  field: CustomerOrderSortField;
};

export type CustomerProductSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Specifies the field in which to sort products. */
  field: ScgpCustomerProductOrderField;
};

export type CustomerSalesGroupFilterInput = {
  company?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type DateRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['Date']>;
  /** End date. */
  lte?: InputMaybe<Scalars['Date']>;
};

export type DateTimeRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** End date. */
  lte?: InputMaybe<Scalars['DateTime']>;
};

export enum DeliveryBlock09Enum {
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK'
}

export type DeliveryDateInput = {
  gte?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type DeliveryTolerance = {
  over?: InputMaybe<Scalars['Int']>;
  under?: InputMaybe<Scalars['Int']>;
  unlimited?: InputMaybe<DeliveryUnlimited>;
};

export enum DeliveryUnlimited {
  X = 'X',
  Y = 'Y'
}

/** An enumeration. */
export enum DistanceUnitsEnum {
  CM = 'CM',
  FT = 'FT',
  INCH = 'INCH',
  KM = 'KM',
  M = 'M',
  YD = 'YD'
}

export enum DistributionChannelType {
  DOMESTIC = 'DOMESTIC',
  EXPORT = 'EXPORT'
}

export type DomesticCompanyFilterInput = {
  businessUnit?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type DomesticMaterialCodeNameFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type DomesticOrderConfirmationFilterInput = {
  bu?: InputMaybe<Scalars['String']>;
  distributionChannel?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Array<Scalars['String']>>;
  materialGroup?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  orderCreateDate?: InputMaybe<DateRangeInput>;
  poNo?: InputMaybe<Scalars['String']>;
  saleOrganization?: InputMaybe<Array<Scalars['String']>>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export enum DomesticOrderConfirmationSortField {
  SO_NO = 'SO_NO'
}

export type DomesticOrderConfirmationSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort orderConfirmation by the selected field. */
  field: DomesticOrderConfirmationSortField;
};

export type DomesticOrderFilterInput = {
  bu?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<DateRangeInput>;
  dpNo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<DateRangeInput>;
  materialCodeName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  orderType?: InputMaybe<Scalars['String']>;
  saleEmployee?: InputMaybe<Scalars['String']>;
  saleGroup?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  statusSap?: InputMaybe<Array<ScgDomesticOrderStatusSap>>;
};

export type DomesticOrderLineAddProductInput = {
  contractMaterialId: Scalars['ID'];
  materialVariantId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
};

export enum DomesticOrderLinesSortField {
  ITEM_NO = 'ITEM_NO'
}

export type DomesticOrderLinesSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort orderLines by the selected field. */
  field: DomesticOrderLinesSortField;
};

export enum DomesticOrderSortField {
  SO_NO = 'SO_NO'
}

export type DomesticOrderSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort domesticOrders by the selected field. */
  field: DomesticOrderSortField;
};

export type DomesticSaleEmployeeFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  salesEmployeee?: InputMaybe<Scalars['String']>;
};

export type DomesticSalesGroupFilterInput = {
  company?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type DomesticSoldToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export enum EOrderingProductionStatus {
  AFTER_PRODUCTION = 'AFTER_PRODUCTION',
  BEFORE_PRODUCTION = 'BEFORE_PRODUCTION',
  DURING_PRODUCTION = 'DURING_PRODUCTION'
}

export type EditExportOrderHeaderInput = {
  billTo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dlcExpiryDate?: InputMaybe<Scalars['Date']>;
  dlcLatestDeliveryDate?: InputMaybe<Scalars['Date']>;
  dlcNo?: InputMaybe<Scalars['String']>;
  endCustomer?: InputMaybe<Scalars['String']>;
  eta?: InputMaybe<Scalars['Date']>;
  etd?: InputMaybe<Scalars['Date']>;
  gwUom?: InputMaybe<Scalars['String']>;
  internalCommentToWarehouse?: InputMaybe<Scalars['String']>;
  noOfContainers?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['String']>;
  paymentInstruction?: InputMaybe<Scalars['String']>;
  placeOfDelivery?: InputMaybe<Scalars['String']>;
  /** PO Date */
  poDate?: InputMaybe<Scalars['Date']>;
  poNo?: InputMaybe<Scalars['String']>;
  portOfDischarge?: InputMaybe<Scalars['String']>;
  portOfLoading?: InputMaybe<Scalars['String']>;
  productionInformation?: InputMaybe<Scalars['String']>;
  refPiNo?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  unloadingPoint?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['String']>;
};

export type EditExportOrderInput = {
  orderHeader?: InputMaybe<EditExportOrderHeaderInput>;
  orderItems?: InputMaybe<Array<EditOrderItemInput>>;
  soNo?: InputMaybe<Scalars['String']>;
};

export type EditOrderItemInput = {
  conditionGroup1?: InputMaybe<Scalars['String']>;
  deliveryTolOver?: InputMaybe<Scalars['Float']>;
  deliveryTolUnder?: InputMaybe<Scalars['Float']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  inquiryMethod?: InputMaybe<InquiryMethodType>;
  itemCatEo?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['String']>;
  packingList?: InputMaybe<Scalars['String']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletSize?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  refPiStock?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  rollCoreDiameter?: InputMaybe<Scalars['String']>;
  rollDiameter?: InputMaybe<Scalars['String']>;
  rollPerPallet?: InputMaybe<Scalars['String']>;
  rollQuantity?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type EditRequireAttentionInput = {
  lines: Array<EditRequireAttentionItemsInput>;
};

export type EditRequireAttentionItemsInput = {
  id: Scalars['ID'];
  itemNo?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  requestDate?: InputMaybe<Scalars['Date']>;
};

export type ExportAtpctpConfirmInputType = {
  items: Array<InputMaybe<ExportAtpctpConfirmItemInputType>>;
};

export type ExportAtpctpConfirmItemInputType = {
  action?: InputMaybe<AtpctpActionType>;
  calculatedItemNo?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  listItems?: InputMaybe<Array<InputMaybe<ExportAtpctpItemBaseListItemInput>>>;
  materialVariantCode: Scalars['String'];
  materialVariantDescription?: InputMaybe<Scalars['String']>;
  orderNo?: InputMaybe<Scalars['String']>;
  originalItemNo: Scalars['String'];
  originalPlant?: InputMaybe<Scalars['String']>;
  originalQuantity: Scalars['Float'];
  originalRequestDate: Scalars['String'];
};

export type ExportAtpctpItemBaseListItemInput = {
  atpCtp?: InputMaybe<Scalars['String']>;
  atpCtpDetail?: InputMaybe<Scalars['String']>;
  blockCode?: InputMaybe<Scalars['String']>;
  confirmDate?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  onHandStock?: InputMaybe<Scalars['Boolean']>;
  orderType?: InputMaybe<Scalars['String']>;
  paperMachine?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  runCode?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type ExportAtpctpRequestOrderLineInput = {
  inquiryMethod?: InputMaybe<InquiryMethodType>;
  itemNo?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  orderNo?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['String']>;
};

export type ExportAddNewItemsInput = {
  deliveryTolOver?: InputMaybe<Scalars['Float']>;
  deliveryTolUnder?: InputMaybe<Scalars['Float']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  inquiryMethod?: InputMaybe<Scalars['String']>;
  itemCatEo?: InputMaybe<Scalars['String']>;
  /** Item no */
  itemNo: Scalars['String'];
  /** Material code */
  materialCode: Scalars['String'];
  packageQuantity?: InputMaybe<Scalars['String']>;
  packingList?: InputMaybe<Scalars['String']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletSize?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantityUnit?: InputMaybe<Scalars['String']>;
  refPiNo?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<ScgExportRejectReason>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  rollCoreDiameter?: InputMaybe<Scalars['String']>;
  rollDiameter?: InputMaybe<Scalars['String']>;
  rollPerPallet?: InputMaybe<Scalars['String']>;
  rollQuantity?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ExportAddNewOrderLineInput = {
  /** Fields to update order line */
  line: Array<InputMaybe<ExportAddNewItemsInput>>;
  /** Fields to update order header */
  orderHeader: ExportOrderHeaderFixedDataInput;
};

export type ExportCartCreateInput = {
  /** A list of export cart items, each containing information about an item in the cart. */
  lines: Array<ExportCartItemInput>;
  /** ID of the export pi. */
  piId: Scalars['ID'];
  /** ID of the sold to. */
  soldToId: Scalars['ID'];
};

export type ExportCartDraftUpdateInput = {
  /** list of export cart items, each containing information about an item in the cart. */
  lines: Array<ExportCartItemDraftInput>;
};

export type ExportCartItemDraftInput = {
  /** ID of the export cart. */
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type ExportCartItemInput = {
  /** ID of the pi product. */
  piProductId: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type ExportCartItemSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort exportCartItem by the selected field. */
  field: ScgExportCartItemOrderField;
};

export type ExportCartSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort exportCart by the selected field. */
  field: ScgExportCartOrderField;
};

export type ExportCartUpdateInput = {
  /** A list of export cart items, each containing information about an item in the cart. */
  lines: Array<ExportCartItemInput>;
};

export type ExportCompaniesFilterInput = {
  businessUnit?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

export type ExportOrderCreateInput = {
  lines: Array<ExportOrderLineCreateInput>;
  orderHeader: ExportOrderHeaderCreateInput;
};

export type ExportOrderFilterInput = {
  bu?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<DateRangeInput>;
  eoNo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  lastUpdate?: InputMaybe<DateRangeInput>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  piNo?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ScgpExportOrderStatus>>;
  statusSap?: InputMaybe<Array<ScgpExportOrderStatusSap>>;
};

export type ExportOrderHeaderCreateInput = {
  piId: Scalars['ID'];
};

export type ExportOrderHeaderFixedDataInput = {
  /** Bill to */
  billTo: Scalars['String'];
  /** EO No */
  eoNo: Scalars['String'];
  /** PI No */
  piNo: Scalars['String'];
  /** Ship to */
  shipTo: Scalars['String'];
  /** Sold to */
  soldTo: Scalars['String'];
};

export type ExportOrderHeaderUpdateInput = {
  /** Bill To */
  billTo?: InputMaybe<Scalars['String']>;
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** D-L/C : Expiry Date */
  dlcExpiryDate?: InputMaybe<Scalars['Date']>;
  /** D-L/C : Latest Delivery Date */
  dlcLatestDeliveryDate?: InputMaybe<Scalars['Date']>;
  /** D-L/C No. */
  dlcNo?: InputMaybe<Scalars['String']>;
  /** End Customer */
  endCustomer?: InputMaybe<Scalars['String']>;
  /** ETA */
  eta?: InputMaybe<Scalars['String']>;
  /** ETD */
  etd?: InputMaybe<Scalars['String']>;
  /** G.W.UOM */
  gwUom?: InputMaybe<Scalars['String']>;
  /** Incoterms 2 */
  incoterms2?: InputMaybe<Scalars['String']>;
  /** Internal Comments to Warehouse */
  internalCommentToWarehouse?: InputMaybe<Scalars['String']>;
  /** No. of Containers */
  noOfContainers?: InputMaybe<Scalars['String']>;
  /** Payer */
  payer?: InputMaybe<Scalars['String']>;
  /** Payment Instruction */
  paymentInstruction?: InputMaybe<Scalars['String']>;
  /** Place of Delivery */
  placeOfDelivery?: InputMaybe<Scalars['String']>;
  /** PO Date */
  poDate?: InputMaybe<Scalars['Date']>;
  /** PO Number */
  poNo?: InputMaybe<Scalars['String']>;
  /** Port of Discharge */
  portOfDischarge?: InputMaybe<Scalars['String']>;
  /** Port of Loading */
  portOfLoading?: InputMaybe<Scalars['String']>;
  /** Production information */
  productionInformation?: InputMaybe<Scalars['String']>;
  /** Ref. Pi No. */
  refPiNo?: InputMaybe<Scalars['String']>;
  /** Remark */
  remark?: InputMaybe<Scalars['String']>;
  /** Request Date */
  requestDate?: InputMaybe<Scalars['Date']>;
  /** Ship To */
  shipTo?: InputMaybe<Scalars['String']>;
  /** Shipping Mark */
  shippingMark?: InputMaybe<Scalars['String']>;
  /** Unloading Point */
  unloadingPoint?: InputMaybe<Scalars['String']>;
  /** UOM */
  uom?: InputMaybe<Scalars['String']>;
  /** Usage */
  usage?: InputMaybe<Scalars['String']>;
};

export type ExportOrderLineAddProductInput = {
  piProduct: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type ExportOrderLineCreateInput = {
  cartItemId?: InputMaybe<Scalars['ID']>;
  piProduct: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type ExportOrderLineDraftInput = {
  /** ID of an order line to update. */
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
  requestDate?: InputMaybe<Scalars['Date']>;
};

export type ExportOrderLineInput = {
  deliveryTolOver?: InputMaybe<Scalars['Float']>;
  deliveryTolUnder?: InputMaybe<Scalars['Float']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  itemCatEo?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['String']>;
  packingList?: InputMaybe<Scalars['String']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletSize?: InputMaybe<Scalars['String']>;
  piProduct?: InputMaybe<Scalars['ID']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantityUnit?: InputMaybe<Scalars['String']>;
  refPiNo?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<ScgExportRejectReason>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  rollCoreDiameter?: InputMaybe<Scalars['String']>;
  rollDiameter?: InputMaybe<Scalars['String']>;
  rollPerPallet?: InputMaybe<Scalars['String']>;
  rollQuantity?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ExportOrderLineUpdateAllInput = {
  requestDate: Scalars['Date'];
};

export type ExportOrderLineUpdateInput = {
  deliveryTolOver?: InputMaybe<Scalars['Float']>;
  deliveryTolUnder?: InputMaybe<Scalars['Float']>;
  deliveryTolUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** ID of an order line to update. */
  id: Scalars['ID'];
  itemCatEo?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['String']>;
  packingList?: InputMaybe<Scalars['String']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletSize?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantityUnit?: InputMaybe<Scalars['String']>;
  refPiNo?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<ScgExportRejectReason>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  rollCoreDiameter?: InputMaybe<Scalars['String']>;
  rollDiameter?: InputMaybe<Scalars['String']>;
  rollPerPallet?: InputMaybe<Scalars['String']>;
  rollQuantity?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export enum ExportOrderLinesSortField {
  /** Sort order lines by material code. */
  MATERIAL_CODE = 'MATERIAL_CODE'
}

export type ExportOrderLinesSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort order_lines by the selected field. */
  field: ExportOrderLinesSortField;
};

export type ExportOrderReasonForRejectInput = {
  reasonForReject?: InputMaybe<ChangeExportRejectReason>;
};

export enum ExportOrderSortField {
  PI_NO = 'PI_NO'
}

export type ExportOrderSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort exportOrders by the selected field. */
  field: ExportOrderSortField;
};

export type ExportOrderUpdateDraftInput = {
  /** Fields to update draft order line */
  lines?: InputMaybe<Array<InputMaybe<ExportOrderLineDraftInput>>>;
};

export type ExportOrderUpdateInput = {
  agency?: InputMaybe<AgencyInput>;
  /** Fields to update order line */
  lines?: InputMaybe<Array<InputMaybe<ExportOrderLineInput>>>;
  orderHeader?: InputMaybe<ExportOrderHeaderUpdateInput>;
  status: ScgpExportOrderStatus;
};

export type ExportPiFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export enum ExportPiProductsSortField {
  ITEM_NO = 'ITEM_NO',
  PRICE_PER_UNIT = 'PRICE_PER_UNIT',
  REMAINING_QUANTITY = 'REMAINING_QUANTITY',
  TOTAL_QUANTITY = 'TOTAL_QUANTITY'
}

export type ExportPiProductsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort exportPiProducts by the selected field. */
  field: ExportPiProductsSortField;
};

export enum ExportPIsSortField {
  /** Sort customer carts by code. */
  CODE = 'CODE'
}

export type ExportPIsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort exportPIs by the selected field. */
  field: ExportPIsSortField;
};

export type ExportShipToFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  shipTo?: InputMaybe<Scalars['String']>;
};

export type ExportSoldToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

export type GpsReportCsCustomerInput = {
  dp: Scalars['String'];
  shippingPoint: Scalars['String'];
  soldTo: Scalars['String'];
};

export type GetOnHandReportInput = {
  code?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum GiftCardSettingsExpiryTypeEnum {
  EXPIRY_PERIOD = 'EXPIRY_PERIOD',
  NEVER_EXPIRE = 'NEVER_EXPIRE'
}

export type HeaderInput = {
  ETA?: InputMaybe<Scalars['String']>;
  ETD?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  billTo?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  contactPerson?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dlcExpiryDate?: InputMaybe<Scalars['String']>;
  dlcLatestDeliveryDate?: InputMaybe<Scalars['String']>;
  dlcNo?: InputMaybe<Scalars['String']>;
  docCurrency?: InputMaybe<Scalars['String']>;
  endCustomer?: InputMaybe<Scalars['String']>;
  gwUom?: InputMaybe<Scalars['String']>;
  incoterms?: InputMaybe<Scalars['String']>;
  internalCommentToWarehouse?: InputMaybe<Scalars['String']>;
  noOfContainers?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['String']>;
  paymentInstruction?: InputMaybe<Scalars['String']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  placeOfDelivery?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  portOfDischarge?: InputMaybe<Scalars['String']>;
  productInfomation?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  salesEmail?: InputMaybe<Scalars['String']>;
  salesEmployee?: InputMaybe<Scalars['String']>;
  salesGroup?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingMark?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  unloadingPoint?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['String']>;
};

export enum IPlanInquiryMethodCode {
  ASAP = 'ASAP',
  JIT = 'JIT',
  JITCP = 'JITCP',
  JITP = 'JITP'
}

export enum IPlanOrderItemStatus {
  CANCEL = 'CANCEL',
  COMPLETED_PRODUCTION = 'COMPLETED_PRODUCTION',
  COMPLETE_DELIVERY = 'COMPLETE_DELIVERY',
  FAILED = 'FAILED',
  FULL_COMMITTED_ORDER = 'FULL_COMMITTED_ORDER',
  IPLAN_ORDER_LINES_STATUS_TH = 'IPLAN_ORDER_LINES_STATUS_TH',
  IPLAN_ORDER_LINE_RANK = 'IPLAN_ORDER_LINE_RANK',
  ITEM_CREATED = 'ITEM_CREATED',
  MAPPING_ORDER_STATUS = 'MAPPING_ORDER_STATUS',
  PARTIAL_DELIVERY = 'PARTIAL_DELIVERY',
  PLANNING_ALLOCATED_NON_CONFIRM = 'PLANNING_ALLOCATED_NON_CONFIRM',
  PLANNING_ALLOCATED_X_TRIM = 'PLANNING_ALLOCATED_X_TRIM',
  PLANNING_CLOSE_LOOP = 'PLANNING_CLOSE_LOOP',
  PLANNING_CONFIRM = 'PLANNING_CONFIRM',
  PLANNING_OUTSOURCING = 'PLANNING_OUTSOURCING',
  PLANNING_UNALLOCATED = 'PLANNING_UNALLOCATED',
  PRODUCING = 'PRODUCING'
}

export enum IPlanOrderStatus {
  CANCEL = 'CANCEL',
  COMPLETED_DELIVERY = 'COMPLETED_DELIVERY',
  COMPLETED_PRODUCTION = 'COMPLETED_PRODUCTION',
  COMPLETE_ORDER = 'COMPLETE_ORDER',
  FULL_COMMITTED_ORDER = 'FULL_COMMITTED_ORDER',
  IPLAN_ORDER_RANK = 'IPLAN_ORDER_RANK',
  IPLAN_ORDER_STATUS_TH = 'IPLAN_ORDER_STATUS_TH',
  PARTIAL_COMMITTED_ORDER = 'PARTIAL_COMMITTED_ORDER',
  PARTIAL_DELIVERY = 'PARTIAL_DELIVERY',
  READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
  RECEIVED_ORDER = 'RECEIVED_ORDER'
}

export type InitialInput = {
  changeType?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  createAndChangeType?: InputMaybe<Scalars['String']>;
  distributionChannel?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  eoNo?: InputMaybe<Scalars['String']>;
  lotNo?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<Scalars['String']>;
  salesOffice?: InputMaybe<Scalars['String']>;
  salesOrg?: InputMaybe<Scalars['String']>;
};

export type InputSalesOrder = {
  direction: SalesOrderSortingInput;
  soldToId: Scalars['ID'];
};

export enum InquiryMethodType {
  ASAP = 'ASAP',
  CUSTOMER = 'CUSTOMER',
  DOMESTIC = 'DOMESTIC',
  EXPORT = 'EXPORT'
}

export enum InquiryOrderConfirmationStatus {
  ALL = 'ALL',
  CONFIRM = 'CONFIRM',
  NON_CONFIRM = 'NON_CONFIRM',
  REJECT = 'REJECT'
}

export type IntRangeInput = {
  /** Value greater than or equal to. */
  gte?: InputMaybe<Scalars['Int']>;
  /** Value less than or equal to. */
  lte?: InputMaybe<Scalars['Int']>;
};

export type IplanRequireAttentionRequestParamsInput = {
  fixSourceAssignment?: InputMaybe<Scalars['String']>;
  inquiryMethodCode?: InputMaybe<Scalars['String']>;
  reAtpRequired?: InputMaybe<Scalars['Boolean']>;
  requestType?: InputMaybe<Scalars['String']>;
  singleSource?: InputMaybe<Scalars['Boolean']>;
  splitOrderItem?: InputMaybe<Scalars['String']>;
  transportationMethod?: InputMaybe<Scalars['String']>;
  typeOfDelivery?: InputMaybe<Scalars['String']>;
  useConsignmentInventory?: InputMaybe<Scalars['Boolean']>;
  useInventory?: InputMaybe<Scalars['Boolean']>;
  useProduction?: InputMaybe<Scalars['Boolean']>;
  useProjectedInventory?: InputMaybe<Scalars['Boolean']>;
};

export type ItemInput = {
  commission?: InputMaybe<Scalars['String']>;
  commissionCurrency?: InputMaybe<Scalars['String']>;
  commissionPercent?: InputMaybe<Scalars['String']>;
  conditionGroup1?: InputMaybe<Scalars['String']>;
  eoItemNo?: InputMaybe<Scalars['String']>;
  itemCatEo?: InputMaybe<Scalars['String']>;
  itemCatPi?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  noOfPackage?: InputMaybe<Scalars['String']>;
  noOfRolls?: InputMaybe<Scalars['Float']>;
  orderQuantity?: InputMaybe<Scalars['Float']>;
  packingListText?: InputMaybe<Scalars['String']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletSize?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  reamRollPerPallet?: InputMaybe<Scalars['Float']>;
  refPiStock?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  rollCoreDiameterInch?: InputMaybe<Scalars['String']>;
  rollDiameterInch?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type LmsReportCsAdminInput = {
  deliveryDate?: InputMaybe<DeliveryDateInput>;
  materialGradeGram?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type LmsReportCsCustomerInput = {
  bu?: InputMaybe<Scalars['String']>;
  deliveryDate: SapPendingOrderReportDateInput;
  matNo?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  saleOrgCode: Array<InputMaybe<Scalars['String']>>;
  shippingPoint?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldToCode: Scalars['String'];
};

/** An enumeration. */
export enum LanguageCodeEnum {
  AF = 'AF',
  AF_NA = 'AF_NA',
  AF_ZA = 'AF_ZA',
  AGQ = 'AGQ',
  AGQ_CM = 'AGQ_CM',
  AK = 'AK',
  AK_GH = 'AK_GH',
  AM = 'AM',
  AM_ET = 'AM_ET',
  AR = 'AR',
  AR_AE = 'AR_AE',
  AR_BH = 'AR_BH',
  AR_DJ = 'AR_DJ',
  AR_DZ = 'AR_DZ',
  AR_EG = 'AR_EG',
  AR_EH = 'AR_EH',
  AR_ER = 'AR_ER',
  AR_IL = 'AR_IL',
  AR_IQ = 'AR_IQ',
  AR_JO = 'AR_JO',
  AR_KM = 'AR_KM',
  AR_KW = 'AR_KW',
  AR_LB = 'AR_LB',
  AR_LY = 'AR_LY',
  AR_MA = 'AR_MA',
  AR_MR = 'AR_MR',
  AR_OM = 'AR_OM',
  AR_PS = 'AR_PS',
  AR_QA = 'AR_QA',
  AR_SA = 'AR_SA',
  AR_SD = 'AR_SD',
  AR_SO = 'AR_SO',
  AR_SS = 'AR_SS',
  AR_SY = 'AR_SY',
  AR_TD = 'AR_TD',
  AR_TN = 'AR_TN',
  AR_YE = 'AR_YE',
  AS = 'AS',
  ASA = 'ASA',
  ASA_TZ = 'ASA_TZ',
  AST = 'AST',
  AST_ES = 'AST_ES',
  AS_IN = 'AS_IN',
  AZ = 'AZ',
  AZ_CYRL = 'AZ_CYRL',
  AZ_CYRL_AZ = 'AZ_CYRL_AZ',
  AZ_LATN = 'AZ_LATN',
  AZ_LATN_AZ = 'AZ_LATN_AZ',
  BAS = 'BAS',
  BAS_CM = 'BAS_CM',
  BE = 'BE',
  BEM = 'BEM',
  BEM_ZM = 'BEM_ZM',
  BEZ = 'BEZ',
  BEZ_TZ = 'BEZ_TZ',
  BE_BY = 'BE_BY',
  BG = 'BG',
  BG_BG = 'BG_BG',
  BM = 'BM',
  BM_ML = 'BM_ML',
  BN = 'BN',
  BN_BD = 'BN_BD',
  BN_IN = 'BN_IN',
  BO = 'BO',
  BO_CN = 'BO_CN',
  BO_IN = 'BO_IN',
  BR = 'BR',
  BRX = 'BRX',
  BRX_IN = 'BRX_IN',
  BR_FR = 'BR_FR',
  BS = 'BS',
  BS_CYRL = 'BS_CYRL',
  BS_CYRL_BA = 'BS_CYRL_BA',
  BS_LATN = 'BS_LATN',
  BS_LATN_BA = 'BS_LATN_BA',
  CA = 'CA',
  CA_AD = 'CA_AD',
  CA_ES = 'CA_ES',
  CA_ES_VALENCIA = 'CA_ES_VALENCIA',
  CA_FR = 'CA_FR',
  CA_IT = 'CA_IT',
  CCP = 'CCP',
  CCP_BD = 'CCP_BD',
  CCP_IN = 'CCP_IN',
  CE = 'CE',
  CEB = 'CEB',
  CEB_PH = 'CEB_PH',
  CE_RU = 'CE_RU',
  CGG = 'CGG',
  CGG_UG = 'CGG_UG',
  CHR = 'CHR',
  CHR_US = 'CHR_US',
  CKB = 'CKB',
  CKB_IQ = 'CKB_IQ',
  CKB_IR = 'CKB_IR',
  CS = 'CS',
  CS_CZ = 'CS_CZ',
  CU = 'CU',
  CU_RU = 'CU_RU',
  CY = 'CY',
  CY_GB = 'CY_GB',
  DA = 'DA',
  DAV = 'DAV',
  DAV_KE = 'DAV_KE',
  DA_DK = 'DA_DK',
  DA_GL = 'DA_GL',
  DE = 'DE',
  DE_AT = 'DE_AT',
  DE_BE = 'DE_BE',
  DE_CH = 'DE_CH',
  DE_DE = 'DE_DE',
  DE_IT = 'DE_IT',
  DE_LI = 'DE_LI',
  DE_LU = 'DE_LU',
  DJE = 'DJE',
  DJE_NE = 'DJE_NE',
  DSB = 'DSB',
  DSB_DE = 'DSB_DE',
  DUA = 'DUA',
  DUA_CM = 'DUA_CM',
  DYO = 'DYO',
  DYO_SN = 'DYO_SN',
  DZ = 'DZ',
  DZ_BT = 'DZ_BT',
  EBU = 'EBU',
  EBU_KE = 'EBU_KE',
  EE = 'EE',
  EE_GH = 'EE_GH',
  EE_TG = 'EE_TG',
  EL = 'EL',
  EL_CY = 'EL_CY',
  EL_GR = 'EL_GR',
  EN = 'EN',
  EN_AE = 'EN_AE',
  EN_AG = 'EN_AG',
  EN_AI = 'EN_AI',
  EN_AS = 'EN_AS',
  EN_AT = 'EN_AT',
  EN_AU = 'EN_AU',
  EN_BB = 'EN_BB',
  EN_BE = 'EN_BE',
  EN_BI = 'EN_BI',
  EN_BM = 'EN_BM',
  EN_BS = 'EN_BS',
  EN_BW = 'EN_BW',
  EN_BZ = 'EN_BZ',
  EN_CA = 'EN_CA',
  EN_CC = 'EN_CC',
  EN_CH = 'EN_CH',
  EN_CK = 'EN_CK',
  EN_CM = 'EN_CM',
  EN_CX = 'EN_CX',
  EN_CY = 'EN_CY',
  EN_DE = 'EN_DE',
  EN_DG = 'EN_DG',
  EN_DK = 'EN_DK',
  EN_DM = 'EN_DM',
  EN_ER = 'EN_ER',
  EN_FI = 'EN_FI',
  EN_FJ = 'EN_FJ',
  EN_FK = 'EN_FK',
  EN_FM = 'EN_FM',
  EN_GB = 'EN_GB',
  EN_GD = 'EN_GD',
  EN_GG = 'EN_GG',
  EN_GH = 'EN_GH',
  EN_GI = 'EN_GI',
  EN_GM = 'EN_GM',
  EN_GU = 'EN_GU',
  EN_GY = 'EN_GY',
  EN_HK = 'EN_HK',
  EN_IE = 'EN_IE',
  EN_IL = 'EN_IL',
  EN_IM = 'EN_IM',
  EN_IN = 'EN_IN',
  EN_IO = 'EN_IO',
  EN_JE = 'EN_JE',
  EN_JM = 'EN_JM',
  EN_KE = 'EN_KE',
  EN_KI = 'EN_KI',
  EN_KN = 'EN_KN',
  EN_KY = 'EN_KY',
  EN_LC = 'EN_LC',
  EN_LR = 'EN_LR',
  EN_LS = 'EN_LS',
  EN_MG = 'EN_MG',
  EN_MH = 'EN_MH',
  EN_MO = 'EN_MO',
  EN_MP = 'EN_MP',
  EN_MS = 'EN_MS',
  EN_MT = 'EN_MT',
  EN_MU = 'EN_MU',
  EN_MW = 'EN_MW',
  EN_MY = 'EN_MY',
  EN_NA = 'EN_NA',
  EN_NF = 'EN_NF',
  EN_NG = 'EN_NG',
  EN_NL = 'EN_NL',
  EN_NR = 'EN_NR',
  EN_NU = 'EN_NU',
  EN_NZ = 'EN_NZ',
  EN_PG = 'EN_PG',
  EN_PH = 'EN_PH',
  EN_PK = 'EN_PK',
  EN_PN = 'EN_PN',
  EN_PR = 'EN_PR',
  EN_PW = 'EN_PW',
  EN_RW = 'EN_RW',
  EN_SB = 'EN_SB',
  EN_SC = 'EN_SC',
  EN_SD = 'EN_SD',
  EN_SE = 'EN_SE',
  EN_SG = 'EN_SG',
  EN_SH = 'EN_SH',
  EN_SI = 'EN_SI',
  EN_SL = 'EN_SL',
  EN_SS = 'EN_SS',
  EN_SX = 'EN_SX',
  EN_SZ = 'EN_SZ',
  EN_TC = 'EN_TC',
  EN_TK = 'EN_TK',
  EN_TO = 'EN_TO',
  EN_TT = 'EN_TT',
  EN_TV = 'EN_TV',
  EN_TZ = 'EN_TZ',
  EN_UG = 'EN_UG',
  EN_UM = 'EN_UM',
  EN_US = 'EN_US',
  EN_VC = 'EN_VC',
  EN_VG = 'EN_VG',
  EN_VI = 'EN_VI',
  EN_VU = 'EN_VU',
  EN_WS = 'EN_WS',
  EN_ZA = 'EN_ZA',
  EN_ZM = 'EN_ZM',
  EN_ZW = 'EN_ZW',
  EO = 'EO',
  ES = 'ES',
  ES_AR = 'ES_AR',
  ES_BO = 'ES_BO',
  ES_BR = 'ES_BR',
  ES_BZ = 'ES_BZ',
  ES_CL = 'ES_CL',
  ES_CO = 'ES_CO',
  ES_CR = 'ES_CR',
  ES_CU = 'ES_CU',
  ES_DO = 'ES_DO',
  ES_EA = 'ES_EA',
  ES_EC = 'ES_EC',
  ES_ES = 'ES_ES',
  ES_GQ = 'ES_GQ',
  ES_GT = 'ES_GT',
  ES_HN = 'ES_HN',
  ES_IC = 'ES_IC',
  ES_MX = 'ES_MX',
  ES_NI = 'ES_NI',
  ES_PA = 'ES_PA',
  ES_PE = 'ES_PE',
  ES_PH = 'ES_PH',
  ES_PR = 'ES_PR',
  ES_PY = 'ES_PY',
  ES_SV = 'ES_SV',
  ES_US = 'ES_US',
  ES_UY = 'ES_UY',
  ES_VE = 'ES_VE',
  ET = 'ET',
  ET_EE = 'ET_EE',
  EU = 'EU',
  EU_ES = 'EU_ES',
  EWO = 'EWO',
  EWO_CM = 'EWO_CM',
  FA = 'FA',
  FA_AF = 'FA_AF',
  FA_IR = 'FA_IR',
  FF = 'FF',
  FF_ADLM = 'FF_ADLM',
  FF_ADLM_BF = 'FF_ADLM_BF',
  FF_ADLM_CM = 'FF_ADLM_CM',
  FF_ADLM_GH = 'FF_ADLM_GH',
  FF_ADLM_GM = 'FF_ADLM_GM',
  FF_ADLM_GN = 'FF_ADLM_GN',
  FF_ADLM_GW = 'FF_ADLM_GW',
  FF_ADLM_LR = 'FF_ADLM_LR',
  FF_ADLM_MR = 'FF_ADLM_MR',
  FF_ADLM_NE = 'FF_ADLM_NE',
  FF_ADLM_NG = 'FF_ADLM_NG',
  FF_ADLM_SL = 'FF_ADLM_SL',
  FF_ADLM_SN = 'FF_ADLM_SN',
  FF_LATN = 'FF_LATN',
  FF_LATN_BF = 'FF_LATN_BF',
  FF_LATN_CM = 'FF_LATN_CM',
  FF_LATN_GH = 'FF_LATN_GH',
  FF_LATN_GM = 'FF_LATN_GM',
  FF_LATN_GN = 'FF_LATN_GN',
  FF_LATN_GW = 'FF_LATN_GW',
  FF_LATN_LR = 'FF_LATN_LR',
  FF_LATN_MR = 'FF_LATN_MR',
  FF_LATN_NE = 'FF_LATN_NE',
  FF_LATN_NG = 'FF_LATN_NG',
  FF_LATN_SL = 'FF_LATN_SL',
  FF_LATN_SN = 'FF_LATN_SN',
  FI = 'FI',
  FIL = 'FIL',
  FIL_PH = 'FIL_PH',
  FI_FI = 'FI_FI',
  FO = 'FO',
  FO_DK = 'FO_DK',
  FO_FO = 'FO_FO',
  FR = 'FR',
  FR_BE = 'FR_BE',
  FR_BF = 'FR_BF',
  FR_BI = 'FR_BI',
  FR_BJ = 'FR_BJ',
  FR_BL = 'FR_BL',
  FR_CA = 'FR_CA',
  FR_CD = 'FR_CD',
  FR_CF = 'FR_CF',
  FR_CG = 'FR_CG',
  FR_CH = 'FR_CH',
  FR_CI = 'FR_CI',
  FR_CM = 'FR_CM',
  FR_DJ = 'FR_DJ',
  FR_DZ = 'FR_DZ',
  FR_FR = 'FR_FR',
  FR_GA = 'FR_GA',
  FR_GF = 'FR_GF',
  FR_GN = 'FR_GN',
  FR_GP = 'FR_GP',
  FR_GQ = 'FR_GQ',
  FR_HT = 'FR_HT',
  FR_KM = 'FR_KM',
  FR_LU = 'FR_LU',
  FR_MA = 'FR_MA',
  FR_MC = 'FR_MC',
  FR_MF = 'FR_MF',
  FR_MG = 'FR_MG',
  FR_ML = 'FR_ML',
  FR_MQ = 'FR_MQ',
  FR_MR = 'FR_MR',
  FR_MU = 'FR_MU',
  FR_NC = 'FR_NC',
  FR_NE = 'FR_NE',
  FR_PF = 'FR_PF',
  FR_PM = 'FR_PM',
  FR_RE = 'FR_RE',
  FR_RW = 'FR_RW',
  FR_SC = 'FR_SC',
  FR_SN = 'FR_SN',
  FR_SY = 'FR_SY',
  FR_TD = 'FR_TD',
  FR_TG = 'FR_TG',
  FR_TN = 'FR_TN',
  FR_VU = 'FR_VU',
  FR_WF = 'FR_WF',
  FR_YT = 'FR_YT',
  FUR = 'FUR',
  FUR_IT = 'FUR_IT',
  FY = 'FY',
  FY_NL = 'FY_NL',
  GA = 'GA',
  GA_GB = 'GA_GB',
  GA_IE = 'GA_IE',
  GD = 'GD',
  GD_GB = 'GD_GB',
  GL = 'GL',
  GL_ES = 'GL_ES',
  GSW = 'GSW',
  GSW_CH = 'GSW_CH',
  GSW_FR = 'GSW_FR',
  GSW_LI = 'GSW_LI',
  GU = 'GU',
  GUZ = 'GUZ',
  GUZ_KE = 'GUZ_KE',
  GU_IN = 'GU_IN',
  GV = 'GV',
  GV_IM = 'GV_IM',
  HA = 'HA',
  HAW = 'HAW',
  HAW_US = 'HAW_US',
  HA_GH = 'HA_GH',
  HA_NE = 'HA_NE',
  HA_NG = 'HA_NG',
  HE = 'HE',
  HE_IL = 'HE_IL',
  HI = 'HI',
  HI_IN = 'HI_IN',
  HR = 'HR',
  HR_BA = 'HR_BA',
  HR_HR = 'HR_HR',
  HSB = 'HSB',
  HSB_DE = 'HSB_DE',
  HU = 'HU',
  HU_HU = 'HU_HU',
  HY = 'HY',
  HY_AM = 'HY_AM',
  IA = 'IA',
  ID = 'ID',
  ID_ID = 'ID_ID',
  IG = 'IG',
  IG_NG = 'IG_NG',
  II = 'II',
  II_CN = 'II_CN',
  IS = 'IS',
  IS_IS = 'IS_IS',
  IT = 'IT',
  IT_CH = 'IT_CH',
  IT_IT = 'IT_IT',
  IT_SM = 'IT_SM',
  IT_VA = 'IT_VA',
  JA = 'JA',
  JA_JP = 'JA_JP',
  JGO = 'JGO',
  JGO_CM = 'JGO_CM',
  JMC = 'JMC',
  JMC_TZ = 'JMC_TZ',
  JV = 'JV',
  JV_ID = 'JV_ID',
  KA = 'KA',
  KAB = 'KAB',
  KAB_DZ = 'KAB_DZ',
  KAM = 'KAM',
  KAM_KE = 'KAM_KE',
  KA_GE = 'KA_GE',
  KDE = 'KDE',
  KDE_TZ = 'KDE_TZ',
  KEA = 'KEA',
  KEA_CV = 'KEA_CV',
  KHQ = 'KHQ',
  KHQ_ML = 'KHQ_ML',
  KI = 'KI',
  KI_KE = 'KI_KE',
  KK = 'KK',
  KKJ = 'KKJ',
  KKJ_CM = 'KKJ_CM',
  KK_KZ = 'KK_KZ',
  KL = 'KL',
  KLN = 'KLN',
  KLN_KE = 'KLN_KE',
  KL_GL = 'KL_GL',
  KM = 'KM',
  KM_KH = 'KM_KH',
  KN = 'KN',
  KN_IN = 'KN_IN',
  KO = 'KO',
  KOK = 'KOK',
  KOK_IN = 'KOK_IN',
  KO_KP = 'KO_KP',
  KO_KR = 'KO_KR',
  KS = 'KS',
  KSB = 'KSB',
  KSB_TZ = 'KSB_TZ',
  KSF = 'KSF',
  KSF_CM = 'KSF_CM',
  KSH = 'KSH',
  KSH_DE = 'KSH_DE',
  KS_ARAB = 'KS_ARAB',
  KS_ARAB_IN = 'KS_ARAB_IN',
  KU = 'KU',
  KU_TR = 'KU_TR',
  KW = 'KW',
  KW_GB = 'KW_GB',
  KY = 'KY',
  KY_KG = 'KY_KG',
  LAG = 'LAG',
  LAG_TZ = 'LAG_TZ',
  LB = 'LB',
  LB_LU = 'LB_LU',
  LG = 'LG',
  LG_UG = 'LG_UG',
  LKT = 'LKT',
  LKT_US = 'LKT_US',
  LN = 'LN',
  LN_AO = 'LN_AO',
  LN_CD = 'LN_CD',
  LN_CF = 'LN_CF',
  LN_CG = 'LN_CG',
  LO = 'LO',
  LO_LA = 'LO_LA',
  LRC = 'LRC',
  LRC_IQ = 'LRC_IQ',
  LRC_IR = 'LRC_IR',
  LT = 'LT',
  LT_LT = 'LT_LT',
  LU = 'LU',
  LUO = 'LUO',
  LUO_KE = 'LUO_KE',
  LUY = 'LUY',
  LUY_KE = 'LUY_KE',
  LU_CD = 'LU_CD',
  LV = 'LV',
  LV_LV = 'LV_LV',
  MAI = 'MAI',
  MAI_IN = 'MAI_IN',
  MAS = 'MAS',
  MAS_KE = 'MAS_KE',
  MAS_TZ = 'MAS_TZ',
  MER = 'MER',
  MER_KE = 'MER_KE',
  MFE = 'MFE',
  MFE_MU = 'MFE_MU',
  MG = 'MG',
  MGH = 'MGH',
  MGH_MZ = 'MGH_MZ',
  MGO = 'MGO',
  MGO_CM = 'MGO_CM',
  MG_MG = 'MG_MG',
  MI = 'MI',
  MI_NZ = 'MI_NZ',
  MK = 'MK',
  MK_MK = 'MK_MK',
  ML = 'ML',
  ML_IN = 'ML_IN',
  MN = 'MN',
  MNI = 'MNI',
  MNI_BENG = 'MNI_BENG',
  MNI_BENG_IN = 'MNI_BENG_IN',
  MN_MN = 'MN_MN',
  MR = 'MR',
  MR_IN = 'MR_IN',
  MS = 'MS',
  MS_BN = 'MS_BN',
  MS_ID = 'MS_ID',
  MS_MY = 'MS_MY',
  MS_SG = 'MS_SG',
  MT = 'MT',
  MT_MT = 'MT_MT',
  MUA = 'MUA',
  MUA_CM = 'MUA_CM',
  MY = 'MY',
  MY_MM = 'MY_MM',
  MZN = 'MZN',
  MZN_IR = 'MZN_IR',
  NAQ = 'NAQ',
  NAQ_NA = 'NAQ_NA',
  NB = 'NB',
  NB_NO = 'NB_NO',
  NB_SJ = 'NB_SJ',
  ND = 'ND',
  NDS = 'NDS',
  NDS_DE = 'NDS_DE',
  NDS_NL = 'NDS_NL',
  ND_ZW = 'ND_ZW',
  NE = 'NE',
  NE_IN = 'NE_IN',
  NE_NP = 'NE_NP',
  NL = 'NL',
  NL_AW = 'NL_AW',
  NL_BE = 'NL_BE',
  NL_BQ = 'NL_BQ',
  NL_CW = 'NL_CW',
  NL_NL = 'NL_NL',
  NL_SR = 'NL_SR',
  NL_SX = 'NL_SX',
  NMG = 'NMG',
  NMG_CM = 'NMG_CM',
  NN = 'NN',
  NNH = 'NNH',
  NNH_CM = 'NNH_CM',
  NN_NO = 'NN_NO',
  NUS = 'NUS',
  NUS_SS = 'NUS_SS',
  NYN = 'NYN',
  NYN_UG = 'NYN_UG',
  OM = 'OM',
  OM_ET = 'OM_ET',
  OM_KE = 'OM_KE',
  OR = 'OR',
  OR_IN = 'OR_IN',
  OS = 'OS',
  OS_GE = 'OS_GE',
  OS_RU = 'OS_RU',
  PA = 'PA',
  PA_ARAB = 'PA_ARAB',
  PA_ARAB_PK = 'PA_ARAB_PK',
  PA_GURU = 'PA_GURU',
  PA_GURU_IN = 'PA_GURU_IN',
  PCM = 'PCM',
  PCM_NG = 'PCM_NG',
  PL = 'PL',
  PL_PL = 'PL_PL',
  PRG = 'PRG',
  PS = 'PS',
  PS_AF = 'PS_AF',
  PS_PK = 'PS_PK',
  PT = 'PT',
  PT_AO = 'PT_AO',
  PT_BR = 'PT_BR',
  PT_CH = 'PT_CH',
  PT_CV = 'PT_CV',
  PT_GQ = 'PT_GQ',
  PT_GW = 'PT_GW',
  PT_LU = 'PT_LU',
  PT_MO = 'PT_MO',
  PT_MZ = 'PT_MZ',
  PT_PT = 'PT_PT',
  PT_ST = 'PT_ST',
  PT_TL = 'PT_TL',
  QU = 'QU',
  QU_BO = 'QU_BO',
  QU_EC = 'QU_EC',
  QU_PE = 'QU_PE',
  RM = 'RM',
  RM_CH = 'RM_CH',
  RN = 'RN',
  RN_BI = 'RN_BI',
  RO = 'RO',
  ROF = 'ROF',
  ROF_TZ = 'ROF_TZ',
  RO_MD = 'RO_MD',
  RO_RO = 'RO_RO',
  RU = 'RU',
  RU_BY = 'RU_BY',
  RU_KG = 'RU_KG',
  RU_KZ = 'RU_KZ',
  RU_MD = 'RU_MD',
  RU_RU = 'RU_RU',
  RU_UA = 'RU_UA',
  RW = 'RW',
  RWK = 'RWK',
  RWK_TZ = 'RWK_TZ',
  RW_RW = 'RW_RW',
  SAH = 'SAH',
  SAH_RU = 'SAH_RU',
  SAQ = 'SAQ',
  SAQ_KE = 'SAQ_KE',
  SAT = 'SAT',
  SAT_OLCK = 'SAT_OLCK',
  SAT_OLCK_IN = 'SAT_OLCK_IN',
  SBP = 'SBP',
  SBP_TZ = 'SBP_TZ',
  SD = 'SD',
  SD_ARAB = 'SD_ARAB',
  SD_ARAB_PK = 'SD_ARAB_PK',
  SD_DEVA = 'SD_DEVA',
  SD_DEVA_IN = 'SD_DEVA_IN',
  SE = 'SE',
  SEH = 'SEH',
  SEH_MZ = 'SEH_MZ',
  SES = 'SES',
  SES_ML = 'SES_ML',
  SE_FI = 'SE_FI',
  SE_NO = 'SE_NO',
  SE_SE = 'SE_SE',
  SG = 'SG',
  SG_CF = 'SG_CF',
  SHI = 'SHI',
  SHI_LATN = 'SHI_LATN',
  SHI_LATN_MA = 'SHI_LATN_MA',
  SHI_TFNG = 'SHI_TFNG',
  SHI_TFNG_MA = 'SHI_TFNG_MA',
  SI = 'SI',
  SI_LK = 'SI_LK',
  SK = 'SK',
  SK_SK = 'SK_SK',
  SL = 'SL',
  SL_SI = 'SL_SI',
  SMN = 'SMN',
  SMN_FI = 'SMN_FI',
  SN = 'SN',
  SN_ZW = 'SN_ZW',
  SO = 'SO',
  SO_DJ = 'SO_DJ',
  SO_ET = 'SO_ET',
  SO_KE = 'SO_KE',
  SO_SO = 'SO_SO',
  SQ = 'SQ',
  SQ_AL = 'SQ_AL',
  SQ_MK = 'SQ_MK',
  SQ_XK = 'SQ_XK',
  SR = 'SR',
  SR_CYRL = 'SR_CYRL',
  SR_CYRL_BA = 'SR_CYRL_BA',
  SR_CYRL_ME = 'SR_CYRL_ME',
  SR_CYRL_RS = 'SR_CYRL_RS',
  SR_CYRL_XK = 'SR_CYRL_XK',
  SR_LATN = 'SR_LATN',
  SR_LATN_BA = 'SR_LATN_BA',
  SR_LATN_ME = 'SR_LATN_ME',
  SR_LATN_RS = 'SR_LATN_RS',
  SR_LATN_XK = 'SR_LATN_XK',
  SU = 'SU',
  SU_LATN = 'SU_LATN',
  SU_LATN_ID = 'SU_LATN_ID',
  SV = 'SV',
  SV_AX = 'SV_AX',
  SV_FI = 'SV_FI',
  SV_SE = 'SV_SE',
  SW = 'SW',
  SW_CD = 'SW_CD',
  SW_KE = 'SW_KE',
  SW_TZ = 'SW_TZ',
  SW_UG = 'SW_UG',
  TA = 'TA',
  TA_IN = 'TA_IN',
  TA_LK = 'TA_LK',
  TA_MY = 'TA_MY',
  TA_SG = 'TA_SG',
  TE = 'TE',
  TEO = 'TEO',
  TEO_KE = 'TEO_KE',
  TEO_UG = 'TEO_UG',
  TE_IN = 'TE_IN',
  TG = 'TG',
  TG_TJ = 'TG_TJ',
  TH = 'TH',
  TH_TH = 'TH_TH',
  TI = 'TI',
  TI_ER = 'TI_ER',
  TI_ET = 'TI_ET',
  TK = 'TK',
  TK_TM = 'TK_TM',
  TO = 'TO',
  TO_TO = 'TO_TO',
  TR = 'TR',
  TR_CY = 'TR_CY',
  TR_TR = 'TR_TR',
  TT = 'TT',
  TT_RU = 'TT_RU',
  TWQ = 'TWQ',
  TWQ_NE = 'TWQ_NE',
  TZM = 'TZM',
  TZM_MA = 'TZM_MA',
  UG = 'UG',
  UG_CN = 'UG_CN',
  UK = 'UK',
  UK_UA = 'UK_UA',
  UR = 'UR',
  UR_IN = 'UR_IN',
  UR_PK = 'UR_PK',
  UZ = 'UZ',
  UZ_ARAB = 'UZ_ARAB',
  UZ_ARAB_AF = 'UZ_ARAB_AF',
  UZ_CYRL = 'UZ_CYRL',
  UZ_CYRL_UZ = 'UZ_CYRL_UZ',
  UZ_LATN = 'UZ_LATN',
  UZ_LATN_UZ = 'UZ_LATN_UZ',
  VAI = 'VAI',
  VAI_LATN = 'VAI_LATN',
  VAI_LATN_LR = 'VAI_LATN_LR',
  VAI_VAII = 'VAI_VAII',
  VAI_VAII_LR = 'VAI_VAII_LR',
  VI = 'VI',
  VI_VN = 'VI_VN',
  VO = 'VO',
  VUN = 'VUN',
  VUN_TZ = 'VUN_TZ',
  WAE = 'WAE',
  WAE_CH = 'WAE_CH',
  WO = 'WO',
  WO_SN = 'WO_SN',
  XH = 'XH',
  XH_ZA = 'XH_ZA',
  XOG = 'XOG',
  XOG_UG = 'XOG_UG',
  YAV = 'YAV',
  YAV_CM = 'YAV_CM',
  YI = 'YI',
  YO = 'YO',
  YO_BJ = 'YO_BJ',
  YO_NG = 'YO_NG',
  YUE = 'YUE',
  YUE_HANS = 'YUE_HANS',
  YUE_HANS_CN = 'YUE_HANS_CN',
  YUE_HANT = 'YUE_HANT',
  YUE_HANT_HK = 'YUE_HANT_HK',
  ZGH = 'ZGH',
  ZGH_MA = 'ZGH_MA',
  ZH = 'ZH',
  ZH_HANS = 'ZH_HANS',
  ZH_HANS_CN = 'ZH_HANS_CN',
  ZH_HANS_HK = 'ZH_HANS_HK',
  ZH_HANS_MO = 'ZH_HANS_MO',
  ZH_HANS_SG = 'ZH_HANS_SG',
  ZH_HANT = 'ZH_HANT',
  ZH_HANT_HK = 'ZH_HANT_HK',
  ZH_HANT_MO = 'ZH_HANT_MO',
  ZH_HANT_TW = 'ZH_HANT_TW',
  ZU = 'ZU',
  ZU_ZA = 'ZU_ZA'
}

export type MaterialCodeDescriptionFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type MaterialMasterFilterInput = {
  gradeGram?: InputMaybe<Scalars['String']>;
  gradeGramCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  materialCode?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export enum MaterialPricingGroupEnum {
  NON_STANDARD = 'NON_STANDARD',
  STANDARD = 'STANDARD'
}

export type MaterialSearchFilterInput = {
  custMatCode?: InputMaybe<Scalars['String']>;
  matCode?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type MetadataFilter = {
  /** Key of a metadata item. */
  key: Scalars['String'];
  /** Value of a metadata item. */
  value?: InputMaybe<Scalars['String']>;
};

export type MulesoftApiLogCreateInput = {
  /** Exception of the mulesoft log. */
  exception?: InputMaybe<Scalars['String']>;
  /** Feature of the mulesoft log. */
  feature?: InputMaybe<Scalars['String']>;
  /** Order number of the mulesoft log. */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Order id of the mulesoft log. */
  orderid?: InputMaybe<Scalars['Int']>;
  /** Request of the mulesoft log. */
  request: Scalars['String'];
  /** Response of the mulesoft log. */
  response?: InputMaybe<Scalars['String']>;
  /** Response time of the mulesoft log. */
  responseTimeMs?: InputMaybe<Scalars['Int']>;
  /** Retry of the mulesoft log. */
  retry?: InputMaybe<Scalars['Boolean']>;
  /** Retry count of the mulesoft log. */
  retryCount?: InputMaybe<Scalars['Int']>;
  /** URL of the mulesoft log. */
  url: Scalars['String'];
};

export enum OrderDirection {
  /** Specifies an ascending sort order. */
  ASC = 'ASC',
  /** Specifies a descending sort order. */
  DESC = 'DESC'
}

export enum OrderDraftField {
  CONTRACT_NO = 'CONTRACT_NO',
  CREATED_AT = 'CREATED_AT',
  SOLD_TO = 'SOLD_TO',
  UPDATED_AT = 'UPDATED_AT'
}

export type OrderDraftSorterInput = {
  direction: OrderDirection;
  /** Sort orderDrafts by the selected field. */
  field: OrderDraftField;
};

export type OrderHeaderPriceInfo = {
  billTo?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  distributionChannel?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['String']>;
  salesEmployee?: InputMaybe<Scalars['String']>;
  salesOrganization?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  taxClassId?: InputMaybe<Scalars['Int']>;
};

export type OrderInformationInput = {
  billTo?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['ID']>;
  customerGroup1Id?: InputMaybe<Scalars['ID']>;
  customerGroup2Id?: InputMaybe<Scalars['ID']>;
  customerGroup3Id?: InputMaybe<Scalars['ID']>;
  customerGroup4Id?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deliveryBlock?: InputMaybe<Scalars['String']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  incotermsId?: InputMaybe<Scalars['ID']>;
  internalCommentsToLogistic?: InputMaybe<Scalars['String']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  poDate?: InputMaybe<Scalars['Date']>;
  poNumber?: InputMaybe<Scalars['String']>;
  productInformation?: InputMaybe<Scalars['String']>;
  /** date must be type yyyy-mm-dd */
  requestDate?: InputMaybe<Scalars['Date']>;
  route?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPoint?: InputMaybe<Scalars['String']>;
};

export type OrderLinePriceInfo = {
  batchNo?: InputMaybe<Scalars['String']>;
  custMatCode?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  materialNo?: InputMaybe<Scalars['String']>;
  parentItemNo?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  priceDate?: InputMaybe<Scalars['String']>;
  productionFlag?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['String']>;
  saleUnit?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export enum OrderLineStatus {
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  ENABLE = 'ENABLE'
}

export enum OrderLinesSortField {
  ITEM_NO = 'ITEM_NO'
}

export type OrderLinesSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort orderLines by the selected field. */
  field: OrderLinesSortField;
};

export type OrderOrganizationalDataInput = {
  distributionChannelId?: InputMaybe<Scalars['ID']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  saleGroupId?: InputMaybe<Scalars['ID']>;
  saleOfficeId?: InputMaybe<Scalars['ID']>;
  saleOrganizationId?: InputMaybe<Scalars['ID']>;
};

export enum OrderType {
  CUSTOMER = 'CUSTOMER',
  DOMESTIC = 'DOMESTIC',
  EO = 'EO',
  EXPORT = 'EXPORT',
  PO = 'PO'
}

export enum PoUploadFileLogField {
  UPDATED_AT = 'UPDATED_AT'
}

export type PoUploadFileLogSorterInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort poUploadFileLogs by the selected field. */
  field: PoUploadFileLogField;
};

export type PendingOrderReportShipTosFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum PermissionEnum {
  ALL_CONTRACT = 'ALL_CONTRACT',
  ALL_REPORT_ADMIN = 'ALL_REPORT_ADMIN',
  ALL_REPORT_CUSTOMER = 'ALL_REPORT_CUSTOMER',
  ALL_REPORT_DOMESTIC = 'ALL_REPORT_DOMESTIC',
  ALL_REPORT_EXPORT = 'ALL_REPORT_EXPORT',
  ALL_UPLOAD_PO_ADMIN = 'ALL_UPLOAD_PO_ADMIN',
  ALL_UPLOAD_PO_CUSTOMER = 'ALL_UPLOAD_PO_CUSTOMER',
  APPROVE_DUMMY = 'APPROVE_DUMMY',
  CHANGE_DUMMY = 'CHANGE_DUMMY',
  CHANGE_ORDER_CUSTOMER = 'CHANGE_ORDER_CUSTOMER',
  CHANGE_ORDER_DOMESTIC = 'CHANGE_ORDER_DOMESTIC',
  CHANGE_ORDER_EXPORT = 'CHANGE_ORDER_EXPORT',
  CREATE_DUMMY = 'CREATE_DUMMY',
  CREATE_ORDER_CUSTOMER = 'CREATE_ORDER_CUSTOMER',
  CREATE_ORDER_DOMESTIC = 'CREATE_ORDER_DOMESTIC',
  CREATE_ORDER_DOMESTIC_PACKAGING = 'CREATE_ORDER_DOMESTIC_PACKAGING',
  CREATE_ORDER_EXPORT = 'CREATE_ORDER_EXPORT',
  HANDLE_CHECKOUTS = 'HANDLE_CHECKOUTS',
  HANDLE_PAYMENTS = 'HANDLE_PAYMENTS',
  IMPERSONATE_USER = 'IMPERSONATE_USER',
  LMS = 'LMS',
  MAINTAIN_ALT_MATERIAL = 'MAINTAIN_ALT_MATERIAL',
  MAINTAIN_CUSTOMER_MATERIAL = 'MAINTAIN_CUSTOMER_MATERIAL',
  MAINTAIN_EMAIL = 'MAINTAIN_EMAIL',
  MAINTAIN_EMAIL_EO_UPLOAD = 'MAINTAIN_EMAIL_EO_UPLOAD',
  MAINTAIN_EXCEL_UPLOAD = 'MAINTAIN_EXCEL_UPLOAD',
  MAINTAIN_ORGANIZATION = 'MAINTAIN_ORGANIZATION',
  MAINTAIN_PO_UPLOAD = 'MAINTAIN_PO_UPLOAD',
  MAINTAIN_ROLE = 'MAINTAIN_ROLE',
  MAINTAIN_ROLE_PERMISSION = 'MAINTAIN_ROLE_PERMISSION',
  MAINTAIN_USER = 'MAINTAIN_USER',
  MAINTAIN_USER_GROUP = 'MAINTAIN_USER_GROUP',
  MANAGE_APPS = 'MANAGE_APPS',
  MANAGE_CHANNELS = 'MANAGE_CHANNELS',
  MANAGE_CHECKOUTS = 'MANAGE_CHECKOUTS',
  MANAGE_DISCOUNTS = 'MANAGE_DISCOUNTS',
  MANAGE_GIFT_CARD = 'MANAGE_GIFT_CARD',
  MANAGE_MENUS = 'MANAGE_MENUS',
  MANAGE_ORDERS = 'MANAGE_ORDERS',
  MANAGE_PAGES = 'MANAGE_PAGES',
  MANAGE_PAGE_TYPES_AND_ATTRIBUTES = 'MANAGE_PAGE_TYPES_AND_ATTRIBUTES',
  MANAGE_PLUGINS = 'MANAGE_PLUGINS',
  MANAGE_PRODUCTS = 'MANAGE_PRODUCTS',
  MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES = 'MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES',
  MANAGE_SETTINGS = 'MANAGE_SETTINGS',
  MANAGE_SHIPPING = 'MANAGE_SHIPPING',
  MANAGE_STAFF = 'MANAGE_STAFF',
  MANAGE_TRANSLATIONS = 'MANAGE_TRANSLATIONS',
  MANAGE_USERS = 'MANAGE_USERS',
  VIEW_DRAFT_ORDER = 'VIEW_DRAFT_ORDER',
  VIEW_DUMMY = 'VIEW_DUMMY',
  VIEW_ORDER_CONFIRM_REPORT = 'VIEW_ORDER_CONFIRM_REPORT',
  VIEW_ORDER_CUSTOMER = 'VIEW_ORDER_CUSTOMER',
  VIEW_ORDER_DOMESTIC = 'VIEW_ORDER_DOMESTIC',
  VIEW_ORDER_EXPORT = 'VIEW_ORDER_EXPORT',
  VIEW_PENDING_ORDER_TRACKING = 'VIEW_PENDING_ORDER_TRACKING',
  VIEW_SALE_ORDER_TRACKING = 'VIEW_SALE_ORDER_TRACKING',
  VIEW_STOCK = 'VIEW_STOCK'
}

export type PermissionGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};

export enum PermissionGroupSortField {
  /** Sort permission group accounts by name. */
  NAME = 'NAME'
}

export type PermissionGroupSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort permission group by the selected field. */
  field: PermissionGroupSortField;
};

export type PmtMatSearchInput = {
  custId?: InputMaybe<Scalars['String']>;
  custName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  matHeight?: InputMaybe<Scalars['Int']>;
  matLength?: InputMaybe<Scalars['Int']>;
  matWidth?: InputMaybe<Scalars['Int']>;
  partNo?: InputMaybe<Scalars['String']>;
  pc1?: InputMaybe<Scalars['String']>;
  pc2?: InputMaybe<Scalars['String']>;
  pc3?: InputMaybe<Scalars['String']>;
  pc4?: InputMaybe<Scalars['String']>;
  pc5?: InputMaybe<Scalars['String']>;
  pc6?: InputMaybe<Scalars['String']>;
  saleText?: InputMaybe<Scalars['String']>;
};

export type PriceCalculationInput = {
  /** A list of order lines, each containing information about an item in the order. */
  lines: Array<OrderLinePriceInfo>;
  orderInformation?: InputMaybe<OrderHeaderPriceInfo>;
};

export type ProductSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Specifies the field in which to sort products. */
  field: ScgProductOrderField;
};

export enum ProductionFlag {
  NOT_PRODUCED = 'NOT_PRODUCED',
  PRODUCED = 'PRODUCED'
}

export enum RealtimePartnerType {
  BILL_TO = 'BILL_TO',
  PAYER = 'PAYER',
  SALE_EMPLOYEE = 'SALE_EMPLOYEE',
  SHIP_TO = 'SHIP_TO',
  SOLD_TO = 'SOLD_TO'
}

export enum ReasonForChangeRequestDateEnum {
  C3 = 'C3',
  C4 = 'C4',
  X = 'X'
}

export enum ReasonForReject {
  CANCEL_93 = 'CANCEL_93',
  DELETE = 'DELETE'
}

export type ReasonForRejectInput = {
  reasonForReject?: InputMaybe<ReasonForReject>;
};

export type ReportOrderPendingSoldToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type RequireAttentionItemParameterUpdateInput = {
  consignment?: InputMaybe<ScgpRequireAttentionConsignment>;
  fixSourceAssignment?: InputMaybe<Scalars['String']>;
  inquiryMethodCode?: InputMaybe<IPlanInquiryMethodCode>;
  partialDelivery?: InputMaybe<ScgpRequireAttentionSplitOrderItemPartialDelivery>;
  splitOrderItem?: InputMaybe<ScgpRequireAttentionSplitOrderItemPartialDelivery>;
  transportationMethod?: InputMaybe<Scalars['Int']>;
  typeOfDelivery?: InputMaybe<ScgpRequireAttentionTypeOfDelivery>;
};

export type RequireAttentionItemsFilterInput = {
  attentionType?: InputMaybe<Array<ScgpRequireAttentionTypeData>>;
  bu?: InputMaybe<Scalars['String']>;
  confirmDate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Array<Scalars['String']>>;
  materialGradeGram?: InputMaybe<Array<Scalars['String']>>;
  materialGroup?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  orderStatus?: InputMaybe<Scalars['String']>;
  overdue1?: InputMaybe<Scalars['Boolean']>;
  overdue2?: InputMaybe<Scalars['Boolean']>;
  plant?: InputMaybe<Array<Scalars['String']>>;
  poNo?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['String']>;
  saleEmployee?: InputMaybe<Scalars['String']>;
  saleGroup?: InputMaybe<Scalars['String']>;
  saleOrganization?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export enum RequireAttentionItemsSortField {
  ATTENTION_TYPE = 'ATTENTION_TYPE',
  CONFIRM_DATE = 'CONFIRM_DATE',
  CONFIRM_QUANTITY = 'CONFIRM_QUANTITY',
  ITEM_NO = 'ITEM_NO',
  ITEM_STATUS = 'ITEM_STATUS',
  MATERIAL_CODE = 'MATERIAL_CODE',
  MATERIAL_DESCRIPTION = 'MATERIAL_DESCRIPTION',
  ORDER_NO = 'ORDER_NO',
  ORDER_STATUS = 'ORDER_STATUS',
  ORIGINAL_DATE = 'ORIGINAL_DATE',
  PLANT = 'PLANT',
  PO_NO = 'PO_NO',
  REQUEST_DATE = 'REQUEST_DATE',
  REQUEST_QUANTITY = 'REQUEST_QUANTITY',
  SHIP_TO = 'SHIP_TO',
  SOLD_TO = 'SOLD_TO',
  UNIT = 'UNIT'
}

export type RequireAttentionItemsSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort requireAttentionItems by the selected field. */
  field: RequireAttentionItemsSortField;
};

export type RequireAttentionMaterialFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type RequireAttentionMaterialGradeGramFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  materialGradeGram?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type RequireAttentionPlantFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  plant?: InputMaybe<Scalars['String']>;
};

export type RequireAttentionSaleEmployeeFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  saleEmployee?: InputMaybe<Scalars['String']>;
};

export type RequireAttentionSalesGroupFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  salesOrganization?: InputMaybe<Scalars['String']>;
};

export type RequireAttentionSalesOrganizationFilterInput = {
  businessUnit?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type RequireAttentionShipToFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  shipTo?: InputMaybe<Scalars['String']>;
};

export type RequireAttentionSoldToFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type RouteFilterInput = {
  routeCode?: InputMaybe<Scalars['String']>;
  routeDescription?: InputMaybe<Scalars['String']>;
};

export type SapChangeOrderInput = {
  bu?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  createBy?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  deliveryBlock?: InputMaybe<Scalars['String']>;
  dpNo?: InputMaybe<Scalars['String']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  isOrderTracking?: InputMaybe<Scalars['Boolean']>;
  lastUpdateDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  materialGroup1?: InputMaybe<Scalars['String']>;
  materialNoMaterialDescription?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  materialPricingGroup?: InputMaybe<MaterialPricingGroupEnum>;
  orderStatus?: InputMaybe<Array<InputMaybe<ChangeOrderOrderStatus>>>;
  orderType?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  purchaseOrderNo?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  requireAttentionFlag?: InputMaybe<Scalars['String']>;
  saleGroup?: InputMaybe<Scalars['String']>;
  saleOrderNo?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
  salesEmployeeNo?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortByField?: InputMaybe<SoldToSortInput>;
  sourceOfApp?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ChangeOrderStatusEnum>;
};

export type SapListOfSaleOrderDateInput = {
  gte?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type SapListOfSaleOrderInput = {
  bu?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  createBy?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  deliveryBlock?: InputMaybe<Scalars['String']>;
  isOrderTracking?: InputMaybe<Scalars['Boolean']>;
  materialGroup1?: InputMaybe<Scalars['String']>;
  materialNoMaterialDescription?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  materialPricingGroup?: InputMaybe<MaterialPricingGroupEnum>;
  orderType?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  purchaseOrderNo?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  requireAttentionFlag?: InputMaybe<Scalars['String']>;
  saleGroup?: InputMaybe<Scalars['String']>;
  saleOrderNo?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
  salesEmployeeNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortByField?: InputMaybe<SoldToSortInput>;
  sourceOfApp?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SaleOrderStatusEnum>;
};

export type SapListOfSaleOrderPendingInput = {
  bu?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  isOrderTracking?: InputMaybe<Scalars['Boolean']>;
  materialNoMaterialDescription?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poNo?: InputMaybe<Scalars['String']>;
  productGroups?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<SapListOfSaleOrderDateInput>;
  saleOrg: Array<InputMaybe<Scalars['String']>>;
  shipTo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceOfApp?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SapOrderConfirmationDateInput = {
  gte?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type SapOrderConfirmationInput = {
  bu?: InputMaybe<Scalars['String']>;
  channel: Scalars['String'];
  createDate?: InputMaybe<SapOrderConfirmationDateInput>;
  materialNoMaterialDescription?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poNo?: InputMaybe<Scalars['String']>;
  productGroup?: InputMaybe<Scalars['String']>;
  saleOrg: Array<InputMaybe<Scalars['String']>>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceOfApp?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InquiryOrderConfirmationStatus>;
};

export type SapOrderRequest = {
  bu?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  createDateFrom?: InputMaybe<Scalars['Date']>;
  createDateTo?: InputMaybe<Scalars['Date']>;
  dpNo?: InputMaybe<Scalars['String']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  purchaseOrderNo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  updateDateFrom?: InputMaybe<Scalars['Date']>;
  updateDateTo?: InputMaybe<Scalars['Date']>;
};

export type SapPendingOrderReportDateInput = {
  gte?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type SapPendingOrderReportInput = {
  bu?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<SapPendingOrderReportDateInput>;
  isOrderTracking?: InputMaybe<Scalars['Boolean']>;
  materialNoMaterialDescription?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poNo?: InputMaybe<Scalars['String']>;
  productGroup?: InputMaybe<Scalars['String']>;
  productGroups?: InputMaybe<Scalars['String']>;
  reportFormat?: InputMaybe<Scalars['String']>;
  reportLanguage?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<SapPendingOrderReportDateInput>;
  saleOrg: Array<InputMaybe<Scalars['String']>>;
  shipTo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
  soldTo: Array<InputMaybe<Scalars['String']>>;
  soldToSort?: InputMaybe<Array<InputMaybe<SoldToSortInput>>>;
  sourceOfApp?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum SaleOrderStatusEnum {
  ALL = 'ALL',
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING'
}

export type SalesOrderFilterInput = {
  channel?: InputMaybe<Scalars['String']>;
  createBy?: InputMaybe<Scalars['String']>;
  createDate?: InputMaybe<DateRangeInput>;
  deliveryBlock?: InputMaybe<DeliveryBlock09Enum>;
  id?: InputMaybe<Scalars['Float']>;
  materialGroup1?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>;
  materialNoMaterialDescription?: InputMaybe<Array<Scalars['String']>>;
  materialPricingGroup?: InputMaybe<MaterialPricingGroupEnum>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  orderType?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  purchaseOrderNo?: InputMaybe<Scalars['String']>;
  requestDeliveryDate?: InputMaybe<DateRangeInput>;
  requireAttentionFlag?: InputMaybe<ScgpRequireAttentionTypeData>;
  saleGroup?: InputMaybe<Scalars['String']>;
  saleOrderNo?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
  salesEmployeeNo?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>;
  status?: InputMaybe<SaleOrderStatusEnum>;
};

export enum SalesOrderSortField {
  CREATE_DATE = 'CREATE_DATE',
  ORDER_NO = 'ORDER_NO',
  PO_NO = 'PO_NO',
  REQUEST_DATE = 'REQUEST_DATE'
}

export type SalesOrderSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort salesOrder by the selected field. */
  field: SalesOrderSortField;
};

export enum ScgDomesticOrderStatusSap {
  BEING_PROCESS = 'BEING_PROCESS',
  COMPLETE = 'COMPLETE'
}

export enum ScgExportCartItemOrderField {
  CONTRACT_MATERIAL_ID = 'CONTRACT_MATERIAL_ID',
  PRICE_PER_UNIT = 'PRICE_PER_UNIT',
  REMAINING_QUANTITY = 'REMAINING_QUANTITY',
  TOTAL_QUANTITY = 'TOTAL_QUANTITY'
}

export enum ScgExportCartOrderField {
  SOLD_TO = 'SOLD_TO'
}

export enum ScgExportOrderType {
  CHANGE = 'CHANGE',
  CREATE = 'CREATE',
  ZFC1 = 'ZFC1',
  ZFC2 = 'ZFC2',
  ZOR = 'ZOR'
}

export enum ScgExportRejectReason {
  NO = 'NO',
  YES = 'YES'
}

export type ScgOrderDraftFilterInput = {
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrderType>;
};

export enum ScgOrderStatus {
  CANCELED = 'CANCELED',
  COMPLETED_DELIVERY = 'COMPLETED_DELIVERY',
  COMPLETED_ORDER = 'COMPLETED_ORDER',
  CONFIRMED = 'CONFIRMED',
  CREDIT_CASH_ISSUE = 'CREDIT_CASH_ISSUE',
  DONE = 'DONE',
  DRAFT = 'DRAFT',
  FAILED_CONFIRM = 'FAILED_CONFIRM',
  PARTIAL_COMMITTED_ORDER = 'PARTIAL_COMMITTED_ORDER',
  PARTIAL_DELIVERY = 'PARTIAL_DELIVERY',
  PRE_DRAFT = 'PRE_DRAFT',
  PROCESSING = 'PROCESSING',
  READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
  RECEIVED_ORDER = 'RECEIVED_ORDER',
  STATUS_RANK = 'STATUS_RANK'
}

export enum ScgOrderlineAtpCtpStatus {
  ACCEPT = 'ACCEPT',
  ROLLBACK = 'ROLLBACK'
}

export enum ScgProductOrderField {
  PRICE_PER_UNIT = 'PRICE_PER_UNIT',
  REMAINING_QUANTITY = 'REMAINING_QUANTITY',
  TOTAL_QUANTITY = 'TOTAL_QUANTITY'
}

export type ScgSoldTosFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum ScgpCustomerErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  PRODUCT_GROUP_ERROR = 'PRODUCT_GROUP_ERROR',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export enum ScgpCustomerProductOrderField {
  PRICE = 'PRICE',
  REMAIN = 'REMAIN',
  TOTAL = 'TOTAL'
}

export enum ScgpCustomerType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

/** An enumeration. */
export enum ScgpExportErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  DUPLICATE_ORDER = 'DUPLICATE_ORDER',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  IPLAN_ERROR = 'IPLAN_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  PRODUCT_GROUP_ERROR = 'PRODUCT_GROUP_ERROR',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export enum ScgpExportOrderStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED_DELIVERY = 'COMPLETED_DELIVERY',
  COMPLETED_ORDER = 'COMPLETED_ORDER',
  CONFIRMED = 'CONFIRMED',
  CREDIT_CASH_ISSUE = 'CREDIT_CASH_ISSUE',
  DRAFT = 'DRAFT',
  FULL_COMMITTED_ORDER = 'FULL_COMMITTED_ORDER',
  PARTIAL_COMMITTED_ORDER = 'PARTIAL_COMMITTED_ORDER',
  PARTIAL_DELIVERY = 'PARTIAL_DELIVERY',
  PRE_DRAFT = 'PRE_DRAFT',
  READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
  RECEIVED_ORDER = 'RECEIVED_ORDER'
}

export enum ScgpExportOrderStatusSap {
  BEING_PROCESS = 'BEING_PROCESS',
  COMPLETE = 'COMPLETE'
}

/** An enumeration. */
export enum ScgpPoUploadErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  FILE_EXCEED = 'FILE_EXCEED',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export enum ScgpRequireAttentionConsignment {
  FREE_STOCK_1000 = 'FREE_STOCK_1000',
  FREE_STOCK_1001 = 'FREE_STOCK_1001',
  FREE_STOCK_1002 = 'FREE_STOCK_1002'
}

/** An enumeration. */
export enum ScgpRequireAttentionItemsErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export enum ScgpRequireAttentionSplitOrderItemPartialDelivery {
  NO = 'NO',
  YES = 'YES'
}

export enum ScgpRequireAttentionTypeData {
  ALL = 'ALL',
  R1 = 'R1',
  R2 = 'R2',
  R3 = 'R3',
  R4 = 'R4',
  R5 = 'R5'
}

export enum ScgpRequireAttentionTypeOfDelivery {
  ARRIVAL = 'ARRIVAL',
  EX_MILL = 'EX_MILL'
}

/** An enumeration. */
export enum ScgpUserManagementErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  LOCK = 'LOCK',
  NOT_ALLOW = 'NOT_ALLOW',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type ScgpUserRegisterInput = {
  /** Ad user. */
  adUser?: InputMaybe<Scalars['String']>;
  /** Email of company. */
  companyEmail?: InputMaybe<Scalars['String']>;
  /** Type of customer. */
  customerType?: InputMaybe<ScgpCustomerType>;
  /** Display name of user. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Email of user */
  email: Scalars['String'];
  /** Id of employee. */
  employeeId?: InputMaybe<Scalars['String']>;
  /** First name of user. */
  firstName: Scalars['String'];
  /** ID of user roles. */
  groupIds: Array<InputMaybe<Scalars['ID']>>;
  /** Last name of user. */
  lastName: Scalars['String'];
  /** Id of sale. */
  saleId?: InputMaybe<Scalars['String']>;
  /** sap id of user. */
  sapId?: InputMaybe<Scalars['String']>;
  /** Business Unit of user. */
  scgpBuIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Distribution Channel of user. */
  scgpDistributionChannelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Division of user. */
  scgpDivisionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Group of user. */
  scgpSalesGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Office of user. */
  scgpSalesOfficeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Organization of user. */
  scgpSalesOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** ID of sold to. */
  soldToIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** ID of user group. */
  userParentGroupId: Scalars['ID'];
};

export enum ScgpUserSortField {
  BU = 'BU',
  CREATED_DATE = 'CREATED_DATE',
  EMPLOYEE_ID = 'EMPLOYEE_ID',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  SALE_GROUP = 'SALE_GROUP',
  SALE_ORGANIZATION = 'SALE_ORGANIZATION',
  USER_GROUP = 'USER_GROUP'
}

export type ScgpUserSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort scgpUser by the selected field. */
  field: ScgpUserSortField;
};

export enum ScgpUserStatus {
  FORCE_ADD_EMAIL = 'FORCE_ADD_EMAIL',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD'
}

export type ScgpUserUpdateInput = {
  /** Ad user. */
  adUser?: InputMaybe<Scalars['String']>;
  /** Email of company. */
  companyEmail?: InputMaybe<Scalars['String']>;
  /** Type of customer. */
  customerType?: InputMaybe<ScgpCustomerType>;
  /** Display name of user. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Email of user */
  email: Scalars['String'];
  /** Id of employee. */
  employeeId?: InputMaybe<Scalars['String']>;
  /** First name of user. */
  firstName: Scalars['String'];
  /** ID of user roles. */
  groupIds: Array<InputMaybe<Scalars['ID']>>;
  /** Set user active status */
  isActive: Scalars['Boolean'];
  /** Last name of user. */
  lastName: Scalars['String'];
  /** Id of sale. */
  saleId?: InputMaybe<Scalars['String']>;
  /** sap id of user. */
  sapId?: InputMaybe<Scalars['String']>;
  /** Business Unit of user. */
  scgpBuIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Distribution Channel of user. */
  scgpDistributionChannelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Division of user. */
  scgpDivisionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Group of user. */
  scgpSalesGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Office of user. */
  scgpSalesOfficeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Sales Organization of user. */
  scgpSalesOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** ID of sold to. */
  soldToIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** ID of user group. */
  userParentGroupId: Scalars['ID'];
};

export type ScgpUsersFilterInput = {
  bu?: InputMaybe<Scalars['Float']>;
  createDate?: InputMaybe<DateRangeInput>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['Float']>;
  lastLoginDate?: InputMaybe<DateRangeInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastUpdateDate?: InputMaybe<DateRangeInput>;
  parentGroup?: InputMaybe<Scalars['Float']>;
  saleGroup?: InputMaybe<Scalars['Float']>;
  saleOrg?: InputMaybe<Scalars['Float']>;
  soldTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updateBy?: InputMaybe<Scalars['String']>;
};

export enum SearchMaterialBy {
  CUST_MAT_CODE = 'CUST_MAT_CODE',
  MAT_CODE = 'MAT_CODE'
}

export type SendEmailOrderInput = {
  contractName?: InputMaybe<Scalars['String']>;
  contractNo?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['String']>;
  isNotRef?: InputMaybe<Scalars['Boolean']>;
  itemNo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderLines?: InputMaybe<Array<InputMaybe<SendEmailOrderLineInput>>>;
  paymentTermDesc?: InputMaybe<Scalars['String']>;
  poNo?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
  shipTo?: InputMaybe<Scalars['String']>;
  soNo?: InputMaybe<Scalars['String']>;
};

export type SendEmailOrderLineInput = {
  confirmQty?: InputMaybe<Scalars['String']>;
  firstDeliveryDate?: InputMaybe<Scalars['String']>;
  iplanConfirmDate?: InputMaybe<Scalars['String']>;
  itemNo?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  materialDescription?: InputMaybe<Scalars['String']>;
  nonConfirmQty?: InputMaybe<Scalars['String']>;
  orderQty?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  saleUnit?: InputMaybe<Scalars['String']>;
  soldTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum ShopErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  CANNOT_FETCH_TAX_RATES = 'CANNOT_FETCH_TAX_RATES',
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE'
}

export type ShopSettingsInput = {
  /** Enable automatic fulfillment for all digital products. */
  automaticFulfillmentDigitalProducts?: InputMaybe<Scalars['Boolean']>;
  /** Charge taxes on shipping. */
  chargeTaxesOnShipping?: InputMaybe<Scalars['Boolean']>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: InputMaybe<Scalars['String']>;
  /** Default number of max downloads per digital content URL. */
  defaultDigitalMaxDownloads?: InputMaybe<Scalars['Int']>;
  /** Default number of days which digital content URL will be valid. */
  defaultDigitalUrlValidDays?: InputMaybe<Scalars['Int']>;
  /** Default email sender's address. */
  defaultMailSenderAddress?: InputMaybe<Scalars['String']>;
  /** Default email sender's name. */
  defaultMailSenderName?: InputMaybe<Scalars['String']>;
  /** Default weight unit. */
  defaultWeightUnit?: InputMaybe<WeightUnitsEnum>;
  /** SEO description. */
  description?: InputMaybe<Scalars['String']>;
  /** Display prices with tax in store. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']>;
  /** Added in Saleor 3.1. Enable ability to approve fulfillments which are unpaid. */
  fulfillmentAllowUnpaid?: InputMaybe<Scalars['Boolean']>;
  /** Added in Saleor 3.1. Enable automatic approval of all new fulfillments. */
  fulfillmentAutoApprove?: InputMaybe<Scalars['Boolean']>;
  /** Header text. */
  headerText?: InputMaybe<Scalars['String']>;
  /** Include taxes in prices. */
  includeTaxesInPrices?: InputMaybe<Scalars['Boolean']>;
  /** Added in Saleor 3.1. Default number of maximum line quantity in single checkout. Minimum possible value is 1, default value is 50. Note: this feature is in a preview state and can be subject to changes at later point. */
  limitQuantityPerCheckout?: InputMaybe<Scalars['Int']>;
  /** Added in Saleor 3.1. Default number of minutes stock will be reserved for anonymous checkout. Enter 0 or null to disable. */
  reserveStockDurationAnonymousUser?: InputMaybe<Scalars['Int']>;
  /** Added in Saleor 3.1. Default number of minutes stock will be reserved for authenticated checkout. Enter 0 or null to disable. */
  reserveStockDurationAuthenticatedUser?: InputMaybe<Scalars['Int']>;
  /** Enable inventory tracking. */
  trackInventoryByDefault?: InputMaybe<Scalars['Boolean']>;
};

export type ShopSettingsTranslationInput = {
  description?: InputMaybe<Scalars['String']>;
  headerText?: InputMaybe<Scalars['String']>;
};

export type SiteDomainInput = {
  /** Domain name for shop. */
  domain?: InputMaybe<Scalars['String']>;
  /** Shop site name. */
  name?: InputMaybe<Scalars['String']>;
};

export type SoldToMasterFilterInput = {
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  soldTo?: InputMaybe<Scalars['String']>;
};

export type SoldToSortInput = {
  soldTo?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
};

export type SplitCipOrderLineInput = {
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  isParent?: InputMaybe<Scalars['Boolean']>;
  itemNo?: InputMaybe<Scalars['String']>;
  itemNoteCip?: InputMaybe<Scalars['String']>;
  lotNo?: InputMaybe<Scalars['String']>;
  originalItemId?: InputMaybe<Scalars['Int']>;
  prItemTextCip?: InputMaybe<Scalars['String']>;
  productionFlag?: InputMaybe<ProductionFlag>;
  productionMemoPp?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  saleText1?: InputMaybe<Scalars['String']>;
  saleText2?: InputMaybe<Scalars['String']>;
  saleText3?: InputMaybe<Scalars['String']>;
  saleText4?: InputMaybe<Scalars['String']>;
};

export type SplitCipOrderLineInputAfterCp = {
  confirmDate?: InputMaybe<Scalars['Date']>;
  externalCommentsToCustomer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  internalCommentsToWarehouse?: InputMaybe<Scalars['String']>;
  isParent?: InputMaybe<Scalars['Boolean']>;
  itemNo?: InputMaybe<Scalars['String']>;
  itemNoteCip?: InputMaybe<Scalars['String']>;
  lotNo?: InputMaybe<Scalars['String']>;
  originalItemId?: InputMaybe<Scalars['Int']>;
  parentBom?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  prItemTextCip?: InputMaybe<Scalars['String']>;
  productionFlag?: InputMaybe<ProductionFlag>;
  productionMemoPp?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
  saleText1?: InputMaybe<Scalars['String']>;
  saleText2?: InputMaybe<Scalars['String']>;
  saleText3?: InputMaybe<Scalars['String']>;
  saleText4?: InputMaybe<Scalars['String']>;
};

export enum StaffMemberStatus {
  /** User account has been activated. */
  ACTIVE = 'ACTIVE',
  /** User account has not been activated yet. */
  DEACTIVATED = 'DEACTIVATED'
}

export type StaffNotificationRecipientInput = {
  /** Determines if a notification active. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Email address of a user subscribed to email notifications. */
  email?: InputMaybe<Scalars['String']>;
  /** The ID of the user subscribed to email notifications.. */
  user?: InputMaybe<Scalars['ID']>;
};

export type StaffUserInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StaffMemberStatus>;
};

export type SuggestionMaterialFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type SuggestionSearchMaterialGradeGramFilterInput = {
  input?: InputMaybe<Scalars['String']>;
  materialOnHand?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type SuggestionSearchUserByNameFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type TempContractFilterInput = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  gradeGram?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  materialCode?: InputMaybe<Scalars['String']>;
};

export type TempProductFilterInput = {
  gradeGram?: InputMaybe<Scalars['String']>;
  gradeGramCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  materialCode?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

/** An enumeration. */
export enum TimePeriodTypeEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

/** An enumeration. */
export enum TranslationErrorCode {
  GRAPHQL_ERROR = 'GRAPHQL_ERROR',
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  REQUIRED = 'REQUIRED'
}

export type UpdateAtpCtpContractOrderLineInput = {
  atpCtp?: InputMaybe<Scalars['String']>;
  atpCtpDetail?: InputMaybe<Scalars['String']>;
  atpCtpStatus?: InputMaybe<ScgOrderlineAtpCtpStatus>;
  block?: InputMaybe<Scalars['String']>;
  confirmedDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  plant?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  run?: InputMaybe<Scalars['String']>;
};

export type UpdateInquiryMethodExportInput = {
  inquiryMethod: InquiryMethodType;
};

/** An enumeration. */
export enum UploadErrorCode {
  GRAPHQL_ERROR = 'GRAPHQL_ERROR'
}

export enum UploadType {
  GROUP = 'GROUP',
  NOT_GROUP = 'NOT_GROUP'
}

export type UserManagementSaleOfficeFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  salesOrganization?: InputMaybe<Array<Scalars['String']>>;
};

export type UserManagementSaleOrgFilterInput = {
  businessUnit?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type UserManagementSalesGroupFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  salesOrganization?: InputMaybe<Array<Scalars['String']>>;
};

export type UserManagementSoldToFilterInput = {
  accountGroupCode?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']>;
};

export enum UserSortField {
  /** Sort users by created at. */
  CREATED_AT = 'CREATED_AT',
  /** Sort users by email. */
  EMAIL = 'EMAIL',
  /** Sort users by first name. */
  FIRST_NAME = 'FIRST_NAME',
  /** Sort users by last modified at. */
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT',
  /** Sort users by last name. */
  LAST_NAME = 'LAST_NAME',
  /** Sort users by order count. */
  ORDER_COUNT = 'ORDER_COUNT'
}

export type UserSortingInput = {
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort users by the selected field. */
  field: UserSortField;
};

/** An enumeration. */
export enum VolumeUnitsEnum {
  ACRE_FT = 'ACRE_FT',
  ACRE_IN = 'ACRE_IN',
  CUBIC_CENTIMETER = 'CUBIC_CENTIMETER',
  CUBIC_DECIMETER = 'CUBIC_DECIMETER',
  CUBIC_FOOT = 'CUBIC_FOOT',
  CUBIC_INCH = 'CUBIC_INCH',
  CUBIC_METER = 'CUBIC_METER',
  CUBIC_MILLIMETER = 'CUBIC_MILLIMETER',
  CUBIC_YARD = 'CUBIC_YARD',
  FL_OZ = 'FL_OZ',
  LITER = 'LITER',
  PINT = 'PINT',
  QT = 'QT'
}

export enum WeightUnitEnum {
  KG = 'KG',
  TON = 'TON'
}

/** An enumeration. */
export enum WeightUnitsEnum {
  G = 'G',
  KG = 'KG',
  LB = 'LB',
  OZ = 'OZ',
  TONNE = 'TONNE'
}

export type PrintPdfOrderConfirmMutationVariables = Exact<{
  orders: SendEmailOrderInput;
  reportLanguage: Scalars['String'];
}>;


export type PrintPdfOrderConfirmMutation = { __typename: 'Mutation', printPdfOrderConfirmation: { __typename: 'PrintPDFOrderConfirmation', exportedFileBase64: string | null, fileName: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type FilterDomesticOrderConfirmationCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterDomesticOrderConfirmationCompanyQuery = { __typename: 'Query', filterDomesticOrderConfirmationCompany: Array<{ __typename: 'SapMigrationCompany', name: string | null, code: string | null } | null> | null };

export type FilterMaterialCodeNameDomesticOrderQueryVariables = Exact<{
  distributionChannelType: DistributionChannelType;
  filter?: InputMaybe<DomesticMaterialCodeNameFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterMaterialCodeNameDomesticOrderQuery = { __typename: 'Query', filterMaterialCodeNameDomesticOrder: { __typename: 'DomesticMaterialCodeNameCountableConnection', edges: Array<{ __typename: 'DomesticMaterialCodeNameCountableEdge', node: { __typename: 'TempProductVariant', code: string | null, name: string | null } }> } | null };

export type GetListAdminOrderConfirmationQueryVariables = Exact<{
  sortBy?: InputMaybe<DomesticOrderConfirmationSortingInput>;
  filter?: InputMaybe<DomesticOrderConfirmationFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type GetListAdminOrderConfirmationQuery = { __typename: 'Query', domesticOrderConfirmation: { __typename: 'TempOrderCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'TempOrderCountableEdge', node: { __typename: 'TempOrder', id: string | null, createdAt: any | null, soNo: string | null, poNo: string | null, poNumber: string | null, company: { __typename: 'SapMigrationCompany', code: string | null, name: string | null } | null, contract: { __typename: 'TempContract', customer: { __typename: 'SoldToMaster', soldToCode: string | null, soldToName: string | null } | null } | null, orderLines: Array<{ __typename: 'TempOrderLine', id: string | null, sapConfirmStatus: string | null, itemNo: string | null, quantity: number | null, assignedQuantity: number | null, confirmQuantity: number | null, nonConfirmQuantity: number | null, salesUnit: string | null, requestDate: any | null, confirmedDate: any | null, variant: { __typename: 'TempProductVariant', descriptionTh: string | null } | null } | null> | null } }> } | null };

export type GetListCustomerOrderConfirmationQueryVariables = Exact<{
  sortBy?: InputMaybe<CustomerOrderConfirmationSortingInput>;
  filter?: InputMaybe<CustomerOrderConfirmationFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type GetListCustomerOrderConfirmationQuery = { __typename: 'Query', customerOrderConfirmation: { __typename: 'CustomerOrderCountTableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'CustomerOrderCountTableEdge', node: { __typename: 'CustomerOrder', id: string | null, createdAt: any | null, soNo: string | null, poNo: string | null, company: { __typename: 'CustomerCompany', name: string | null, code: string | null } | null, contract: { __typename: 'CustomerContract', soldTo: { __typename: 'SoldToMaster', soldToCode: string | null, soldToName: string | null } | null } | null, lines: Array<{ __typename: 'CustomerOrderLine', id: string | null, sapConfirmStatus: string | null, itemNo: string | null, quantity: number | null, assignedQuantity: number | null, confirmQuantity: number | null, nonConfirmQuantity: number | null, salesUnit: string | null, requestDeliveryDate: any | null, confirmedDate: any | null, variant: { __typename: 'CustomerProductVariant', descriptionTh: string | null } | null } | null> | null } }> } | null };

export type DistributionChannelsDomesticQueryVariables = Exact<{ [key: string]: never; }>;


export type DistributionChannelsDomesticQuery = { __typename: 'Query', distributionChannelsDomestic: Array<{ __typename: 'DistributionChannel', code: string | null, name: string | null } | null> | null };

export type DistributionChannelsExportQueryVariables = Exact<{ [key: string]: never; }>;


export type DistributionChannelsExportQuery = { __typename: 'Query', distributionChannelsExport: Array<{ __typename: 'DistributionChannel', code: string | null, name: string | null } | null> | null };

export type ListOrderConfirmationSapQueryVariables = Exact<{
  filter?: InputMaybe<SapOrderConfirmationInput>;
}>;


export type ListOrderConfirmationSapQuery = { __typename: 'Query', listOrderConfirmationSap: Array<{ __typename: 'SAPOrderConfirmation', contractName: string | null, contractNo: string | null, orderDate: string | null, shipToCode: string | null, isNotRef: boolean | null, paymentMethodName: string | null, poNo: string | null, salesOrgName: string | null, soNo: string | null, soldToName: string | null, orderLines: Array<{ __typename: 'SAPOrderConfirmationLineGroup', saleOrg: string | null, soldToCode: string | null, soldToName: string | null, status: string | null, itemNo: string | null, materialDescription: string | null, orderQty: string | null, confirmQuantity: string | null, nonConfirmQuantity: string | null, saleUnit: string | null, requestDate: string | null, confirmDate: string | null, remarkOrder: string | null, materialCode: string | null } | null> | null } | null> | null };

export type PrintPendingOrderReportMutationVariables = Exact<{
  input?: InputMaybe<SapPendingOrderReportInput>;
}>;


export type PrintPendingOrderReportMutation = { __typename: 'Mutation', printPendingOrderReport: { __typename: 'PrintPendingOrderReport', exportedFileBase64: string | null, fileName: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type DownloadPendingOrderReportMutationVariables = Exact<{
  input?: InputMaybe<SapPendingOrderReportInput>;
}>;


export type DownloadPendingOrderReportMutation = { __typename: 'Mutation', downloadPendingOrderReport: { __typename: 'DownloadPendingOrderReportExcel', exportedFileBase64: string | null, fileName: string | null } | null };

export type SendEmailPendingOrderMutationVariables = Exact<{
  listTo: Scalars['String'];
  listCc: Scalars['String'];
  subject: Scalars['String'];
  emailContent: Scalars['String'];
  input: SapPendingOrderReportInput;
  soldToCode: Scalars['String'];
}>;


export type SendEmailPendingOrderMutation = { __typename: 'Mutation', sendEmailPendingOrder: { __typename: 'SendEmailPendingOrder', status: string | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null }> } | null };

export type Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables = Exact<{
  filter?: InputMaybe<ReportOrderPendingSoldToFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type Suggestion_Search_Sold_To_Report_Order_PendingQuery = { __typename: 'Query', suggestionSearchSoldToReportOrderPending: { __typename: 'ReportOrderPendingSoldToCountTableConnection', edges: Array<{ __typename: 'ReportOrderPendingSoldToCountTableEdge', node: { __typename: 'ReportOrderPendingSoldTo', id: number | null, name: string | null, code: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables = Exact<{
  filter?: InputMaybe<SuggestionSearchMaterialGradeGramFilterInput>;
  materialGradeGram?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery = { __typename: 'Query', suggestionSearchMaterialNoGradeGramReportOrderPending: { __typename: 'MaterialVariantMasterCountTableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'MaterialVariantMasterCountTableEdge', node: { __typename: 'MaterialVariantMaster', code: string | null, descriptionEn: string | null } }> } | null };

export type SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestionSearchSalesOrganizationReportOrderPendingQuery = { __typename: 'Query', suggestionSearchSalesOrganizationReportOrderPending: Array<{ __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null> | null };

export type SuggestionSearchShipToReportOrderPendingQueryVariables = Exact<{
  shipToSearch?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SuggestionSearchShipToReportOrderPendingQuery = { __typename: 'Query', suggestionSearchShipToReportOrderPending: Array<{ __typename: 'ReportOrderPendingShipToItems', name: string | null, code: string | null } | null> | null };

export type ListOfSaleOrderPendingSapQueryVariables = Exact<{
  filter?: InputMaybe<SapListOfSaleOrderPendingInput>;
}>;


export type ListOfSaleOrderPendingSapQuery = { __typename: 'Query', listOfSaleOrderPendingSap: Array<{ __typename: 'SAPListOfSaleOrderPending', soldTo: string | null, soldToName: string | null, productGroups: Array<{ __typename: 'SAPListOfSaleOrderLineGroup', productGroup: string | null, materialGroup: string | null, orderLines: Array<{ __typename: 'SAPOrderLinePending', saleOrg: string | null, soldTo: string | null, shipTo: string | null, requestDate: string | null, orderDate: string | null, poNo: string | null, soNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, orderQty: string | null, pendingQty: string | null, atpQty: string | null, ctpQty: string | null, deliveryQty: string | null, saleUnit: string | null, shipToPoDate: string | null, confirmDate: string | null, bomFlag: boolean | null, parentItemNo: string | null } | null> | null, summary: Array<{ __typename: 'SAPListOfSaleOrderPendingSummary', orderQty: string | null, pendingQty: string | null, atpQty: string | null, ctpQty: string | null, deliveryQty: string | null, saleUnit: string | null } | null> | null } | null> | null } | null> | null };

export type GetEmailToAndCcBySoldToQueryVariables = Exact<{
  soldToCode: Scalars['String'];
  saleOrg: Scalars['String'];
  saleOrgList?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  productGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  bu: Scalars['String'];
}>;


export type GetEmailToAndCcBySoldToQuery = { __typename: 'Query', getEmailToAndCcBySoldTo: { __typename: 'EmailPendingOrder', soldToName: string | null, to: string | null, cc: string | null } | null };

export type SearchSuggestionDomesticShipTosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PendingOrderReportShipTosFilterInput>;
}>;


export type SearchSuggestionDomesticShipTosQuery = { __typename: 'Query', searchSuggestionDomesticShipTos: { __typename: 'SoldToPartnerAddressMasterCountableConnection', edges: Array<{ __typename: 'SoldToPartnerAddressMasterCountableEdge', node: { __typename: 'SoldToPartnerAddressMaster', partnerCode: string | null, displayCodeName: string | null } }> } | null };

export type UploadAlternativeMaterialsMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadAlternativeMaterialsMutation = { __typename: 'Mutation', uploadAlternativeMaterials: { __typename: 'UploadAlternativeMaterials', status: boolean | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, field: string | null }> } | null };

export type AddAlternativeMaterialMutationVariables = Exact<{
  input: AlternativeMaterialAddInput;
}>;


export type AddAlternativeMaterialMutation = { __typename: 'Mutation', addAlternativeMaterial: { __typename: 'AlternativeMaterialAdd', alternativeMaterials: { __typename: 'AlternativeMaterial', id: string | null, salesOrganization: { __typename: 'SalesOrganization', id: string | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null } | null } | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode, field: string | null }> } | null };

export type DeleteAlternativeMaterialMutationVariables = Exact<{
  alternativeMaterialOsId: Scalars['ID'];
}>;


export type DeleteAlternativeMaterialMutation = { __typename: 'Mutation', deleteAlternativeMaterialOs: { __typename: 'AlternativeMaterialOsDelete', status: string | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type ExportAlternativeMaterialMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportAlternativeMaterialMutation = { __typename: 'Mutation', exportAlternativeMaterial: { __typename: 'AlternativeMaterialExport', fileName: string | null, contentType: string | null, exportedFileBase64: string | null } | null };

export type ExportLogChangeMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportLogChangeMutation = { __typename: 'Mutation', exportLogChange: { __typename: 'AlternativeMaterialLogExport', fileName: string | null, contentType: string | null, exportedFileBase64: string | null } | null };

export type EditAlternativeMaterialMutationVariables = Exact<{
  id: Scalars['ID'];
  input: AlternativeMaterialEditInput;
}>;


export type EditAlternativeMaterialMutation = { __typename: 'Mutation', editAlternativeMaterial: { __typename: 'AlternativeMaterialEdit', errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode, field: string | null }>, alternativeMaterial: { __typename: 'AlternativeMaterial', id: string | null } | null } | null };

export type SalesOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesOrganizationsQuery = { __typename: 'Query', salesOrganizations: Array<{ __typename: 'SalesOrganization', code: string | null, label: string | null, value: string | null, businessUnit: { __typename: 'BusinessUnit', id: string | null, code: string | null } | null } | null> | null };

export type ScgSoldTosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ScgSoldTosFilterInput>;
}>;


export type ScgSoldTosQuery = { __typename: 'Query', scgSoldTos: { __typename: 'SoldToMasterCountableConnection', edges: Array<{ __typename: 'SoldToMasterCountableEdge', node: { __typename: 'SoldToMaster', code: string | null, name: string | null, id: string | null } }> } | null };

export type MaterialOwnQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TempProductFilterInput>;
  distributionChannelType: DistributionChannelType;
  bu?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
}>;


export type MaterialOwnQuery = { __typename: 'Query', materialAlter: { __typename: 'TempProductCountableConnection', edges: Array<{ __typename: 'TempProductCountableEdge', node: { __typename: 'MaterialInfo', id: string | null, code: string | null } }> } | null };

export type GradeGramQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TempProductFilterInput>;
  distributionChannelType: DistributionChannelType;
  bu?: InputMaybe<Scalars['String']>;
  saleOrg?: InputMaybe<Scalars['String']>;
}>;


export type GradeGramQuery = { __typename: 'Query', materialAlter: { __typename: 'TempProductCountableConnection', edges: Array<{ __typename: 'TempProductCountableEdge', node: { __typename: 'MaterialInfo', id: string | null, dia: string | null, code: string | null } }> } | null };

export type SuggestionSearchUserByNameQueryVariables = Exact<{
  filter?: InputMaybe<SuggestionSearchUserByNameFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionSearchUserByNameQuery = { __typename: 'Query', suggestionSearchUserByName: { __typename: 'UserCountableConnection', edges: Array<{ __typename: 'UserCountableEdge', node: { __typename: 'User', id: string, firstName: string, lastName: string } }> } | null };

export type AlternatedMaterialsQueryVariables = Exact<{
  filter?: InputMaybe<AlternatedMaterialFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<AlternatedMaterialSortInput>;
}>;


export type AlternatedMaterialsQuery = { __typename: 'Query', alternatedMaterials: { __typename: 'AlternatedMaterialCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null }, edges: Array<{ __typename: 'AlternatedMaterialCountableEdge', node: { __typename: 'ALternatedMaterial', id: string | null, quantityChangeOfRoll: number | null, quantityChangeOfTon: number | null, errorType: string | null, oldProduct: { __typename: 'MaterialInfo', name: string | null, code: string | null } | null, newProduct: { __typename: 'MaterialInfo', name: string | null, code: string | null } | null, orderLine: { __typename: 'TempOrderLine', plant: string | null, itemNo: string | null, quantity: number | null, requestDate: any | null, product: { __typename: 'TempProduct', name: string | null } | null, order: { __typename: 'TempOrder', poUploadFileName: string | null, poNumber: string | null, orderNo: string | null, soNo: string | null, requestDate: any | null, createdAt: any | null, updatedAt: any | null, customer: { __typename: 'SoldToMaster', name: string | null } | null, saleOrganization: { __typename: 'SalesOrganization', name: string | null, code: string | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null, createdBy: { __typename: 'User', lastName: string, firstName: string, email: string } | null, updateBy: { __typename: 'User', firstName: string, lastName: string } | null } | null } | null } }> } | null };

export type SuggestionSearchMaterialQueryVariables = Exact<{
  distributionChannelType: DistributionChannelType;
  filter?: InputMaybe<SuggestionMaterialFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  bu?: InputMaybe<Scalars['String']>;
}>;


export type SuggestionSearchMaterialQuery = { __typename: 'Query', suggestionSearchMaterial: { __typename: 'TempProductCountableConnection', edges: Array<{ __typename: 'TempProductCountableEdge', node: { __typename: 'MaterialInfo', id: string | null, code: string | null, name: string | null } }> } | null };

export type AlternativeMaterialsOsQueryVariables = Exact<{
  filter?: InputMaybe<AlterMaterialFilterInput>;
  sortBy?: InputMaybe<AlternativeMaterialOsInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type AlternativeMaterialsOsQuery = { __typename: 'Query', alternativeMaterialsOs: { __typename: 'AlternativeMaterialOsCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, lastUpdateDate: any | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'AlternativeMaterialOsCountableEdge', node: { __typename: 'AlternativeMaterialOs', id: string | null, diameter: string | null, priority: number, alternativeMaterial: { __typename: 'AlternativeMaterial', id: string | null, type: string | null, updatedAt: any, salesOrganization: { __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null, soldTo: { __typename: 'SoldToMaster', code: string | null, name: string | null } | null, materialOwn: { __typename: 'MaterialInfo', code: string | null, gram: string | null, grade: string | null, dia: string | null } | null, updatedBy: { __typename: 'User', firstName: string, lastName: string } | null } | null, materialOs: { __typename: 'MaterialInfo', code: string | null, dia: string | null } | null } }> } | null };

export type AlternativeMaterialDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AlternativeMaterialDetailQuery = { __typename: 'Query', alternativeMaterial: { __typename: 'AlternativeMaterial', id: string | null, type: string | null, materialOwn: { __typename: 'MaterialInfo', id: string | null, code: string | null } | null, salesOrganization: { __typename: 'SalesOrganization', id: string | null, name: string | null, code: string | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null, materialsOs: Array<{ __typename: 'AlternativeMaterialOs', id: string | null, diameter: string | null, priority: number, materialOs: { __typename: 'MaterialInfo', id: string | null, code: string | null } | null } | null> | null } | null };

export type DownloadPdfOrderMutationVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']>;
  soNo?: InputMaybe<Scalars['String']>;
  sortType: Scalars['String'];
}>;


export type DownloadPdfOrderMutation = { __typename: 'Mutation', downloadPdfOrder: { __typename: 'DownloadPDFOrder', exportedFileBase64: string | null, fileName: string | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type PrintChangeOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  sortType: Scalars['String'];
}>;


export type PrintChangeOrderMutation = { __typename: 'Mutation', printChangeOrder: { __typename: 'PrintOrder', exportedFileBase64: string | null, fileName: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename: 'Mutation', requestPasswordReset: { __typename: 'RequestPasswordReset', errors: Array<{ __typename: 'AccountError', code: AccountErrorCode, field: string | null, message: string | null }> } | null };

export type GenerateTokenMutationVariables = Exact<{
  idToken: Scalars['String'];
}>;


export type GenerateTokenMutation = { __typename: 'Mutation', generateToken: { __typename: 'GenerateTokenFromCognito', token: string | null, csrfToken: string | null, refreshToken: string | null, user: { __typename: 'User', id: string, email: string, lastName: string } | null, errors: Array<{ __typename: 'CognitoError', message: string | null, field: string | null, code: CognitoErrorCode }> } | null };

export type ScgpUserSendMailResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ScgpUserSendMailResetPasswordMutation = { __typename: 'Mutation', scgpUserSendMailResetPassword: { __typename: 'ScgpUserSendMailResetPassword', message: string | null, errors: Array<{ __typename: 'ScgpUserManagementError', field: string | null, message: string | null, code: ScgpUserManagementErrorCode }> } | null };

export type ScgpUserCheckValidTokenResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
}>;


export type ScgpUserCheckValidTokenResetPasswordMutation = { __typename: 'Mutation', scgpUserCheckValidTokenResetPassword: { __typename: 'ScgpUserCheckValidTokenResetPassword', email: string | null, token: string | null, errors: Array<{ __typename: 'ScgpUserManagementError', field: string | null, message: string | null, code: ScgpUserManagementErrorCode }> } | null };

export type ScgpUserConfirmResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
  new_password: Scalars['String'];
  confirm_password: Scalars['String'];
}>;


export type ScgpUserConfirmResetPasswordMutation = { __typename: 'Mutation', scgpUserConfirmResetPassword: { __typename: 'ScgpUserConfirmResetPassword', message: string | null, errors: Array<{ __typename: 'ScgpUserManagementError', field: string | null, message: string | null, code: ScgpUserManagementErrorCode }> } | null };

export type ScgpUserLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  cfTurnstileToken?: InputMaybe<Scalars['String']>;
}>;


export type ScgpUserLoginMutation = { __typename: 'Mutation', scgpUserLogin: { __typename: 'ScgpUserLogin', message: string | null, status: ScgpUserStatus | null, tempToken: string | null, username: string | null, token: string | null, csrfToken: string | null, refreshToken: string | null, errors: Array<{ __typename: 'AccountError', field: string | null, code: AccountErrorCode, message: string | null }> } | null };

export type ScgpUserFirstLoginUpdateMutationVariables = Exact<{
  username: Scalars['String'];
  tempToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  confirmPassword?: InputMaybe<Scalars['String']>;
}>;


export type ScgpUserFirstLoginUpdateMutation = { __typename: 'Mutation', scgpUserFirstLoginUpdate: { __typename: 'ScgpUserFirstLoginUpdate', message: string | null, status: ScgpUserStatus | null, tempToken: string | null, username: string | null, token: string | null, csrfToken: string | null, refreshToken: string | null, errors: Array<{ __typename: 'AccountError', code: AccountErrorCode, message: string | null, field: string | null }> } | null };

export type RefreshTokenMutationVariables = Exact<{
  csrfToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
}>;


export type RefreshTokenMutation = { __typename: 'Mutation', tokenRefresh: { __typename: 'RefreshToken', token: string | null, errors: Array<{ __typename: 'AccountError', field: string | null, code: AccountErrorCode, message: string | null }>, user: { __typename: 'User', id: string, email: string, lastName: string, isStaff: boolean } | null } | null };

export type AvailableExternalAuthenticationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableExternalAuthenticationsQuery = { __typename: 'Query', shop: { __typename: 'Shop', availableExternalAuthentications: Array<{ __typename: 'ExternalAuthentication', id: string, name: string | null }> } };

export type UserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQuery = { __typename: 'Query', me: { __typename: 'User', id: string, email: string, firstName: string, lastName: string, isStaff: boolean, displayName: string | null, isSuperuser: boolean | null, permissionGroups: Array<{ __typename: 'Group', name: string, id: string }> | null, userPermissions: Array<{ __typename: 'UserPermission', code: PermissionEnum, name: string }> | null, avatar: { __typename: 'Image', url: string } | null } | null };

export type UserCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCompanyQuery = { __typename: 'Query', scgpMe: { __typename: 'ScgpUser', soldTos: Array<{ __typename: 'SoldToMaster', id: string | null, soldToCode: string | null, soldToName: string | null, showPoUpload: boolean | null } | null> | null } | null };

export type DuplicateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateOrderMutation = { __typename: 'Mutation', duplicateOrder: { __typename: 'DuplicateOrder', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, order: { __typename: 'ExportOrderExtended', id: string | null, lines: { __typename: 'ExportOrderLineCountableConnection', edges: Array<{ __typename: 'ExportOrderLineCountableEdge', node: { __typename: 'ExportOrderLine', id: string | null, quantity: number | null } }> } | null } | null } | null };

export type CallApiSapRouteMutationVariables = Exact<{
  maxRecords: Scalars['Int'];
  piMessageId: Scalars['String'];
  route: Scalars['String'];
  routeDescription: Scalars['String'];
}>;


export type CallApiSapRouteMutation = { __typename: 'Mutation', callApiSapRoute: { __typename: 'CallAPISapRoute', response: { __typename: 'RouteType', piMessageId: string | null, status: string | null, reason: string | null, routeList: Array<{ __typename: 'RouteListType', route: string | null, routeDescription: string | null } | null> | null } | null } | null };

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelOrderMutation = { __typename: 'Mutation', cancelExportOrder: { __typename: 'CancelExportOrder', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, order: { __typename: 'ExportOrderExtended', status: string | null, id: string | null } | null } | null };

export type CancelRevertContractOrderLineMutationVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status?: InputMaybe<OrderLineStatus>;
}>;


export type CancelRevertContractOrderLineMutation = { __typename: 'Mutation', cancelRevertContractOrderLine: { __typename: 'CancelRevertContractOrderLine', orderline: Array<{ __typename: 'TempOrderLine', id: string | null } | null> | null } | null };

export type DeleteContractOrderLinesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteContractOrderLinesMutation = { __typename: 'Mutation', deleteContractOrderLines: { __typename: 'ContractOrderLinesDelete', errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type AddSplitOrderLineItemMutationVariables = Exact<{
  originLineItem?: InputMaybe<AddSplitOrderLineItemInput>;
  soNo?: InputMaybe<Scalars['String']>;
  splitLineItems?: InputMaybe<Array<AddSplitOrderLineItemInput> | AddSplitOrderLineItemInput>;
}>;


export type AddSplitOrderLineItemMutation = { __typename: 'Mutation', addSplitOrderLineItem: { __typename: 'AddSplitOrderLineItem', status: boolean | null, errors: Array<{ __typename: 'ContractCheckoutError', code: ContractCheckoutErrorCode, field: string | null, message: string | null }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null } | null };

export type UpdateAtpCtpContractOrderLineMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpdateAtpCtpContractOrderLineInput>> | InputMaybe<UpdateAtpCtpContractOrderLineInput>>;
}>;


export type UpdateAtpCtpContractOrderLineMutation = { __typename: 'Mutation', updateAtpCtpContractOrderLine: { __typename: 'UpdateAtpCtpContractOrderLine', status: boolean | null } | null };

export type SendOrderEmailMutationVariables = Exact<{
  cc: Scalars['String'];
  content: Scalars['String'];
  orders?: InputMaybe<Array<InputMaybe<SendEmailOrderInput>> | InputMaybe<SendEmailOrderInput>>;
  subject: Scalars['String'];
  to: Scalars['String'];
  reportLanguage?: InputMaybe<Scalars['String']>;
}>;


export type SendOrderEmailMutation = { __typename: 'Mutation', sendOrderEmail: { __typename: 'SendOrderEmail', status: string | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode, field: string | null }> } | null };

export type CancelDeleteOrderLinesMutationVariables = Exact<{
  orderLines?: InputMaybe<Array<InputMaybe<CancelDeleteOrderLinesInput>> | InputMaybe<CancelDeleteOrderLinesInput>>;
  soNo: Scalars['String'];
}>;


export type CancelDeleteOrderLinesMutation = { __typename: 'Mutation', cancelDeleteOrderLines: { __typename: 'CancelDeleteOrderLines', status: boolean | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode, field: string | null }>, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null } | null };

export type ChangeOrderAddNewOrderLineMutationVariables = Exact<{
  input: ChangeOrderAddNewOrderLineInput;
}>;


export type ChangeOrderAddNewOrderLineMutation = { __typename: 'Mutation', changeOrderAddNewOrderLine: { __typename: 'ChangeOrderAddNewOrderLine', success: boolean | null, isRedirectPreview: boolean | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, iplanConfirmFailedErrors: Array<{ __typename: 'Error', field: string | null, message: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ContractCheckoutError', code: ContractCheckoutErrorCode, field: string | null, message: string | null }> } | null };

export type ChangeOrderUpdateMutationVariables = Exact<{
  input: ChangeOrderEditInput;
  soNo: Scalars['ID'];
}>;


export type ChangeOrderUpdateMutation = { __typename: 'Mutation', changeOrderUpdate: { __typename: 'ChangeOrderUpdate', success: boolean | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }>, order: { __typename: 'TempOrder', id: string | null } | null, sapWarningMessages: Array<{ __typename: 'WarningMessage', order: string | null, source: string | null, message: string | null } | null> | null, iplanConfirmFailedErrors: Array<{ __typename: 'Error', field: string | null, message: string | null } | null> | null } | null };

export type UndoOrderLinesMutationVariables = Exact<{
  itemNo: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  soNo: Scalars['String'];
}>;


export type UndoOrderLinesMutation = { __typename: 'Mutation', undoOrderLines: { __typename: 'UndoOrderLines', success: boolean | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null } | null };

export type DeleteNewlyAddedOrderLineMutationVariables = Exact<{
  soNo?: InputMaybe<Scalars['String']>;
  listItemNo?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type DeleteNewlyAddedOrderLineMutation = { __typename: 'Mutation', deleteNewlyAddedOrderLine: { __typename: 'DeleteNewlyAddedOrderLineDelete', status: string | null } | null };

export type CheckContractExpiredCompleteInvalidMutationVariables = Exact<{
  contractNo: Scalars['String'];
}>;


export type CheckContractExpiredCompleteInvalidMutation = { __typename: 'Mutation', checkContractExpiredCompleteInvalid: { __typename: 'CheckContractExpiredCompleteInvalid', isInvalid: boolean | null } | null };

export type ShowAtpCtpPopupQueryVariables = Exact<{
  lineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type ShowAtpCtpPopupQuery = { __typename: 'Query', showAtpCtpPopup: { __typename: 'ShowATPCTPPopup', status: boolean | null, itemErrors: Array<string | null> | null, flag: string | null } | null };

export type FilterSoldToDomesticOrderQueryVariables = Exact<{
  filter?: InputMaybe<DomesticSoldToFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterSoldToDomesticOrderQuery = { __typename: 'Query', filterSoldToDomesticOrder: { __typename: 'DomesticSoldToCountableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'DomesticSoldToCountableEdge', node: { __typename: 'SoldToMaster', name: string | null, code: string | null } }> } | null };

export type FilterSaleEmployeeDomesticOrderQueryVariables = Exact<{
  filter?: InputMaybe<DomesticSaleEmployeeFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterSaleEmployeeDomesticOrderQuery = { __typename: 'Query', filterSaleEmployeeDomesticOrder: { __typename: 'DomesticSaleEmployeeCountableConnection', edges: Array<{ __typename: 'DomesticSaleEmployeeCountableEdge', node: { __typename: 'SalesEmployee', name: string | null, code: string | null } }> } | null };

export type DomesticOrderTypeQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type DomesticOrderTypeQuery = { __typename: 'Query', domesticOrderType: { __typename: 'TempOrderCountableConnection', edges: Array<{ __typename: 'TempOrderCountableEdge', node: { __typename: 'TempOrder', orderType: string | null } }> } | null };

export type DomesticOrdersQueryVariables = Exact<{
  sortBy?: InputMaybe<DomesticOrderSortingInput>;
  filter?: InputMaybe<DomesticOrderFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type DomesticOrdersQuery = { __typename: 'Query', domesticOrders: { __typename: 'TempOrderCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'TempOrderCountableEdge', node: { __typename: 'TempOrder', id: string | null, soNo: string | null, poNumber: string | null, contractPiNo: string | null, paymentTerm: string | null, creditStatus: string | null, orderDate: any | null, statusSap: string | null, status: string | null, soldTo: { __typename: 'SoldToMaster', displayText: string | null } | null, contract: { __typename: 'TempContract', projectName: string | null, contractNo: string | null, paymentTermKey: string | null, customer: { __typename: 'SoldToMaster', displayText: string | null } | null } | null, company: { __typename: 'SapMigrationCompany', name: string | null, code: string | null } | null } }> } | null };

export type FieldOrderLinesFragment = { __typename: 'TempOrderLine', id: string | null, shippingMark: string | null, paymentTerm: string | null, itemNo: string | null, prcGroup1: string | null, inquiryMethod: string | null, requestDate: any | null, requestDateChangeReason: string | null, confirmedDate: any | null, quantity: number | null, unit: string | null, weight: number | null, weightUnit: string | null, plant: string | null, price: number | null, netPrice: number | null, priceCurrency: string | null, paymentCondition: string | null, itemCategory: string | null, shippingPoint: string | null, route: string | null, poNo: string | null, poNoExternal: string | null, poDate: any | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: boolean | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, internalCommentsToLogistic: string | null, productInformation: string | null, status: string | null, product: { __typename: 'TempProduct', id: string | null, code: string | null, description: string | null, salesUnit: string | null } | null, iplan: { __typename: 'OrderLineIPlan', atpCtp: string | null, atpCtpDetail: string | null, block: string | null, run: string | null, paperMachine: string | null, iplantConfirmQuantity: number | null, salesUnit: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, weight: string | null, code: string | null, descriptionEn: string | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null, remain: number | null, price: number | null, currency: string | null } | null };

export type ContractOrderDomesticQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type ContractOrderDomesticQuery = { __typename: 'Query', contractOrder: { __typename: 'TempOrder', id: string | null, soNo: string | null, orderType: string | null, orderTypeDesc: string | null, poNumber: string | null, status: string | null, soldToAddress: string | null, orderAmtBeforeVat: string | null, orderAmtVat: string | null, orderAmtAfterVat: string | null, itemCategory: string | null, routeId: string | null, routeName: string | null, salesGroup: string | null, untimatedTol: string | null, billTo: string | null, taxPercent: number | null, shipTo: string | null, poDate: any | null, requestDate: any | null, paymentTerm: string | null, dpNo: string | null, invoiceNo: string | null, deliveryBlock: string | null, incoterm: string | null, route: string | null, shippingPoint: string | null, internalCommentsToLogistic: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, productInformation: string | null, customer: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, soldToCode: string | null, soldToName: string | null, displayText: string | null, addressText: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', streetAddress1: string, streetAddress2: string }> | null } | null> | null } | null, contract: { __typename: 'TempContract', id: string | null, contractNo: string | null, billTo: string | null, currency: string | null, shipTo: string | null, paymentTerm: string | null, projectName: string | null, customer: { __typename: 'SoldToMaster', soldToName: string | null, soldToCode: string | null, displayText: string | null, addressText: string | null } | null } | null, soldTo: { __typename: 'SoldToMaster', displayText: string | null, addressText: string | null } | null, customerGroup: { __typename: 'CustomerGroupMaster', id: string | null, code: string | null, name: string | null } | null, customerGroup1: { __typename: 'CustomerGroup1Master', id: string | null, code: string | null, name: string | null } | null, customerGroup2: { __typename: 'CustomerGroup2Master', id: string | null, code: string | null, name: string | null } | null, customerGroup3: { __typename: 'CustomerGroup3Master', id: string | null, code: string | null, name: string | null } | null, customerGroup4: { __typename: 'CustomerGroup4Master', id: string | null, code: string | null, name: string | null } | null, incoterms1: { __typename: 'Incoterms1Master', id: string | null, code: string | null, description: string | null } | null, saleOrganization: { __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null, saleGroup: { __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null, saleOffice: { __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null, division: { __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null, distributionChannel: { __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null, orderLines: Array<{ __typename: 'TempOrderLine', id: string | null, shippingMark: string | null, paymentTerm: string | null, itemNo: string | null, prcGroup1: string | null, inquiryMethod: string | null, requestDate: any | null, requestDateChangeReason: string | null, confirmedDate: any | null, quantity: number | null, unit: string | null, weight: number | null, weightUnit: string | null, plant: string | null, price: number | null, netPrice: number | null, priceCurrency: string | null, paymentCondition: string | null, itemCategory: string | null, shippingPoint: string | null, route: string | null, poNo: string | null, poNoExternal: string | null, poDate: any | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: boolean | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, internalCommentsToLogistic: string | null, productInformation: string | null, status: string | null, splitItems: Array<{ __typename: 'TempOrderLine', id: string | null, shippingMark: string | null, paymentTerm: string | null, itemNo: string | null, prcGroup1: string | null, inquiryMethod: string | null, requestDate: any | null, requestDateChangeReason: string | null, confirmedDate: any | null, quantity: number | null, unit: string | null, weight: number | null, weightUnit: string | null, plant: string | null, price: number | null, netPrice: number | null, priceCurrency: string | null, paymentCondition: string | null, itemCategory: string | null, shippingPoint: string | null, route: string | null, poNo: string | null, poNoExternal: string | null, poDate: any | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: boolean | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, internalCommentsToLogistic: string | null, productInformation: string | null, status: string | null, product: { __typename: 'TempProduct', id: string | null, code: string | null, description: string | null, salesUnit: string | null } | null, iplan: { __typename: 'OrderLineIPlan', atpCtp: string | null, atpCtpDetail: string | null, block: string | null, run: string | null, paperMachine: string | null, iplantConfirmQuantity: number | null, salesUnit: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, weight: string | null, code: string | null, descriptionEn: string | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null, remain: number | null, price: number | null, currency: string | null } | null } | null> | null, product: { __typename: 'TempProduct', id: string | null, code: string | null, description: string | null, salesUnit: string | null } | null, iplan: { __typename: 'OrderLineIPlan', atpCtp: string | null, atpCtpDetail: string | null, block: string | null, run: string | null, paperMachine: string | null, iplantConfirmQuantity: number | null, salesUnit: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, weight: string | null, code: string | null, descriptionEn: string | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null, remain: number | null, price: number | null, currency: string | null } | null } | null> | null } | null };

export type CashSaleResponseFragment = { __typename: 'CashSaleResponse', id: string | null, arAmount: number | null, cashFlag: boolean | null, cashAmount: number | null, balanceFlag: boolean | null, balanceAmount: number | null, feeAmount: number | null, feeType: string | null, feeAbsorbFlag: boolean | null, withHoldTax: number | null, remark: string | null, files: Array<{ __typename: 'CashSaleFileResponse', id: string | null, fileName: string | null, fileSize: number | null, documentType: string | null, paymentMethod: string | null } | null> | null };

export type ContractChangeOrderDomesticQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type ContractChangeOrderDomesticQuery = { __typename: 'Query', changeOrder: { __typename: 'ChangeOrder', orderId: string | null, poDate: string | null, orderType: string | null, orderTypeDesc: string | null, itemNoLatest: string | null, assignedQty: string | null, contractNo: string | null, currency: string | null, customerGroup: string | null, customerGroup1: string | null, customerGroup1Name: string | null, customerGroup2: string | null, customerGroup2Name: string | null, customerGroup3: string | null, customerGroup3Name: string | null, customerGroup4: string | null, customerGroup4Name: string | null, customerGroupName: string | null, deliveryBlock: string | null, distributionChannel: string | null, distributionChannelName: string | null, division: string | null, divisionName: string | null, incoterms1: string | null, incoterms1Name: string | null, incoterms2: string | null, incoterms2Name: string | null, orderAmtAfterVat: string | null, orderAmtBeforeVat: string | null, orderAmtVat: string | null, orderDate: string | null, overTol: string | null, underTol: string | null, paymentTerms: string | null, poNo: string | null, priceDate: string | null, requestDate: string | null, salesGroup: string | null, salesGroupName: string | null, salesOff: string | null, salesOffName: string | null, salesOrg: string | null, salesOrgName: string | null, salesOrgShortName: string | null, soNo: string | null, status: string | null, dp: Array<{ __typename: 'DPNo', dpNo: string | null } | null> | null, invoice: Array<{ __typename: 'InvoiceNo', invoiceNo: string | null } | null> | null, orderCondition: Array<{ __typename: 'OrderCondition', itemNo: string | null, conditionBaseValue: string | null, conditionPriceOrder: string | null, conditionType: string | null, conditionPriceUnit: string | null, conditionRate: string | null, conditionUnit: string | null, currency: string | null } | null> | null, orderItems: Array<{ __typename: 'OrderItems', weightUnit: string | null, grossWeightTon: number | null, netWeightTon: number | null, weightUnitTon: string | null, allowChangeInquiryMethod: boolean | null, itemStatusEn: string | null, itemStatusEnDisplayText: string | null, inquiryMethod: string | null, orderType: string | null, originalRequestDate: string | null, assignQuantity: number | null, confirmedDate: string | null, poDate: string | null, reasonReject: string | null, comfirmQty: string | null, contractItemNo: string | null, contractNo: string | null, deliveryQty: string | null, deliveryStatus: string | null, itemCategory: string | null, id: string | null, itemNo: string | null, itemQty: string | null, material: string | null, materialDesc: string | null, materialGroup1: string | null, materialGroup1Desc: string | null, netPrice: number | null, orderQty: string | null, paymentTerm: string | null, paymentTermDescTh: string | null, plant: string | null, poNumber: string | null, poSubcontract: string | null, prNo: string | null, prItem: string | null, prdHierachy: string | null, requestedDate: string | null, routeId: string | null, routeName: string | null, saleQtyDivision: string | null, saleQtyFactor: string | null, saleText1Th: string | null, salesUnit: string | null, shippingPoint: string | null, shipTo: string | null, untimatedTol: string | null, weightPerUnit: string | null, atp: string | null, atpDetails: string | null, block: string | null, run: string | null, paperMachine: string | null, remainWeight: number | null, weight: number | null, weightDisplay: string | null, productMaterial: string | null, internalCommentsToLogistic: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, product_Information: string | null, contractProductId: string | null, deliveryTolUnlimited: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, flagR5: boolean | null, requestDateChangeReason: string | null, sapConfirmStatus: string | null, shippingMark: string | null } | null> | null, orderPartners: Array<{ __typename: 'OrderPartners', addrLink: string | null, itemNo: string | null, partnerNo: string | null, partnerRole: string | null, address: Array<{ __typename: 'PartnersAddress', addrNo: string | null, city: string | null, country: string | null, district: string | null, name: string | null, postCode: string | null, street: string | null, transpzone: string | null, strSuppl1: string | null, strSuppl2: string | null, strSuppl3: string | null, location: string | null } | null> | null } | null> | null, orderText: Array<{ __typename: 'OrderText', itemNo: string | null, language: string | null, textId: string | null, textLine: Array<{ __typename: 'TextLine', text: string | null } | null> | null } | null> | null, cashSale: { __typename: 'CashSaleResponse', id: string | null, arAmount: number | null, cashFlag: boolean | null, cashAmount: number | null, balanceFlag: boolean | null, balanceAmount: number | null, feeAmount: number | null, feeType: string | null, feeAbsorbFlag: boolean | null, withHoldTax: number | null, remark: string | null, files: Array<{ __typename: 'CashSaleFileResponse', id: string | null, fileName: string | null, fileSize: number | null, documentType: string | null, paymentMethod: string | null } | null> | null } | null } | null };

export type GetCustomerGroupMasterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerGroupMasterQuery = { __typename: 'Query', customerGroup1: Array<{ __typename: 'CustomerGroup1Master', id: string | null, code: string | null, name: string | null } | null> | null, customerGroup2: Array<{ __typename: 'CustomerGroup2Master', id: string | null, code: string | null, name: string | null } | null> | null, customerGroup3: Array<{ __typename: 'CustomerGroup3Master', id: string | null, code: string | null, name: string | null } | null> | null, customerGroup4: Array<{ __typename: 'CustomerGroup4Master', id: string | null, code: string | null, name: string | null } | null> | null };

export type GetCreditLimitQueryVariables = Exact<{
  input?: InputMaybe<CreditLimitInput>;
}>;


export type GetCreditLimitQuery = { __typename: 'Query', getCreditLimit: { __typename: 'CreditLimit', creditControlArea: string | null, creditLimit: string | null, creditAccount: string | null, creditLimitUsed: string | null, receivables: string | null, specialLiabil: string | null, saleValue: string | null, creditExposure: string | null, secondReceivables: string | null, creditAvaiable: string | null, currency: string | null, creditBlockStatus: boolean | null } | null };

export type GetIncotermQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncotermQuery = { __typename: 'Query', incoterms1: Array<{ __typename: 'Incoterms1Master', id: string | null, code: string | null, description: string | null } | null> | null };

export type GetOrderEmailToAndCcQueryVariables = Exact<{
  bu?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  saleOrg?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  soNo?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetOrderEmailToAndCcQuery = { __typename: 'Query', getOrderEmailToAndCc: { __typename: 'OrderEmailRecipient', to: string | null, cc: string | null } | null };

export type SapChangeOrderQueryVariables = Exact<{
  filter?: InputMaybe<SapChangeOrderInput>;
}>;


export type SapChangeOrderQuery = { __typename: 'Query', sapChangeOrder: Array<{ __typename: 'SAPChangeOrder', soNo: string | null, contractNo: string | null, poNo: string | null, soldToParty: string | null, shipTo: string | null, country: string | null, incoterm: string | null, payment: string | null, bu: string | null, projectName: string | null, company: string | null, paymentTerms: string | null, creditStatusOfDocument: string | null, orderDate: string | null, orderStatusSap: string | null, orderStatusEOrdering: string | null, soldToCode: string | null, salesOrgCode: string | null, isNotRef: boolean | null, cashSale: { __typename: 'CashSaleStatusResponse', status: boolean | null, message: string | null, cashSaleStatus: string | null, statusName: string | null } | null } | null> | null };

export type UpdateInquiryMethodExportMutationVariables = Exact<{
  orderLineId: Scalars['ID'];
  input: UpdateInquiryMethodExportInput;
}>;


export type UpdateInquiryMethodExportMutation = { __typename: 'Mutation', updateInquiryMethodExport: { __typename: 'UpdateInquiryMethodExport', orderLine: { __typename: 'ExportOrderLine', id: string | null, inquiryMethod: string | null } | null } | null };

export type AtpctpConfirmMutationMutationVariables = Exact<{
  input: AtpctpConfirmInputType;
}>;


export type AtpctpConfirmMutationMutation = { __typename: 'Mutation', atpCtpConfirm: { __typename: 'ATPCTPConfirmMutation', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type CheckoutAtpctpConfirmMutationMutationVariables = Exact<{
  input: CheckoutAtpctpConfirmInputType;
}>;


export type CheckoutAtpctpConfirmMutationMutation = { __typename: 'Mutation', checkoutAtpCtpConfirm: { __typename: 'CheckoutChangeOrderATPCTPConfirmMutation', items: Array<{ __typename: 'CheckoutATPCTPConfirmItemOutputType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, action: AtpctpActionType | null, calculatedItemNo: string | null, listItems: Array<{ __typename: 'CheckoutATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null } | null> | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type CheckoutAtpctpRequestMutationMutationVariables = Exact<{
  input: Array<CheckoutAtpctpRequestOrderLineInput> | CheckoutAtpctpRequestOrderLineInput;
}>;


export type CheckoutAtpctpRequestMutationMutation = { __typename: 'Mutation', checkoutAtpCtpRequest: { __typename: 'CheckoutChangeOrderATPCTPRequestMutation', items: Array<{ __typename: 'CheckoutATPCTPRequestResultType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, listItems: Array<{ __typename: 'CheckoutATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null }> | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, itemsFailed: Array<{ __typename: 'CheckoutATPCTPRequestResultType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, listItems: Array<{ __typename: 'CheckoutATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null }> | null } | null };

export type AddProductsToChangeExportOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: Array<ChangeExportOrderLineAddProductInput> | ChangeExportOrderLineAddProductInput;
}>;


export type AddProductsToChangeExportOrderMutation = { __typename: 'Mutation', addProductsToChangeExportOrder: { __typename: 'ChangeExportOrderAddProducts', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, result: Array<{ __typename: 'ExportOrderLine', id: string | null, materialCode: string | null, materialDescription: string | null, quantity: number | null, quantityUnit: string | null, weight: number | null, weightUnit: string | null, itemCatEo: string | null, netPrice: number | null, plant: string | null, refPiNo: string | null, route: string | null, conditionGroup1: string | null, materialGroup2: string | null, commissionPercent: number | null, commissionAmount: number | null, commissionUnit: string | null, rollDiameter: string | null, rollCoreDiameter: string | null, noOfRolls: string | null, rollPerPallet: string | null, palletSize: string | null, palletNo: string | null, noOfPackage: string | null, packingList: string | null, shippingPoint: string | null, remark: string | null, rejectReason: string | null, inquiryMethod: string | null, piProduct: { __typename: 'ContractMaterial', id: string | null, pricePerUnit: number | null, remainingQuantity: number | null, contract: { __typename: 'SapContract', currency: string | null } | null } | null } | null> | null } | null };

export type UpdateExportOrderLinesDraftMutationVariables = Exact<{
  input: ExportOrderUpdateDraftInput;
}>;


export type UpdateExportOrderLinesDraftMutation = { __typename: 'Mutation', updateExportOrderLinesDraft: { __typename: 'ExportOrderLineUpdateDraft', status: boolean | null, orderLines: Array<{ __typename: 'ExportOrderLine', id: string | null, quantity: number | null } | null> | null } | null };

export type ExportOrderAtpCtpRequestMutationVariables = Exact<{
  input: Array<ExportAtpctpRequestOrderLineInput> | ExportAtpctpRequestOrderLineInput;
}>;


export type ExportOrderAtpCtpRequestMutation = { __typename: 'Mutation', exportOrderAtpCtpRequest: { __typename: 'ExportChangeOrderATPCTPRequestMutation', items: Array<{ __typename: 'ExportATPCTPRequestResultType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, listItems: Array<{ __typename: 'ExportATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null }> | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, itemsFailed: Array<{ __typename: 'ExportATPCTPRequestResultType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, listItems: Array<{ __typename: 'ExportATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null }> | null } | null };

export type ExportOrderAtpCtpConfirmMutationVariables = Exact<{
  input: ExportAtpctpConfirmInputType;
}>;


export type ExportOrderAtpCtpConfirmMutation = { __typename: 'Mutation', exportOrderAtpCtpConfirm: { __typename: 'ExportChangeOrderATPCTPConfirmMutation', items: Array<{ __typename: 'ExportATPCTPConfirmItemOutputType', lineId: string | null, originalItemNo: string, materialVariantCode: string, materialVariantDescription: string | null, originalQuantity: number, originalRequestDate: string, originalPlant: string | null, orderNo: string | null, action: AtpctpActionType | null, calculatedItemNo: string | null, listItems: Array<{ __typename: 'ExportATPCTPItemBaseListItemOutput', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null } | null> | null } | null> | null, iPlanErrorMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapOrderErrorMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type ExportChangeOrderAddNewOrderLineMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ExportAddNewOrderLineInput;
}>;


export type ExportChangeOrderAddNewOrderLineMutation = { __typename: 'Mutation', exportChangeOrderAddNewOrderLines: { __typename: 'ExportChangeOrderAddNewOrderLine', success: boolean | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null, soNo: string | null } | null> | null } | null };

export type CancelDeleteExportOrderMutationVariables = Exact<{
  itemNos?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  reason: ExportOrderReasonForRejectInput;
  soNo?: InputMaybe<Scalars['String']>;
}>;


export type CancelDeleteExportOrderMutation = { __typename: 'Mutation', cancelDeleteExportOrder: { __typename: 'CancelDeleteExportOrder', iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null, soNo: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type UndoOrderLinesExportMutationVariables = Exact<{
  itemNo: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  soNo: Scalars['String'];
}>;


export type UndoOrderLinesExportMutation = { __typename: 'Mutation', undoOrderLinesExport: { __typename: 'UndoOrderLinesExport', success: boolean | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ScgpExportError', message: string | null, code: ScgpExportErrorCode }> } | null };

export type EditOrderExportMutationVariables = Exact<{
  input: EditExportOrderInput;
}>;


export type EditOrderExportMutation = { __typename: 'Mutation', editOrderExport: { __typename: 'EditExportOrderMutation', success: boolean | null, iplanMessages: Array<{ __typename: 'IPlanYT65156Message', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, sapWarningMessages: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type DeleteExportOrderLineDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteExportOrderLineDraftMutation = { __typename: 'Mutation', deleteExportOrderLineDraft: { __typename: 'DeleteExportOrderLineDraft', success: boolean | null, errors: Array<{ __typename: 'ScgpExportError', message: string | null, field: string | null, code: ScgpExportErrorCode }> } | null };

export type SuggestionShipToChangeOrderSearchQueryVariables = Exact<{
  filter?: InputMaybe<ChangeOrderShipToFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionShipToChangeOrderSearchQuery = { __typename: 'Query', suggestionShipToChangeOrderSearch: { __typename: 'SoldToPartnerAddressMasterCountableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'SoldToPartnerAddressMasterCountableEdge', node: { __typename: 'SoldToPartnerAddressMaster', displayCodeName: string | null, partnerCode: string | null } }> } | null };

export type SuggestionSoldToChangeOrderSearchQueryVariables = Exact<{
  filter?: InputMaybe<ChangeOrderSoldToFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SuggestionSoldToChangeOrderSearchQuery = { __typename: 'Query', suggestionSoldToChangeOrderSearch: { __typename: 'SoldToPartnerAddressMasterCountableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'SoldToPartnerAddressMasterCountableEdge', node: { __typename: 'SoldToPartnerAddressMaster', partnerCode: string | null, displayCodeName: string | null } }> } | null };

export type FilterCompaniesExportOrderByBusinessUnitQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExportCompaniesFilterInput>;
}>;


export type FilterCompaniesExportOrderByBusinessUnitQuery = { __typename: 'Query', filterCompaniesExportOrderByBusinessUnit: { __typename: 'SalesOrganizationCountTableConnection', edges: Array<{ __typename: 'SalesOrganizationCountTableEdge', node: { __typename: 'SalesOrganizationMaster', label: string | null, value: string | null } }> } | null };

export type FilterCompaniesExportOrderByUserLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterCompaniesExportOrderByUserLoginQuery = { __typename: 'Query', filterCompaniesExportOrderByUserLogin: Array<{ __typename: 'SalesOrganization', label: string | null, value: string | null } | null> | null };

export type FilterBusinessExportOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterBusinessExportOrderQuery = { __typename: 'Query', filterBusinessExportOrder: Array<{ __typename: 'BusinessUnit', label: string | null, value: string | null } | null> | null };

export type ExportOrdersQueryVariables = Exact<{
  sortBy?: InputMaybe<ExportOrderSortingInput>;
  filter?: InputMaybe<ExportOrderFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type ExportOrdersQuery = { __typename: 'Query', exportOrders: { __typename: 'ExportOrderCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string | null, startCursor: string | null }, edges: Array<{ __typename: 'ExportOrderCountableEdge', node: { __typename: 'ExportOrder', id: string | null, eoNo: string | null, poNo: string | null, shipTo: string | null, incoterm: string | null, statusSap: string | null, status: string | null, createdAt: any | null, pi: { __typename: 'SapContract', code: string | null, paymentTerm: string | null, shipToCountry: string | null, soldTo: { __typename: 'SoldToMaster', name: string | null, code: string | null } | null } | null, salesOrganization: { __typename: 'SalesOrganizationMaster', name: string | null, code: string | null, businessUnit: { __typename: 'BusinessUnits', name: string | null } | null } | null } }> } | null };

export type ExportOrderWithAllItemsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ExportOrderWithAllItemsQuery = { __typename: 'Query', exportOrderWithAllItems: { __typename: 'ExportOrderWithAllOrderLine', id: string | null, paymentTerm: string | null, eoNo: string | null, soNo: string | null, contractType: string | null, soldToAddress: string | null, taxPercent: number | null, orderType: string | null, poDate: any | null, poNo: string | null, requestDate: any | null, refPiNo: string | null, netPrice: number | null, docCurrency: string | null, usage: string | null, unloadingPoint: string | null, placeOfDelivery: string | null, portOfDischarge: string | null, portOfLoading: string | null, noOfContainers: string | null, shippingMark: string | null, uom: string | null, gwUom: string | null, etd: string | null, eta: string | null, dlcNo: string | null, dlcExpiryDate: any | null, dlcLatestDeliveryDate: any | null, description: string | null, payer: string | null, endCustomer: string | null, contactPerson: string | null, salesEmployee: string | null, author: string | null, taxAmount: number | null, totalPrice: number | null, shipTo: string | null, billTo: string | null, paymentInstruction: string | null, remark: string | null, productionInformation: string | null, internalCommentToWarehouse: string | null, status: string | null, pi: { __typename: 'SapContract', id: string | null, placeOfDelivery: string | null, currency: string | null, shipTo: string | null, billTo: string | null, paymentTerm: string | null, etd: any | null, eta: any | null, code: string | null, poNo: string | null, incoterm: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, displayText: string | null, addressText: string | null, code: string | null } | null, salesOrganization: { __typename: 'SalesOrganizationMaster', id: string | null, code: string | null, name: string | null } | null, distributionChannel: { __typename: 'DistributionChannelMaster', id: string | null, code: string | null, name: string | null } | null, division: { __typename: 'DivisionMaster', id: string | null, code: string | null, name: string | null } | null, salesOffice: { __typename: 'SalesOfficeMaster', id: string | null, code: string | null, name: string | null } | null, salesGroup: { __typename: 'SalesGroupMaster', id: string | null, code: string | null, name: string | null } | null } | null, salesOrganization: { __typename: 'SalesOrganizationMaster', code: string | null, name: string | null, id: string | null } | null, distributionChannel: { __typename: 'DistributionChannelMaster', code: string | null, name: string | null, id: string | null } | null, division: { __typename: 'DivisionMaster', code: string | null, name: string | null, id: string | null } | null, salesOffice: { __typename: 'SalesOfficeMaster', code: string | null, name: string | null, id: string | null } | null, salesGroup: { __typename: 'SalesGroupMaster', code: string | null, name: string | null, id: string | null } | null, lines: Array<{ __typename: 'ExportOrderLine', id: string | null, itemNo: number | null, materialCode: string | null, materialDescription: string | null, isMaterialOutsource: boolean | null, quantity: number | null, quantityUnit: string | null, weight: number | null, weightUnit: string | null, salesUnit: string | null, itemCatEo: string | null, plant: string | null, refPiNo: string | null, requestDate: any | null, confirmedDate: any | null, rejectReason: string | null, conditionGroup1: string | null, route: string | null, rollQuantity: string | null, rollDiameter: string | null, rollCoreDiameter: string | null, remark: string | null, palletSize: string | null, palletNo: string | null, rollPerPallet: string | null, packageQuantity: string | null, packingList: string | null, commissionPercent: number | null, commissionAmount: number | null, commissionUnit: string | null, shippingPoint: string | null, deliveryTolOver: number | null, deliveryTolUnder: number | null, deliveryTolUnlimited: boolean | null, materialGroup2: string | null, inquiryMethod: string | null, piProduct: { __typename: 'ContractMaterial', id: string | null, materialCode: string | null, pricePerUnit: number | null, matGroup1: string | null, currency: string | null, remainingQuantity: number | null, remainingQuantityEx: number | null, limitQuantity: number | null, weight: number | null, weightUnit: string | null, calculation: string | null, product: { __typename: 'MaterialMaster', materialGroup: string | null, widthOfRoll: string | null, lengthOfRoll: string | null, id: string | null, name: string | null, salesUnit: string | null, slug: string | null } | null } | null } | null> | null } | null };

export type ContractExportOrderAllItemBySoNoQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type ContractExportOrderAllItemBySoNoQuery = { __typename: 'Query', exportOrderWithAllItemsBySoNo: { __typename: 'ExportOrderAllItemBySoNo', orderStatus: string | null, poDate: string | null, eoNo: string | null, contractNo: string | null, taxPercent: number | null, orderType: string | null, salesOrg: string | null, distributionChannel: string | null, division: string | null, salesOff: string | null, salesGroup: string | null, poNo: string | null, requestDate: string | null, docCurrency: string | null, paymentTerms: string | null, incoterms1: string | null, incoterms2: string | null, refPiNo: string | null, orderAmtBeforeVat: string | null, orderAmtVat: string | null, orderAmtAfterVat: string | null, originalRequestDate: string | null, description: string | null, usage: string | null, unloadingPoint: string | null, fixedItemNo: Array<string | null> | null, orderPartners: Array<{ __typename: 'OrderPartners', payerName: string | null, partnerRole: string | null, partnerNo: string | null, addrLink: string | null, itemNo: string | null, address: Array<{ __typename: 'PartnersAddress', name: string | null, addrNo: string | null, city: string | null, postCode: string | null, district: string | null, street: string | null, transpzone: string | null, country: string | null, nameForPartners: string | null, strSuppl1: string | null, strSuppl2: string | null, strSuppl3: string | null, location: string | null } | null> | null } | null> | null, orderItems: Array<{ __typename: 'OrderItems', allowChangeInquiryMethod: boolean | null, id: string | null, itemNo: string | null, itemRemain: string | null, remainingQuantity: number | null, remainingQuantityEx: number | null, poDate: string | null, reasonReject: string | null, confirmedDate: string | null, material: string | null, materialDesc: string | null, itemQty: string | null, salesUnit: string | null, plant: string | null, paymentTerm: string | null, poNumber: string | null, itemCategory: string | null, materialGroup1: string | null, saleText1Th: string | null, routeId: string | null, routeName: string | null, requestedDate: string | null, untimatedTol: string | null, weightPerUnit: string | null, orderQty: string | null, comfirmQty: string | null, deliveryQty: string | null, deliveryStatus: string | null, saleQtyDivision: string | null, saleQtyFactor: string | null, prdHierachy: string | null, shippingPoint: string | null, contractNo: string | null, contractItemNo: string | null, atp: string | null, atpDetails: string | null, block: string | null, run: string | null, paperMachine: string | null, refPiStock: string | null, conditionGroup1: string | null, inquiryMethod: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolOver: number | null, deliveryTolUnder: number | null, deliveryTolUnlimited: string | null, flagR5: boolean | null, isMaterialOutsource: boolean | null, itemProductionState: EOrderingProductionStatus | null, assignQuantity: number | null, itemStatusEn: string | null, orderType: string | null, originalRequestDate: string | null, poSubcontract: string | null, poStatus: string | null } | null> | null, orderCondition: Array<{ __typename: 'OrderCondition', itemNo: string | null, conditionType: string | null, conditionRate: string | null, currency: string | null, conditionUnit: string | null, conditionPriceUnit: string | null, conditionPriceOrder: string | null, conditionBaseValue: string | null } | null> | null, orderText: Array<{ __typename: 'OrderText', itemNo: string | null, textId: string | null, language: string | null, textLine: Array<{ __typename: 'TextLine', text: string | null } | null> | null } | null> | null } | null };

export type ExportPiGetAllProductsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExportPiGetAllProductsQuery = { __typename: 'Query', exportPi: { __typename: 'ExportPI', id: string | null, code: string | null, soldToName: string | null, poNo: string | null, incoterm: string | null, paymentTerm: string | null, shipToCountry: string | null, shipToName: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null, allPiProducts: Array<{ __typename: 'ExportPIProduct', id: string | null, itemNo: string | null, weight: number | null, quantityUnit: string | null, totalQuantity: number | null, remainingQuantity: number | null, weightUnit: string | null, salesUnit: string | null, pricePerUnit: number | null, currency: string | null, calculation: string | null, limitQuantity: number | null, limitQuantityOrderLine: number | null, cartQuantity: number | null, remainingQuantityEx: number | null, product: { __typename: 'ExportProduct', id: string | null, name: string | null, slug: string | null } | null } | null> | null } | null };

export type ScgpMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ScgpMeQuery = { __typename: 'Query', scgpMe: { __typename: 'ScgpUser', id: string | null, extendData: { __typename: 'ScgpUserExtend', defaultBusinessUnit: { __typename: 'BusinessUnits', id: string | null, name: string | null } | null, defaultSalesOrganizations: { __typename: 'SalesOrganizationMaster', name: string | null, code: string | null } | null, scgpBus: Array<{ __typename: 'BusinessUnits', code: string | null, name: string | null } | null> | null, scgpSalesOrganizations: Array<{ __typename: 'SalesOrganizationMaster', code: string | null, name: string | null } | null> | null, scgpSalesOrganizationsAll: Array<{ __typename: 'SalesOrganizationMaster', code: string | null, name: string | null } | null> | null, scgpSalesGroups: Array<{ __typename: 'SalesGroupMaster', code: string | null, name: string | null } | null> | null, salesOrgByBuAndUser: Array<{ __typename: 'SalesOrgByBu', businessUnit: string | null, salesOrganizations: Array<{ __typename: 'SalesOrganizationMaster', code: string | null, name: string | null, shortName: string | null } | null> | null } | null> | null, salesOrgByBu: Array<{ __typename: 'SalesOrgByBu', businessUnit: string | null, salesOrganizations: Array<{ __typename: 'SalesOrganizationMaster', code: string | null, name: string | null, shortName: string | null } | null> | null } | null> | null } | null } | null };

export type ShopInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopInfoQuery = { __typename: 'Query', shop: { __typename: 'Shop', defaultWeightUnit: WeightUnitsEnum | null, displayGrossPrices: boolean, includeTaxesInPrices: boolean, name: string, trackInventoryByDefault: boolean | null, version: string, countries: Array<{ __typename: 'CountryDisplay', country: string, code: string }>, defaultCountry: { __typename: 'CountryDisplay', country: string, code: string } | null, domain: { __typename: 'Domain', host: string, url: string }, languages: Array<{ __typename: 'LanguageDisplay', code: LanguageCodeEnum, language: string }>, permissions: Array<{ __typename: 'Permission', code: PermissionEnum, name: string }> } };

export type ShopCountriesQueryVariables = Exact<{
  filter?: InputMaybe<CountryFilterInput>;
}>;


export type ShopCountriesQuery = { __typename: 'Query', shop: { __typename: 'Shop', countries: Array<{ __typename: 'CountryDisplay', code: string, country: string }> } };

export type RefreshLimitsQueryVariables = Exact<{
  channels: Scalars['Boolean'];
  orders: Scalars['Boolean'];
  productVariants: Scalars['Boolean'];
  staffUsers: Scalars['Boolean'];
  warehouses: Scalars['Boolean'];
}>;


export type RefreshLimitsQuery = { __typename: 'Query', shop: { __typename: 'Shop', limits: { __typename: 'LimitInfo', currentUsage: { __typename: 'Limits', channels?: number | null, orders?: number | null, productVariants?: number | null, staffUsers?: number | null, warehouses?: number | null }, allowedUsage: { __typename: 'Limits', channels?: number | null, orders?: number | null, productVariants?: number | null, staffUsers?: number | null, warehouses?: number | null } } } };

export type AddOrderLineMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['String'];
  materialCode: Scalars['String'];
  totalItems?: InputMaybe<Scalars['Int']>;
}>;


export type AddOrderLineMutation = { __typename: 'Mutation', addOrderLine: { __typename: 'AddOrderLine', itemNoUpdated: boolean | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode }>, orderLines: Array<{ __typename: 'CipTempOrderLine', id: string | null, materialCode: string | null, materialDescription: string | null, materialType: string | null, quantity: number | null, bomUnitQuantity: number | null, customerMatCode: string | null, plant: string | null, requestDate: any | null, paymentTermItem: string | null, productionFlag: string | null, itemNo: string | null, priceCurrency: string | null, weight: number | null, salesUnit: string | null, weightUnit: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, prcGroup1: string | null, bomFlag: boolean | null, parentId: string | null, parentItemNo: string | null, batchFlag: boolean | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null, remark: string | null, itemNote: string | null, prItemText: string | null, lotNo: string | null, productionMemo: string | null, salesUnitList: Array<{ __typename: 'CipConversion2Master', toUnit: string | null, fromUnit: string | null, calculation: number | null } | null> | null } | null> | null } | null };

export type DeleteOrderLinesMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  totalItems?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteOrderLinesMutation = { __typename: 'Mutation', deleteOrderLines: { __typename: 'DeleteOrderLine', errors: Array<{ __typename: 'ContractCheckoutError', code: ContractCheckoutErrorCode, field: string | null, message: string | null }> } | null };

export type UpdateCipOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CipOrderUpdateInput;
}>;


export type UpdateCipOrderMutation = { __typename: 'Mutation', updateCipOrder: { __typename: 'CipOrderUpdate', success: boolean | null, order: { __typename: 'CipTempOrder', id: string | null } | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null }>, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null, eorWarnings: Array<{ __typename: 'EORWarning', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type CancelCipOrderMutationVariables = Exact<{
  orderLines?: InputMaybe<Array<InputMaybe<CancelDeleteCipOrderLinesInput>> | InputMaybe<CancelDeleteCipOrderLinesInput>>;
  soNo: Scalars['String'];
}>;


export type CancelCipOrderMutation = { __typename: 'Mutation', cancelCipOrder: { __typename: 'CancelCipOrder', status: boolean | null, errors: Array<{ __typename: 'CipOrderError', message: string | null, code: CipOrderErrorCode, field: string | null }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, itemNo: string | null, errorMessage: string | null } | null> | null } | null };

export type CipChangeOrderUpdateMutationVariables = Exact<{
  input: CipChangeOrderEditInput;
}>;


export type CipChangeOrderUpdateMutation = { __typename: 'Mutation', cipChangeOrderUpdate: { __typename: 'CipChangeOrderUpdate', success: boolean | null, order: { __typename: 'CipTempOrder', id: string | null } | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null, code: CipOrderErrorCode }>, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type UndoCancelCipOrderLinesMutationVariables = Exact<{
  itemNo: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  soNo: Scalars['String'];
  totalItems?: InputMaybe<Scalars['Int']>;
}>;


export type UndoCancelCipOrderLinesMutation = { __typename: 'Mutation', undoCancelCipOrderLines: { __typename: 'CipUndoOrderLines', success: boolean | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', code: CipOrderErrorCode, message: string | null }> } | null };

export type CipChangeOrderAddNewOrderLineMutationVariables = Exact<{
  input: CipChangeOrderEditInput;
}>;


export type CipChangeOrderAddNewOrderLineMutation = { __typename: 'Mutation', cipChangeOrderAddNewOrderLine: { __typename: 'CipChangeOrderAddNewOrderLine', success: boolean | null, order: { __typename: 'CipTempOrder', id: string | null } | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null, code: CipOrderErrorCode }>, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type GetSapPriceCalcMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PriceCalculationInput;
}>;


export type GetSapPriceCalcMutation = { __typename: 'Mutation', getPriceCalculation: { __typename: 'OrderLinePriceCalculator', success: boolean | null, response: { __typename: 'PriceSummaryResponse', orderItemsOut: Array<{ __typename: 'PriceCalcOrderItemsOut', itemNo: string | null, materialCode: string | null, materialDescription: string | null, materialType: string | null, manualPriceFlag: boolean | null, pricePerUnit: number | null, netValue: number | null, currency: string | null, priceStatus: string | null, priceStatusDesc: string | null } | null> | null, orderHeaderOut: { __typename: 'PriceCalcOrderHeaderOut', orderAmountBeforeVat: number | null, orderAmountVat: number | null, orderAmountAfterVat: number | null, currency: string | null } | null } | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, itemNo: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null }> } | null };

export type DownloadOrdersPdfMutationVariables = Exact<{
  soNo: Scalars['ID'];
}>;


export type DownloadOrdersPdfMutation = { __typename: 'Mutation', downloadOrdersPdf: { __typename: 'PrintOrderFromPreviewPage', exportedFileBase64: string | null, fileName: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type CpUpdateCreateOrderMutationVariables = Exact<{
  input: CpOrderUpdateInput;
}>;


export type CpUpdateCreateOrderMutation = { __typename: 'Mutation', cpUpdateCreateOrder: { __typename: 'CpOrderCreate', success: boolean | null, order: { __typename: 'CipTempOrder', id: string | null } | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null }>, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type UpdateOrderLineOtcShipToMutationVariables = Exact<{
  lineId: Scalars['ID'];
  otcShipTo: CipOrderOtcPartnerInput;
}>;


export type UpdateOrderLineOtcShipToMutation = { __typename: 'Mutation', updateOrderLineOtcShipTo: { __typename: 'UpdateOrderLineOtcShipTo', id: string | null } | null };

export type DeleteOrderLineOtcShipToMutationVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type DeleteOrderLineOtcShipToMutation = { __typename: 'Mutation', deleteOrderLineOtcShipTo: { __typename: 'DeleteOrderLineOtcShipTo' } | null };

export type AddCipSplitOrderMutationVariables = Exact<{
  soNo: Scalars['String'];
  isBom: Scalars['Boolean'];
  originLineItems?: InputMaybe<Array<SplitCipOrderLineInput> | SplitCipOrderLineInput>;
  splitLineItems?: InputMaybe<Array<SplitCipOrderLineInput> | SplitCipOrderLineInput>;
  totalItems?: InputMaybe<Scalars['Int']>;
}>;


export type AddCipSplitOrderMutation = { __typename: 'Mutation', addCipSplitOrderLine: { __typename: 'AddCipSplitOrderLineItem', success: boolean | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null, code: CipOrderErrorCode }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', soNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type SendEmailFromChangeOrderMutationVariables = Exact<{
  cc: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
  soNo: Scalars['String'];
}>;


export type SendEmailFromChangeOrderMutation = { __typename: 'Mutation', sendEmailFromChangeOrder: { __typename: 'SendEmailFromChangeOrder', status: string | null, errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode, field: string | null }> } | null };

export type DuplicateOrderCipMutationVariables = Exact<{
  soNo: Scalars['ID'];
}>;


export type DuplicateOrderCipMutation = { __typename: 'Mutation', duplicateOrderCip: { __typename: 'DuplicateOrderCip', errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null, code: CipOrderErrorCode }>, order: { __typename: 'CipTempOrder', id: string | null } | null } | null };

export type AddCipSplitOrderAfterCpMutationVariables = Exact<{
  soNo: Scalars['String'];
  isBom: Scalars['Boolean'];
  originLineItems?: InputMaybe<Array<SplitCipOrderLineInputAfterCp> | SplitCipOrderLineInputAfterCp>;
  splitLineItems?: InputMaybe<Array<SplitCipOrderLineInputAfterCp> | SplitCipOrderLineInputAfterCp>;
}>;


export type AddCipSplitOrderAfterCpMutation = { __typename: 'Mutation', addCipSplitOrderLineAfterCp: { __typename: 'AddCipSplitOrderLineAfterCp', success: boolean | null, cpItemMessages: Array<{ __typename: 'CPItemMessage', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: string | null, requestDate: string | null, confirmDate: string | null, originalDate: string | null, bomFlag: string | null, plant: string | null, parentItemNo: string | null, parentBom: string | null, showInPopup: boolean | null } | null> | null, cpErrorMessages: Array<{ __typename: 'CPMessage', id: string | null, itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, errors: Array<{ __typename: 'CipOrderError', field: string | null, message: string | null, code: CipOrderErrorCode }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', soNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessages', itemNo: string | null, errorMessage: string | null, errorCode: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type CancelDeleteCipOrderLinesMutationVariables = Exact<{
  orderLines?: InputMaybe<Array<InputMaybe<CancelDeleteCipOrderLinesInput>> | InputMaybe<CancelDeleteCipOrderLinesInput>>;
  soNo: Scalars['String'];
  totalItems?: InputMaybe<Scalars['Int']>;
}>;


export type CancelDeleteCipOrderLinesMutation = { __typename: 'Mutation', cancelDeleteCipOrderLines: { __typename: 'CancelDeleteCipOrderLines', status: boolean | null, errors: Array<{ __typename: 'CipOrderError', message: string | null, code: CipOrderErrorCode, field: string | null }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', itemNo: string | null, errorCode: string | null, errorMessage: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessages', message: string | null, order: string | null, source: string | null, itemNo: string | null } | null> | null } | null };

export type SyncCipOrderMutationVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type SyncCipOrderMutation = { __typename: 'Mutation', syncCipOrder: { __typename: 'CipSyncOrderData', order: { __typename: 'CipTempOrder', id: string | null, soNo: string | null, orderLines: Array<{ __typename: 'CipTempOrderLine', id: string | null, itemNo: string | null, parentId: string | null, bomUnitQuantity: number | null } | null> | null } | null, errors: Array<{ __typename: 'CipOrderError', message: string | null, code: CipOrderErrorCode, field: string | null }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessages', id: string | null, soNo: string | null, errorMessage: string | null } | null> | null } | null };

export type SyncFieldOrderLinesFragment = { __typename: 'CipTempOrderLine', id: string | null, itemNo: string | null, parentId: string | null, bomUnitQuantity: number | null };

export type SubmitCashSaleMutationVariables = Exact<{
  input: CashSaleInput;
  files?: InputMaybe<Array<InputMaybe<CashSaleFileInput>> | InputMaybe<CashSaleFileInput>>;
}>;


export type SubmitCashSaleMutation = { __typename: 'Mutation', submitCashSale: { __typename: 'SubmitCashSale', status: boolean | null, message: string | null, cashSaleStatus: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type SubmitCashSaleUpdateMutationVariables = Exact<{
  input: CashSaleInput;
  files?: InputMaybe<Array<InputMaybe<CashSaleFileInput>> | InputMaybe<CashSaleFileInput>>;
}>;


export type SubmitCashSaleUpdateMutation = { __typename: 'Mutation', submitCashSaleUpdate: { __typename: 'SubmitCashSaleUpdate', status: boolean | null, message: string | null, cashSaleStatus: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type GetDataSelectSalesTabQueryVariables = Exact<{
  saleOrg?: InputMaybe<Scalars['String']>;
}>;


export type GetDataSelectSalesTabQuery = { __typename: 'Query', salesOrganizations: Array<{ __typename: 'SalesOrganization', id: string | null, name: string | null, shortName: string | null, code: string | null } | null> | null, distributionChannelsDomestic: Array<{ __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null> | null, scgDivisions: Array<{ __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null> | null, salesOffices: Array<{ __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null> | null, salesGroups: Array<{ __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null> | null };

export type GetSalesDataQueryVariables = Exact<{
  saleOrg?: InputMaybe<Scalars['String']>;
  distributionChannelType: DistributionChannelType;
}>;


export type GetSalesDataQuery = { __typename: 'Query', getSalesData: { __typename: 'SalesDataResponse', salesOrganization: Array<{ __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null, displayText: string | null } | null> | null, defaultSalesOrganization: { __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null, distributionChannel: Array<{ __typename: 'DistributionChannel', id: string | null, code: string | null, name: string | null, displayText: string | null } | null> | null, division: Array<{ __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null> | null, defaultOtcSoldTo: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, displayText: string | null } | null } | null };

export type GetCustomerBlockQueryVariables = Exact<{
  input?: InputMaybe<CustomerBlockInput>;
}>;


export type GetCustomerBlockQuery = { __typename: 'Query', getCustomerBlock: { __typename: 'CustomerBlockResponse', customerBlock: boolean | null } | null };

export type SearchSuggestionSoldTosCipQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DomesticSoldToFilterInput>;
  saleOrg?: InputMaybe<Scalars['String']>;
  distributionChannel?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  oneTimeCustomer?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchSuggestionSoldTosCipQuery = { __typename: 'Query', searchSuggestionSoldTosCip: { __typename: 'DomesticSoldToCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'DomesticSoldToCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, displayText: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type PmtMatSearchQueryVariables = Exact<{
  filter?: InputMaybe<PmtMatSearchInput>;
  saleOrg: Scalars['String'];
}>;


export type PmtMatSearchQuery = { __typename: 'Query', pmtMatSearch: Array<{ __typename: 'PmtMatSearch', stockFg: string | null, stockQa: string | null, stockWip: string | null, hold: string | null, custName: string | null, custId: string | null, custCode: string | null, pc: string | null, materialNo: string | null, partNo: string | null, description: string | null, saleText: string | null, rate: number | null, flute: string | null, board: string | null, width: number | null, length: number | null, height: number | null, vendorName: string | null, netPrice: string | null, purTxt: string | null, remark: string | null, weightBox: number | null, plant: string | null, saleOrg: string | null, lastUpdate: string | null } | null> | null };

export type SearchSuggestionShipTosforCipQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CipHeaderShipTosFilterInput>;
  soldTo: Scalars['String'];
  saleOrg: Scalars['String'];
  distributionChannel: Scalars['String'];
  division: Scalars['String'];
}>;


export type SearchSuggestionShipTosforCipQuery = { __typename: 'Query', searchSuggestionShipTo: { __typename: 'SoldToPartnerAddressMasterCountableConnection', edges: Array<{ __typename: 'SoldToPartnerAddressMasterCountableEdge', node: { __typename: 'SoldToPartnerAddressMaster', partnerCode: string | null, displayCodeName: string | null, addressText: string | null } }> } | null };

export type ShipToUnloadingPointQueryVariables = Exact<{
  shipTo: Scalars['String'];
}>;


export type ShipToUnloadingPointQuery = { __typename: 'Query', shipToUnloadingPoint: { __typename: 'UnloadingPointForShipTo', shipTo: string | null, unloadingPoints: Array<{ __typename: 'CustomerUnloadingPoint', id: string | null, unloadingPoint: string | null } | null> | null, defaultUnloadingPoint: { __typename: 'CustomerUnloadingPoint', id: string | null, unloadingPoint: string | null } | null } | null };

export type SoldToHeaderInfoCipQueryVariables = Exact<{
  soldTo: Scalars['String'];
  saleOrg: Scalars['String'];
  distributionChannel: Scalars['String'];
  division: Scalars['String'];
}>;


export type SoldToHeaderInfoCipQuery = { __typename: 'Query', soldToHeaderInfoCip: { __typename: 'SoldToHeaderInfoType', orderType: string | null, taxClassification: string | null, saleEmployee: string | null, paymentTerm: Array<{ __typename: 'PaymentTermData', code: string | null, name: string | null } | null> | null, defaultPaymentTerm: { __typename: 'PaymentTermData', code: string | null, name: string | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null, displayText: string | null } | null, shipTo: Array<{ __typename: 'SoldToPartnerAddressMaster', code: string | null, name: string | null, addressText: string | null } | null> | null, billTo: Array<{ __typename: 'SoldToPartnerAddressMaster', code: string | null, name: string | null, addressText: string | null } | null> | null, unloadingPoints: Array<{ __typename: 'CustomerUnloadingPoint', id: string | null, unloadingPoint: string | null } | null> | null, saleGroup: Array<{ __typename: 'SalesGroupMaster', id: string | null, name: string | null, code: string | null } | null> | null, saleOffice: { __typename: 'SalesOfficeMaster', id: string | null, code: string | null } | null, defaultSaleGroup: { __typename: 'SalesGroupMaster', id: string | null, name: string | null, code: string | null } | null, defaultShipTo: { __typename: 'SoldToPartnerAddressMaster', code: string | null, name: string | null, addressText: string | null, displayText: string | null } | null, defaultBillTo: { __typename: 'SoldToPartnerAddressMaster', code: string | null, name: string | null, addressText: string | null, displayText: string | null } | null, defaultUnloadingPoint: { __typename: 'CustomerUnloadingPoint', id: string | null, unloadingPoint: string | null } | null, headerNote1En: { __typename: 'SoldToTextMaster', textId: string | null, textLine: string | null } | null, commentsToWarehouseEn: { __typename: 'SoldToTextMaster', textId: string | null, textLine: string | null } | null, headerNote1Th: { __typename: 'SoldToTextMaster', textId: string | null, textLine: string | null } | null, commentsToWarehouseTh: { __typename: 'SoldToTextMaster', textId: string | null, textLine: string | null } | null } | null };

export type GetPlantsByMatCodeQueryVariables = Exact<{
  materialCode: Scalars['String'];
}>;


export type GetPlantsByMatCodeQuery = { __typename: 'Query', getPlantsByMatCode: Array<{ __typename: 'PlantResponse', plantCode: string | null, plantName: string | null } | null> | null };

export type GetTransportationQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type GetTransportationQuery = { __typename: 'Query', transportation: Array<{ __typename: 'TempTransportation', countryCode: string | null, id: string | null, transportZoneCode: string | null, transportZoneName: string | null } | null> | null };

export type GetCountryMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryMasterDataQuery = { __typename: 'Query', getCountryMasterData: Array<{ __typename: 'TempCountryMaster', countryCode: string | null, countryName: string | null } | null> | null };

export type SearchSuggestionMaterialQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<MaterialSearchFilterInput>;
  saleOrg: Scalars['String'];
  distributionChannel: Scalars['String'];
  searchBy: SearchMaterialBy;
  soldTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type SearchSuggestionMaterialQuery = { __typename: 'Query', searchSuggestionMaterial: { __typename: 'MaterialSearchSuggestionCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'MaterialSearchSuggestionCountableEdge', node: { __typename: 'MaterialSearchSuggestionResponse', id: string | null, materialCode: string | null, descriptionEn: string | null, soldToMaterialCode: string | null, displayText: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetOrderDataQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOrderDataQuery = { __typename: 'Query', getOrderData: { __typename: 'CipTempOrder', id: string | null, soNo: string | null, orderType: string | null, orderTypeDesc: string | null, poNumber: string | null, status: string | null, soldToAddress: string | null, orderAmtBeforeVat: string | null, orderAmtVat: string | null, orderAmtAfterVat: string | null, itemCategory: string | null, routeId: string | null, routeName: string | null, info: string | null, billTo: string | null, unloadingPoint: string | null, salesEmployee: string | null, taxPercent: number | null, shipTo: string | null, poDate: any | null, requestDate: any | null, paymentTerm: string | null, dpNo: string | null, invoiceNo: string | null, deliveryBlock: string | null, incoterm: string | null, route: string | null, shippingPoint: string | null, internalCommentsToLogistic: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, productInformation: string | null, orderExtension: { __typename: 'OrderExtension', taxClass: string | null, additionalTxtFromHeader: string | null, additionalTxtHeaderNote1: string | null, additionalTxtCash: string | null, otcSoldTo: { __typename: 'OrderOtcPartner', soldToCode: string | null, address: { __typename: 'OrderOtcPartnerAddress', addressCode: string | null, name1: string | null, name2: string | null, name3: string | null, name4: string | null, city: string | null, postalCode: string | null, district: string | null, street1: string | null, street2: string | null, street3: string | null, street4: string | null, location: string | null, transportZoneCode: string | null, transportZoneName: string | null, countryCode: string | null, countryName: string | null, telephoneNo: string | null, telephoneExtension: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, email: string | null, language: string | null, taxNumber1: string | null, taxNumber2: string | null, taxId: string | null, branchId: string | null } | null } | null, otcBillTo: { __typename: 'OrderOtcPartner', soldToCode: string | null, address: { __typename: 'OrderOtcPartnerAddress', addressCode: string | null, name1: string | null, name2: string | null, name3: string | null, name4: string | null, city: string | null, postalCode: string | null, district: string | null, street1: string | null, street2: string | null, street3: string | null, street4: string | null, location: string | null, transportZoneCode: string | null, transportZoneName: string | null, countryCode: string | null, countryName: string | null, telephoneNo: string | null, telephoneExtension: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, email: string | null, language: string | null, taxNumber1: string | null, taxNumber2: string | null, taxId: string | null, branchId: string | null } | null } | null, otcShipTo: { __typename: 'OrderOtcPartner', soldToCode: string | null, address: { __typename: 'OrderOtcPartnerAddress', addressCode: string | null, name1: string | null, name2: string | null, name3: string | null, name4: string | null, city: string | null, postalCode: string | null, district: string | null, street1: string | null, street2: string | null, street3: string | null, street4: string | null, location: string | null, transportZoneCode: string | null, transportZoneName: string | null, countryCode: string | null, countryName: string | null, telephoneNo: string | null, telephoneExtension: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, email: string | null, language: string | null, taxNumber1: string | null, taxNumber2: string | null, taxId: string | null, branchId: string | null } | null } | null } | null, customer: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, soldToCode: string | null, soldToName: string | null, displayText: string | null, addressText: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', streetAddress1: string, streetAddress2: string }> | null } | null> | null } | null, soldTo: { __typename: 'SoldToMaster', displayText: string | null, addressText: string | null } | null, scgpSalesEmployee: { __typename: 'ScgpSalesEmployee', id: string | null, code: string | null, name: string | null } | null, customerGroup: { __typename: 'CustomerGroupMaster', id: string | null, code: string | null, name: string | null } | null, customerGroup1: { __typename: 'CustomerGroup1Master', id: string | null, code: string | null, name: string | null } | null, customerGroup2: { __typename: 'CustomerGroup2Master', id: string | null, code: string | null, name: string | null } | null, customerGroup3: { __typename: 'CustomerGroup3Master', id: string | null, code: string | null, name: string | null } | null, customerGroup4: { __typename: 'CustomerGroup4Master', id: string | null, code: string | null, name: string | null } | null, incoterms1: { __typename: 'Incoterms1Master', id: string | null, code: string | null, description: string | null } | null, saleOrganization: { __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null, salesGroup: { __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null, saleOffice: { __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null, division: { __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null, distributionChannel: { __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null, orderLines: Array<{ __typename: 'CipTempOrderLine', id: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, customerMatCode: string | null, quantity: number | null, bomFlag: boolean | null, parentId: string | null, parentItemNo: string | null, bomUnitQuantity: number | null, salesUnit: string | null, weight: number | null, weightUnit: string | null, batchFlag: boolean | null, batchNo: string | null, plant: string | null, requestDate: any | null, price: number | null, netPrice: number | null, materialType: string | null, priceCurrency: string | null, paymentTermItem: string | null, priceDate: any | null, poItemNo: string | null, poNo: string | null, productionFlag: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, remark: string | null, saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null, batchChoiceFlag: boolean | null, itemNote: string | null, lotNo: string | null, prItemText: string | null, productionMemo: string | null, salesUnitList: Array<{ __typename: 'CipConversion2Master', toUnit: string | null, fromUnit: string | null, calculation: number | null } | null> | null, otcShipTo: { __typename: 'OrderOtcPartner', soldToCode: string | null, address: { __typename: 'OrderOtcPartnerAddress', addressCode: string | null, name1: string | null, name2: string | null, name3: string | null, name4: string | null, city: string | null, postalCode: string | null, district: string | null, street1: string | null, street2: string | null, street3: string | null, street4: string | null, location: string | null, transportZoneCode: string | null, transportZoneName: string | null, countryCode: string | null, countryName: string | null, telephoneNo: string | null, telephoneExtension: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, email: string | null, language: string | null, taxNumber1: string | null, taxNumber2: string | null } | null } | null } | null> | null } | null };

export type FieldOrderLinesCipFragment = { __typename: 'CipTempOrderLine', id: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, customerMatCode: string | null, quantity: number | null, bomFlag: boolean | null, parentId: string | null, parentItemNo: string | null, bomUnitQuantity: number | null, salesUnit: string | null, weight: number | null, weightUnit: string | null, batchFlag: boolean | null, batchNo: string | null, plant: string | null, requestDate: any | null, price: number | null, netPrice: number | null, materialType: string | null, priceCurrency: string | null, paymentTermItem: string | null, priceDate: any | null, poItemNo: string | null, poNo: string | null, productionFlag: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, remark: string | null, saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null, batchChoiceFlag: boolean | null, itemNote: string | null, lotNo: string | null, prItemText: string | null, productionMemo: string | null, salesUnitList: Array<{ __typename: 'CipConversion2Master', toUnit: string | null, fromUnit: string | null, calculation: number | null } | null> | null, otcShipTo: { __typename: 'OrderOtcPartner', soldToCode: string | null, address: { __typename: 'OrderOtcPartnerAddress', addressCode: string | null, name1: string | null, name2: string | null, name3: string | null, name4: string | null, city: string | null, postalCode: string | null, district: string | null, street1: string | null, street2: string | null, street3: string | null, street4: string | null, location: string | null, transportZoneCode: string | null, transportZoneName: string | null, countryCode: string | null, countryName: string | null, telephoneNo: string | null, telephoneExtension: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, email: string | null, language: string | null, taxNumber1: string | null, taxNumber2: string | null } | null } | null };

export type PreviewDomesticOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PreviewDomesticOrderQuery = { __typename: 'Query', previewDomesticOrder: { __typename: 'CipPreviewOrderResponse', previewHeaderData: { __typename: 'PreviewHeaderResponse', soNo: string | null, poNumber: string | null, orderDate: string | null, paymentTerm: string | null, saleOrganization: string | null, saleEmployee: string | null, customerName: string | null, shipTo: string | null, billTo: string | null } | null, previewItemData: Array<{ __typename: 'PreviewItemResponse', itemNo: string | null, materialCode: string | null, materialDescription: string | null, quantity: number | null, salesUnit: string | null, weight: number | null, weightUnit: string | null, pricePerUnit: number | null, netPrice: number | null, requestDate: string | null, confirmedDate: string | null, plant: string | null, confirmedPlant: string | null, bomFlag: boolean | null, parentItemNo: string | null, itemStatusEn: string | null, itemStatusTh: string | null } | null> | null, previewFooterData: { __typename: 'PreviewItemFooterResponse', netTotalPrice: number | null, totalVat: number | null, orderAmountAfterVat: number | null, currency: string | null } | null } | null };

export type GetOrderEmailToAndCcForNotRefQueryVariables = Exact<{
  soldToCode?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  saleOrg?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  soNo?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetOrderEmailToAndCcForNotRefQuery = { __typename: 'Query', getOrderEmailToAndCcForNotRef: { __typename: 'OrderEmailRecipient', to: string | null, cc: string | null } | null };

export type OrderViewDataQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type OrderViewDataQuery = { __typename: 'Query', orderViewData: { __typename: 'CipOrderViewData', id: string | null, soNo: string | null, poNo: string | null, oneTimeFlag: boolean | null, distributionChannelCode: string | null, distributionChannelName: string | null, salesOrgCode: string | null, salesOrgName: string | null, salesOrgShortName: string | null, salesOff: string | null, salesOffName: string | null, divisionCode: string | null, divisionName: string | null, priceDate: string | null, status: string | null, orderAmtBeforeVat: string | null, orderAmtVat: string | null, orderAmtAfterVat: string | null, currency: string | null, requestDate: string | null, paymentTerms: string | null, salesOrgDisplayText: string | null, salesGroupCode: string | null, salesEmployee: string | null, soldToCode: string | null, soldToDisplayText: string | null, billToDisplayText: string | null, shipToDisplayText: string | null, internalCommentsToLogistic: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, productionInformation: string | null, formHeader: string | null, headerNote1: string | null, cash: string | null, unloadingPoint: string | null, orderDate: string | null, salesGroupName: string | null, itemNoLatest: string | null, poDate: string | null, orderType: string | null, orderTypeDesc: string | null, taxClass: string | null, paymentTermsDisplayText: string | null, salesEmployeeDisplayText: string | null, otcOrderPartners: Array<{ __typename: 'OrderPartners', partnerRole: string | null, partnerNo: string | null, addrLink: string | null, payerName: string | null, itemNo: string | null, oneTimeFlag: boolean | null, address: Array<{ __typename: 'PartnersAddress', addrNo: string | null, name: string | null, city: string | null, postCode: string | null, district: string | null, street: string | null, transpzone: string | null, country: string | null, countryName: string | null, nameForPartners: string | null, location: string | null, strSuppl1: string | null, strSuppl2: string | null, strSuppl3: string | null, mobileNo: string | null, faxNo: string | null, faxNoExt: string | null, language: string | null, telNoList: Array<{ __typename: 'TelNoList', telNo: string | null, telNoExt: string | null } | null> | null, orderTaxNumber: { __typename: 'OrderTaxNumber', taxNumber1: string | null, taxNumber2: string | null, taxId: string | null, branchId: string | null } | null } | null> | null } | null> | null, orderItems: Array<{ __typename: 'CipGetChangeOrderItemData', id: string | null, itemNo: string | null, materialCode: string | null, customerMatCode: string | null, productionFlag: string | null, batchNo: string | null, batchChoiceFlag: boolean | null, batchFlag: boolean | null, materialDescription: string | null, quantity: string | null, salesUnit: string | null, plant: string | null, paymentTerm: string | null, paymentTermDescTh: string | null, poNo: string | null, itemCategory: string | null, materialGroup1: string | null, saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null, routeId: string | null, routeName: string | null, requestDate: string | null, originalRequestDate: string | null, weightPerUnit: string | null, orderQty: string | null, confirmQty: string | null, deliveryQty: string | null, deliveryStatus: string | null, saleQtyDivision: string | null, saleQtyFactor: number | null, prdHierachy: string | null, shippingPoint: string | null, poDate: string | null, reasonReject: string | null, confirmedDate: string | null, weight: number | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, remark: string | null, itemNote: string | null, prItemText: string | null, lotNo: string | null, productionMemo: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: string | null, shipTo: string | null, refPiStock: string | null, assignQuantity: number | null, itemStatusEn: string | null, itemStatusTh: string | null, netValue: number | null, requestDateChangeReason: string | null, weightDisplay: string | null, poStatus: string | null, materialGroup1Desc: string | null, weightUnit: string | null, prNoOs: string | null, poNoOs: string | null, prItemOs: string | null, poItemNumber: string | null, poItemNoOs: string | null, materialType: string | null, pricePerUnit: string | null, priceCurrency: string | null, bomFlag: boolean | null, parentItemNo: string | null, priceDate: string | null, netWeight: string | null, grossWeight: string | null, baseUnit: string | null, grStatusOs: string | null, isSplitEnabled: boolean | null, manualPriceFlag: boolean | null, deliveryBlock: boolean | null, bomUnitQuantity: number | null, salesUnitList: Array<{ __typename: 'CipConversion2Master', toUnit: string | null, fromUnit: string | null, calculation: number | null } | null> | null, salesTextMaster: { __typename: 'DefaultSaleText', saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null } | null } | null> | null, orderCondition: Array<{ __typename: 'OrderCondition', itemNo: string | null, conditionType: string | null, conditionRate: string | null, currency: string | null, conditionUnit: string | null, conditionPriceUnit: string | null, conditionPriceOrder: string | null, conditionBaseValue: string | null } | null> | null, orderText: Array<{ __typename: 'OrderText', itemNo: string | null, textId: string | null, language: string | null, textLine: Array<{ __typename: 'TextLine', text: string | null } | null> | null } | null> | null, cashSale: { __typename: 'CashSaleResponse', id: string | null, arAmount: number | null, cashFlag: boolean | null, cashAmount: number | null, balanceFlag: boolean | null, balanceAmount: number | null, feeAmount: number | null, feeType: string | null, feeAbsorbFlag: boolean | null, withHoldTax: number | null, remark: string | null, files: Array<{ __typename: 'CashSaleFileResponse', id: string | null, fileName: string | null, fileSize: number | null, documentType: string | null, paymentMethod: string | null } | null> | null } | null } | null };

export type ChangeFieldOrderLinesFragment = { __typename: 'CipGetChangeOrderItemData', id: string | null, itemNo: string | null, materialCode: string | null, customerMatCode: string | null, productionFlag: string | null, batchNo: string | null, batchChoiceFlag: boolean | null, batchFlag: boolean | null, materialDescription: string | null, quantity: string | null, salesUnit: string | null, plant: string | null, paymentTerm: string | null, paymentTermDescTh: string | null, poNo: string | null, itemCategory: string | null, materialGroup1: string | null, saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null, routeId: string | null, routeName: string | null, requestDate: string | null, originalRequestDate: string | null, weightPerUnit: string | null, orderQty: string | null, confirmQty: string | null, deliveryQty: string | null, deliveryStatus: string | null, saleQtyDivision: string | null, saleQtyFactor: number | null, prdHierachy: string | null, shippingPoint: string | null, poDate: string | null, reasonReject: string | null, confirmedDate: string | null, weight: number | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, remark: string | null, itemNote: string | null, prItemText: string | null, lotNo: string | null, productionMemo: string | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: string | null, shipTo: string | null, refPiStock: string | null, assignQuantity: number | null, itemStatusEn: string | null, itemStatusTh: string | null, netValue: number | null, requestDateChangeReason: string | null, weightDisplay: string | null, poStatus: string | null, materialGroup1Desc: string | null, weightUnit: string | null, prNoOs: string | null, poNoOs: string | null, prItemOs: string | null, poItemNumber: string | null, poItemNoOs: string | null, materialType: string | null, pricePerUnit: string | null, priceCurrency: string | null, bomFlag: boolean | null, parentItemNo: string | null, priceDate: string | null, netWeight: string | null, grossWeight: string | null, baseUnit: string | null, grStatusOs: string | null, isSplitEnabled: boolean | null, manualPriceFlag: boolean | null, deliveryBlock: boolean | null, bomUnitQuantity: number | null, salesUnitList: Array<{ __typename: 'CipConversion2Master', toUnit: string | null, fromUnit: string | null, calculation: number | null } | null> | null, salesTextMaster: { __typename: 'DefaultSaleText', saleText1: string | null, saleText2: string | null, saleText3: string | null, saleText4: string | null } | null };

export type ShipToUnloadingAndTaxQueryVariables = Exact<{
  shipTo: Scalars['String'];
  saleOrg: Scalars['String'];
  distributionChannel: Scalars['String'];
  division: Scalars['String'];
}>;


export type ShipToUnloadingAndTaxQuery = { __typename: 'Query', shipToUnloadingAndTax: { __typename: 'UnloadingPointTaxForShipTo', shipTo: string | null, taxClassification: string | null, unloadingPoints: Array<{ __typename: 'CustomerUnloadingPoint', id: string | null, soldToCode: string | null, unloadingPoint: string | null, factoryCalendar: string | null, factoryCalendarDesc: string | null } | null> | null, defaultUnloadingPoint: { __typename: 'CustomerUnloadingPoint', id: string | null, soldToCode: string | null, unloadingPoint: string | null, factoryCalendar: string | null, factoryCalendarDesc: string | null } | null } | null };

export type GetArOutstandingQueryVariables = Exact<{
  input: ArOutstandingInput;
}>;


export type GetArOutstandingQuery = { __typename: 'Query', getArOutstanding: { __typename: 'ArOutstandingResponse', currentAmount: number | null, status: boolean | null, message: string | null } | null };

export type GetCashSaleStatusQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type GetCashSaleStatusQuery = { __typename: 'Query', getCashSaleStatus: { __typename: 'CashSaleStatusResponse', status: boolean | null, message: string | null, cashSaleStatus: string | null, statusName: string | null, updateFlag: boolean | null } | null };

export type CreateContractCheckoutMutationVariables = Exact<{
  input: ContractCheckoutCreateInput;
}>;


export type CreateContractCheckoutMutation = { __typename: 'Mutation', createContractCheckout: { __typename: 'ContractCheckoutCreate', checkout: { __typename: 'ContractCheckout', id: string | null } | null } | null };

export type DeleteContractCheckoutLinesMutationVariables = Exact<{
  checkoutLineIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteContractCheckoutLinesMutation = { __typename: 'Mutation', deleteContractCheckoutLines: { __typename: 'ContractCheckoutLinesDeleteDelete', status: string | null, errors: Array<{ __typename: 'ContractCheckoutError', code: ContractCheckoutErrorCode, field: string | null, message: string | null }> } | null };

export type UpdateContractCheckoutMutationVariables = Exact<{
  detailId: Scalars['ID'];
  input: ContractCheckoutUpdateInput;
}>;


export type UpdateContractCheckoutMutation = { __typename: 'Mutation', updateContractCheckout: { __typename: 'ContractCheckoutUpdate', errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }>, checkout: { __typename: 'ContractCheckout', id: string | null } | null } | null };

export type CreateOrderMutationVariables = Exact<{
  input: ContractOrderCreateInput;
}>;


export type CreateOrderMutation = { __typename: 'Mutation', createContractOrder: { __typename: 'ContractOrderCreate', order: { __typename: 'TempOrder', id: string | null, customer: { __typename: 'SoldToMaster', id: string | null } | null } | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type UpdateContractOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ContractOrderUpdateInput;
}>;


export type UpdateContractOrderMutation = { __typename: 'Mutation', updateContractOrder: { __typename: 'ContractOrderUpdate', success: boolean | null, order: { __typename: 'TempOrder', id: string | null } | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, errorMessage: string | null, itemNo: string | null } | null> | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }>, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type DeleteCustomerCartItemsMutationVariables = Exact<{
  cartItemIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteCustomerCartItemsMutation = { __typename: 'Mutation', deleteCustomerCartItems: { __typename: 'CartItemsDelete', status: string | null, errors: Array<{ __typename: 'ScgpCustomerError', message: string | null }> } | null };

export type CreateCustomerCartMutationVariables = Exact<{
  input: CustomerCartCreateInput;
}>;


export type CreateCustomerCartMutation = { __typename: 'Mutation', createCustomerCart: { __typename: 'CustomerCartCreate', errors: Array<{ __typename: 'ScgpCustomerError', message: string | null }>, cart: { __typename: 'CustomerCart', id: string | null, cartItems: Array<{ __typename: 'CustomerCartItem', id: string | null }> | null } | null } | null };

export type UpdateCustomerCartMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CustomerCartUpdateInput;
}>;


export type UpdateCustomerCartMutation = { __typename: 'Mutation', updateCustomerCart: { __typename: 'CustomerCartUpdate', errors: Array<{ __typename: 'ScgpCustomerError', message: string | null }>, cart: { __typename: 'CustomerCart', id: string | null, quantity: number | null, contract: { __typename: 'CustomerContract', code: string | null } | null, createdBy: { __typename: 'ScgUser', id: string } | null, cartItems: Array<{ __typename: 'CustomerCartItem', id: string | null, quantity: number | null, variant: { __typename: 'CustomerProductVariant', name: string | null } | null, customerProduct: { __typename: 'CustomerProduct', name: string | null, slug: string | null } | null, customerProductVariant: { __typename: 'CustomerProductVariant', name: string | null, slug: string | null } | null }> | null } | null } | null };

export type UpdateCustomerCartLinesMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CustomerCartLinesUpdateQuantityInput;
}>;


export type UpdateCustomerCartLinesMutation = { __typename: 'Mutation', updateCustomerCartLines: { __typename: 'CustomerCartLinesUpdateQuantity', cart: { __typename: 'CustomerCartLines', cartItems: Array<{ __typename: 'CustomerCartItem', cart: { __typename: 'CustomerCart', id: string | null } | null }> | null } | null } | null };

export type ContractsQueryVariables = Exact<{
  soldToCode: Scalars['String'];
  contractNo?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TempContractFilterInput>;
  sortBy?: InputMaybe<ContractsSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type ContractsQuery = { __typename: 'Query', contracts: { __typename: 'TempContractCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, edges: Array<{ __typename: 'TempContractCountableEdge', node: { __typename: 'TempContract', id: string | null, contractNo: string | null, prcGroup1: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, paymentTermKey: string | null, paymentTermDescTh: string | null, company: { __typename: 'CheckoutCompany', id: string | null, name: string | null, businessUnit: { __typename: 'BusinessUnit', name: string | null } | null } | null, salesOrganization: { __typename: 'SalesOrganization', code: string | null } | null, customer: { __typename: 'SoldToMaster', soldToCode: string | null } | null, products: Array<{ __typename: 'TempContractProduct', id: string | null, name: string | null } | null> | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type ContractQueryVariables = Exact<{
  id: Scalars['ID'];
  soNo?: InputMaybe<Scalars['String']>;
}>;


export type ContractQuery = { __typename: 'Query', contract: { __typename: 'TempContract', id: string | null, contractNo: string | null, currency: string | null, prcGroup1: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, paymentTermKey: string | null, paymentTermDescTh: string | null, salesOrganization: { __typename: 'SalesOrganization', code: string | null } | null, customer: { __typename: 'SoldToMaster', name: string | null, id: string | null, code: string | null, soldToCode: string | null, soldToName: string | null, displayText: string | null, addressText: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string } | null> | null } | null, company: { __typename: 'CheckoutCompany', id: string | null, name: string | null, shortName: string | null, fullName: string | null, businessUnit: { __typename: 'BusinessUnit', name: string | null } | null } | null, products: Array<{ __typename: 'TempContractProduct', id: string | null, price: number | null, name: string | null, materialDescription: string | null, total: number | null, remain: number | null, salesUnit: string | null, weightUnit: string | null, productId: string | null, itemNo: string | null, matGroup1: string | null, materialCode: string | null, product: { __typename: 'TempProduct', id: string | null, name: string | null, code: string | null, description: string | null, materialType: string | null, weight: number | null } | null } | null> | null } | null };

export type GetBusinessUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessUnitQuery = { __typename: 'Query', businessUnits: { __typename: 'BusinessUnitCountableConnection', edges: Array<{ __typename: 'BusinessUnitCountableEdge', node: { __typename: 'BusinessUnit', id: string | null, name: string | null, companies: Array<{ __typename: 'CheckoutCompany', id: string | null, name: string | null, shortName: string | null, fullName: string | null } | null> | null } }> } | null };

export type ContractProductQueryVariables = Exact<{
  productId: Scalars['ID'];
  contractId: Scalars['ID'];
  contractMaterialId: Scalars['ID'];
  soNo?: InputMaybe<Scalars['ID']>;
}>;


export type ContractProductQuery = { __typename: 'Query', contractProduct: { __typename: 'TempContractProduct', id: string | null, total: number | null, remain: number | null, price: number | null, salesUnit: string | null, contract: { __typename: 'TempContract', id: string | null, projectName: string | null, currency: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, prcGroup1: string | null } | null, product: { __typename: 'TempProduct', id: string | null, name: string | null, salesUnit: string | null, code: string | null, description: string | null, variants: Array<{ __typename: 'TempProductVariant', id: string | null, name: string | null, code: string | null, descriptionTh: string | null, descriptionEn: string | null, variantType: string | null, weight: string | null } | null> | null } | null } | null };

export type CartTotalCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type CartTotalCheckoutQuery = { __typename: 'Query', totalContractCheckouts: { __typename: 'ContractCheckoutTotal', totalProducts: number | null, totalCustomers: number | null } | null };

export type CartCheckoutQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<ContractCheckoutsSortingInput>;
}>;


export type CartCheckoutQuery = { __typename: 'Query', contractCheckouts: { __typename: 'ContractCheckoutCountableConnection', edges: Array<{ __typename: 'ContractCheckoutCountableEdge', node: { __typename: 'ContractCheckout', id: string | null, quantity: number | null, customer: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, soldToCode: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string } | null> | null } | null, contract: { __typename: 'TempContract', id: string | null, paymentTerm: string | null } | null } }> } | null };

export type GetListSaleOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListSaleOrganizationsQuery = { __typename: 'Query', salesOrganizations: Array<{ __typename: 'SalesOrganization', id: string | null, name: string | null, code: string | null } | null> | null };

export type GetDistributionChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistributionChannelQuery = { __typename: 'Query', distributionChannels: Array<{ __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null> | null };

export type GetListScgDivisionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListScgDivisionQuery = { __typename: 'Query', scgDivisions: Array<{ __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null> | null };

export type GetListSalesOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListSalesOfficesQuery = { __typename: 'Query', salesOffices: Array<{ __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null> | null };

export type GetListSaleGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListSaleGroupsQuery = { __typename: 'Query', salesGroups: Array<{ __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null> | null };

export type ContractCheckoutQueryVariables = Exact<{
  id: Scalars['ID'];
  sortBy?: InputMaybe<CheckoutLineSortingInput>;
}>;


export type ContractCheckoutQuery = { __typename: 'Query', contractCheckout: { __typename: 'ContractCheckout', id: string | null, customer: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, soldToCode: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string } | null> | null } | null, contract: { __typename: 'TempContract', id: string | null, paymentTerm: string | null, contractNo: string | null, currency: string | null, startDate: any | null, endDate: any | null, projectName: string | null } | null, lines: Array<{ __typename: 'ContractCheckoutLine', id: string | null, quantity: number | null, price: number | null, selected: boolean | null, product: { __typename: 'TempProduct', id: string | null, name: string | null, salesUnit: string | null, baseUnit: string | null, purchaseUnit: string | null, materialType: string | null, materialCode: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, name: string | null, weight: string | null, salesUnit: string | null, limitQuantity: number | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null } | null }> | null } | null };

export type ContractCheckoutProductVariantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContractCheckoutProductVariantQuery = { __typename: 'Query', contractCheckoutProductVariant: { __typename: 'ContractCheckoutProductVariant', contractProduct: Array<{ __typename: 'TempContractProduct', id: string | null, name: string | null, total: number | null, remain: number | null, salesUnit: string | null, price: number | null, deliveryOver: number | null, deliveryUnder: number | null, materialDescription: string | null, productId: string | null, contract: { __typename: 'TempContract', id: string | null, contractNo: string | null, prcGroup1: string | null } | null } | null> | null, productVariant: Array<{ __typename: 'TempProduct', id: string | null, name: string | null, salesUnit: string | null, baseUnit: string | null, purchaseUnit: string | null, materialType: string | null, variants: Array<{ __typename: 'TempProductVariant', id: string | null, salesUnit: string | null, descriptionEn: string | null, limitQuantity: number | null, variantType: string | null, code: string | null, name: string | null } | null> | null } | null> | null } | null };

export type CustomerCheckoutContractQueryVariables = Exact<{
  id: Scalars['ID'];
  sortBy?: InputMaybe<CustomerProductSortingInput>;
}>;


export type CustomerCheckoutContractQuery = { __typename: 'Query', customerCheckoutContract: { __typename: 'CustomerContract', id: string | null, code: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, customer: { __typename: 'ScgUserDetail', id: string, lastName: string, firstName: string, customerNo: string | null } | null, company: { __typename: 'CompanyMaster', id: number | null, name: string | null, businessUnit: { __typename: 'BusinessUnits', name: string | null } | null } | null, soldTo: { __typename: 'SoldToMaster', code: string | null, name: string | null } | null, products: Array<{ __typename: 'CustomerContractProduct', id: string | null, weight: number | null, weightUnit: string | null, remainingQuantity: number | null, totalQuantity: number | null, pricePerUnit: number | null, product: { __typename: 'CustomerProduct', id: string | null, slug: string | null, materialType: string | null, name: string | null } | null } | null> | null } | null };

export type ContractOrderQueryVariables = Exact<{
  soNo: Scalars['String'];
}>;


export type ContractOrderQuery = { __typename: 'Query', contractOrder: { __typename: 'TempOrder', id: string | null, status: string | null, poDate: any | null, poNumber: string | null, shipTo: string | null, billTo: string | null, requestDate: any | null, internalCommentsToWarehouse: string | null, internalCommentsToLogistic: string | null, externalCommentsToCustomer: string | null, productInformation: string | null, orderType: string | null, totalPrice: number | null, contract: { __typename: 'TempContract', currency: string | null } | null, customer: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, soldToCode: string | null, representatives: Array<{ __typename: 'ScgpUser', firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', streetAddress1: string, streetAddress2: string }> | null } | null> | null } | null, saleOrganization: { __typename: 'SalesOrganization', id: string | null, name: string | null, code: string | null } | null, distributionChannel: { __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null, division: { __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null, saleOffice: { __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null, saleGroup: { __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null, orderLines: Array<{ __typename: 'TempOrderLine', id: string | null, quantity: number | null, plant: string | null, price: number | null, netPrice: number | null, requestDate: any | null, internalCommentsToWarehouse: string | null, shipTo: string | null, paymentTerm: string | null, productInformation: string | null, order: { __typename: 'TempOrder', id: string | null } | null, product: { __typename: 'TempProduct', id: string | null, name: string | null, salesUnit: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, name: string | null, weight: string | null } | null, checkoutLine: { __typename: 'ContractCheckoutLine', id: string | null } | null, contractProduct: { __typename: 'TempContractProduct', total: number | null, remain: number | null, price: number | null, plant: string | null, deliveryOver: number | null, deliveryUnder: number | null } | null } | null> | null } | null };

export type CustomerCartsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CustomerCartsSortingInput>;
  soldToId: Scalars['ID'];
}>;


export type CustomerCartsQuery = { __typename: 'Query', customerCarts: { __typename: 'CustomerCartCountableConnection', edges: Array<{ __typename: 'CustomerCartCountableEdge', node: { __typename: 'CustomerCart', id: string | null, quantity: number | null, contract: { __typename: 'CustomerContract', code: string | null, projectName: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type CustomerCartTotalsQueryVariables = Exact<{
  soldToId: Scalars['ID'];
}>;


export type CustomerCartTotalsQuery = { __typename: 'Query', customerCartTotals: { __typename: 'CustomerCartTotals', totalContracts: number | null, totalProducts: number | null } | null };

export type CustomerCartQueryVariables = Exact<{
  cartId: Scalars['ID'];
}>;


export type CustomerCartQuery = { __typename: 'Query', customerCart: { __typename: 'CustomerCart', id: string | null, quantity: number | null, contract: { __typename: 'CustomerContract', id: string | null, code: string | null, projectName: string | null } | null, cartItems: Array<{ __typename: 'CustomerCartItem', id: string | null, quantity: number | null, contractProductId: string | null, variant: { __typename: 'CustomerProductVariant', id: string | null, limitQuantity: number | null, name: string | null, salesUnit: string | null } | null }> | null } | null };

export type CustomerCartProductVariantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerCartProductVariantQuery = { __typename: 'Query', customerCartProductVariant: { __typename: 'CustomerCartProductVariant', contractProduct: Array<{ __typename: 'CustomerContractProduct', id: string | null, quantityUnit: string | null, remainingQuantity: number | null, materialDescription: string | null, product: { __typename: 'CustomerProduct', id: string | null, slug: string | null, materialType: string | null, descriptionEn: string | null, name: string | null, variants: Array<{ __typename: 'CustomerProductVariant', id: string | null, descriptionEn: string | null, descriptionTh: string | null, salesUnit: string | null, weight: number | null, limitQuantity: number | null, name: string | null } | null> | null } | null } | null> | null } | null };

export type CustomerContractProductQueryVariables = Exact<{
  contractId: Scalars['ID'];
  productId: Scalars['ID'];
  contractMaterialId: Scalars['ID'];
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomerContractProductQuery = { __typename: 'Query', customerContractProduct: { __typename: 'CustomerContractProduct', id: string | null, totalQuantity: number | null, remainingQuantity: number | null, pricePerUnit: number | null, currency: string | null, weightUnit: string | null, product: { __typename: 'CustomerProduct', slug: string | null, descriptionEn: string | null, name: string | null, variants: Array<{ __typename: 'CustomerProductVariant', id: string | null, variantType: string | null, descriptionTh: string | null, descriptionEn: string | null, weight: number | null, name: string | null } | null> | null } | null, contract: { __typename: 'CustomerContract', currency: string | null } | null } | null };

export type MaterialSearchSuggestionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<MaterialMasterFilterInput>;
  distributionChannelType: DistributionChannelType;
}>;


export type MaterialSearchSuggestionQuery = { __typename: 'Query', materialSearchSuggestion: { __typename: 'TempProductCountableConnection', edges: Array<{ __typename: 'TempProductCountableEdge', node: { __typename: 'MaterialInfo', id: string | null, code: string | null } }> } | null };

export type GradeGramSearchSuggestionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<MaterialMasterFilterInput>;
  distributionChannelType: DistributionChannelType;
}>;


export type GradeGramSearchSuggestionQuery = { __typename: 'Query', materialSearchSuggestion: { __typename: 'TempProductCountableConnection', edges: Array<{ __typename: 'TempProductCountableEdge', node: { __typename: 'MaterialInfo', id: string | null, name: string | null, code: string | null } }> } | null };

export type GetCartProductItemsQueryVariables = Exact<{
  soldToCode: Scalars['String'];
  contractCode: Scalars['String'];
}>;


export type GetCartProductItemsQuery = { __typename: 'Query', cartProductItems: Array<{ __typename: 'ContractCheckoutLine', id: string | null, quantity: number | null, selected: boolean | null, product: { __typename: 'TempProduct', id: string | null, name: string | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, name: string | null, weight: string | null, salesUnit: string | null } | null } | null> | null };

export type CreateCustomerOrderMutationVariables = Exact<{
  input: CreateCustomerOrderInput;
}>;


export type CreateCustomerOrderMutation = { __typename: 'Mutation', createCustomerOrder: { __typename: 'CreateCustomerOrder', order: { __typename: 'CustomerOrder', id: string | null, totalPrice: number | null, totalPriceIncTax: number | null, taxAmount: number | null, status: string | null, orderDate: any | null, orderNo: string | null, requestDeliveryDate: any | null, shipTo: string | null, billTo: string | null, unloadingPoint: string | null, remarkForInvoice: string | null, remarkForLogistic: string | null, createdAt: any | null, updatedAt: any | null, contract: { __typename: 'CustomerContract', code: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null, representatives: Array<{ __typename: 'ScgpUser', id: string | null, email: string } | null> | null } | null, company: { __typename: 'CompanyMaster', id: number | null, name: string | null } | null } | null, lines: Array<{ __typename: 'CustomerOrderLine', quantity: number | null, quantityUnit: string | null, weightPerUnit: number | null, totalWeight: number | null, pricePerUnit: number | null, totalPrice: number | null, requestDeliveryDate: any | null, order: { __typename: 'CustomerOrder', orderNo: string | null } | null, contractProduct: { __typename: 'CustomerContractProduct', pricePerUnit: number | null, quantityUnit: string | null, currency: string | null, weight: number | null, weightUnit: string | null, contract: { __typename: 'CustomerContract', projectName: string | null } | null, product: { __typename: 'CustomerProduct', name: string | null, slug: string | null } | null } | null, variant: { __typename: 'CustomerProductVariant', name: string | null, slug: string | null } | null } | null> | null } | null, errors: Array<{ __typename: 'ScgpCustomerError', field: string | null, message: string | null, code: ScgpCustomerErrorCode }> } | null };

export type AddProductToCustomerOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: Array<CustomerOrderLineInput> | CustomerOrderLineInput;
}>;


export type AddProductToCustomerOrderMutation = { __typename: 'Mutation', addProductToCustomerOrder: { __typename: 'CustomerOrderAddProduct', order: { __typename: 'CustomerOrder', id: string | null } | null, errors: Array<{ __typename: 'ScgpCustomerError', message: string | null, code: ScgpCustomerErrorCode }> } | null };

export type UpdateCustomerOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CustomerOrderInformationUpdateInput;
}>;


export type UpdateCustomerOrderMutation = { __typename: 'Mutation', updateCustomerOrder: { __typename: 'CustomerOrderUpdate', success: boolean | null, errors: Array<{ __typename: 'ScgpCustomerError', field: string | null, message: string | null, code: ScgpCustomerErrorCode }>, order: { __typename: 'CustomerOrder', id: string | null, status: string | null } | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, itemNo: string | null, errorMessage: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type DeleteCustomerOrderLinesMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  deleteAll?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteCustomerOrderLinesMutation = { __typename: 'Mutation', deleteCustomerOrderLines: { __typename: 'CustomerOrderLinesDelete', status: boolean | null, errors: Array<{ __typename: 'ScgpCustomerError', field: string | null, message: string | null }> } | null };

export type UpdateCustomerOrderLinesMutationVariables = Exact<{
  orderId: Scalars['ID'];
  input: CustomerOrderLinesUpdateInput;
}>;


export type UpdateCustomerOrderLinesMutation = { __typename: 'Mutation', updateCustomerOrderLines: { __typename: 'CustomerOrderLinesUpdate', errors: Array<{ __typename: 'ScgpCustomerError', field: string | null, message: string | null, code: ScgpCustomerErrorCode }>, order: { __typename: 'CustomerOrder', id: string | null } | null } | null };

export type UpdateRequestDateOnIplanMutationVariables = Exact<{
  orderLinesId: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  confirm?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRequestDateOnIplanMutation = { __typename: 'Mutation', updateRequestDateOnIplan: { __typename: 'UpdateRequestDateOnIplan', status: boolean | null, errors: Array<{ __typename: 'ScgpCustomerError', field: string | null, message: string | null, code: ScgpCustomerErrorCode }> } | null };

export type CustomerUnloadingPointsQueryVariables = Exact<{
  soldTo: Scalars['String'];
}>;


export type CustomerUnloadingPointsQuery = { __typename: 'Query', contractUnloadingPoint: Array<{ __typename: 'CustomerUnloadingPoint', unloadingPoint: string | null } | null> | null };

export type CustomerContractsQueryVariables = Exact<{
  contractNo?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  soldToId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerContractFilterInput>;
  sortBy?: InputMaybe<CustomerContractsSortingInput>;
}>;


export type CustomerContractsQuery = { __typename: 'Query', scgpCustomerContracts: { __typename: 'CustomerContractCountableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'CustomerContractCountableEdge', node: { __typename: 'CustomerContract', id: string | null, code: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, paymentTermKey: string | null, paymentTermDescriptionTh: string | null, soldTo: { __typename: 'SoldToMaster', representatives: Array<{ __typename: 'ScgpUser', id: string | null } | null> | null } | null, company: { __typename: 'CompanyMaster', name: string | null, shortName: string | null, fullName: string | null } | null, customer: { __typename: 'ScgUserDetail', id: string } | null, products: Array<{ __typename: 'CustomerContractProduct', totalQuantity: number | null, remainingQuantity: number | null, pricePerUnit: number | null, quantityUnit: string | null, currency: string | null, weight: number | null, weightUnit: string | null, limitQuantity: number | null } | null> | null } }> } | null };

export type CustomerOrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerOrderQuery = { __typename: 'Query', customerOrder: { __typename: 'CustomerOrderExtended', id: string | null, totalPrice: number | null, totalPriceIncTax: number | null, taxAmount: number | null, taxPercent: number | null, orderDate: any | null, orderNo: string | null, requestDeliveryDate: any | null, shipTo: string | null, billTo: string | null, unloadingPoint: string | null, remarkForInvoice: string | null, remarkForLogistic: string | null, status: string | null, contract: { __typename: 'CustomerContract', id: string | null, code: string | null, projectName: string | null, paymentTerm: string | null, paymentTermDescriptionTh: string | null, currency: string | null, startDate: any | null, endDate: any | null, company: { __typename: 'CompanyMaster', id: number | null, name: string | null, businessUnit: { __typename: 'BusinessUnits', id: string | null, name: string | null } | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null } | null, lines: { __typename: 'CustomerOrderLineCountableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'CustomerOrderLineCountableEdge', node: { __typename: 'CustomerOrderLine', availableQuantity: number | null, id: string | null, quantity: number | null, quantityUnit: string | null, weightPerUnit: number | null, totalWeight: number | null, pricePerUnit: number | null, totalPrice: number | null, requestDeliveryDate: any | null, contractProduct: { __typename: 'CustomerContractProduct', id: string | null, pricePerUnit: number | null, remainingQuantity: number | null, totalQuantity: number | null, contract: { __typename: 'CustomerContract', id: string | null, paymentTerm: string | null, paymentTermDescriptionTh: string | null } | null, product: { __typename: 'CustomerProduct', id: string | null, name: string | null } | null } | null, variant: { __typename: 'CustomerProductVariant', id: string | null, name: string | null, descriptionEn: string | null, limitQuantity: number | null } | null } }> } | null } | null };

export type CustomerOrderHeaderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type CustomerOrderHeaderQuery = { __typename: 'Query', customerOrder: { __typename: 'CustomerOrderExtended', id: string | null, soldToAddress: string | null, totalPrice: number | null, totalPriceIncTax: number | null, taxPercent: number | null, taxAmount: number | null, orderDate: any | null, orderNo: string | null, requestDeliveryDate: any | null, shipTo: string | null, billTo: string | null, unloadingPoint: string | null, internalCommentsToWarehouse: string | null, internalCommentsToLogistic: string | null, remarkForInvoice: string | null, remarkForLogistic: string | null, status: string | null, contract: { __typename: 'CustomerContract', id: string | null, currency: string | null, code: string | null, projectName: string | null, paymentTerm: string | null, paymentTermDescriptionTh: string | null, startDate: any | null, endDate: any | null, company: { __typename: 'CompanyMaster', id: number | null, name: string | null, businessUnit: { __typename: 'BusinessUnits', id: string | null, name: string | null } | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null } | null, createdBy: { __typename: 'ScgUser', id: string, firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', streetAddress1: string, streetAddress2: string }> | null, company: { __typename: 'Company', id: string, name: string } | null } | null } | null };

export type ScgpCustomerContractQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScgpCustomerContractQuery = { __typename: 'Query', scgpCustomerContract: { __typename: 'CustomerContract', id: string | null, code: string | null, currency: string | null, projectName: string | null, startDate: any | null, endDate: any | null, paymentTerm: string | null, paymentTermKey: string | null, paymentTermDescriptionTh: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null, customer: { __typename: 'ScgUserDetail', id: string, firstName: string, lastName: string, customerNo: string | null } | null, company: { __typename: 'CompanyMaster', name: string | null, shortName: string | null, fullName: string | null, businessUnit: { __typename: 'BusinessUnits', name: string | null } | null } | null, products: Array<{ __typename: 'CustomerContractProduct', id: string | null, weightUnit: string | null, remainingQuantity: number | null, totalQuantity: number | null, pricePerUnit: number | null, limitQuantity: number | null, materialDescription: string | null, product: { __typename: 'CustomerProduct', name: string | null, id: string | null, materialType: string | null, descriptionEn: string | null } | null } | null> | null } | null };

export type PreviewCustomerOrderQueryVariables = Exact<{
  id: Scalars['ID'];
  sortBy?: InputMaybe<OrderLinesSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type PreviewCustomerOrderQuery = { __typename: 'Query', previewCustomerOrder: { __typename: 'PreviewOrderLines', id: string | null, totalPrice: number | null, taxAmount: number | null, totalPriceIncTax: number | null, soNo: string | null, poNo: string | null, orderNo: string | null, createdAt: any | null, paymentTerm: string | null, paymentTermDescriptionTh: string | null, shipTo: string | null, customerSoldToOrder: string | null, soldToAddress: string | null, currency: { __typename: 'CurrencyMaster', code: string | null } | null, contract: { __typename: 'CustomerContract', code: string | null, projectName: string | null } | null, previewOrderLines: { __typename: 'OrderLinesCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null }, edges: Array<{ __typename: 'OrderLinesCountableEdge', node: { __typename: 'PreviewCustomerTempOrderLine', id: string | null, itemNo: string | null, materialVariantCode: string | null, materialDescription: string | null, quantity: number | null, logErrors: string | null, logOldProduct: string | null, descriptionEn: string | null, salesUnit: string | null, orderQuantityTon: number | null, requestDeliveryDate: any | null, confirmedDate: any | null, originalRequestDate: any | null, contractProduct: { __typename: 'CustomerContractProduct', product: { __typename: 'CustomerProduct', descriptionEn: string | null, salesUnit: string | null } | null } | null } }> } | null, failOrderLines: Array<{ __typename: 'CustomerOrderLine', id: string | null, itemNo: string | null, materialVariantCode: string | null, materialDescription: string | null, descriptionEn: string | null, quantity: number | null, salesUnit: string | null, orderQuantityTon: number | null, requestDeliveryDate: any | null, confirmedDate: any | null, contractProduct: { __typename: 'CustomerContractProduct', product: { __typename: 'CustomerProduct', descriptionEn: string | null, salesUnit: string | null } | null } | null } | null> | null } | null };

export type UpdateOrderLinesDomesticMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ContractOrderLinesUpdateInput;
}>;


export type UpdateOrderLinesDomesticMutation = { __typename: 'Mutation', updateOrderLines: { __typename: 'ContractOrderLinesUpdate', errors: Array<{ __typename: 'ContractCheckoutError', message: string | null, code: ContractCheckoutErrorCode }>, order: { __typename: 'TempOrder', id: string | null, orderLines: Array<{ __typename: 'TempOrderLine', id: string | null, requestDate: any | null, productInformation: string | null, unit: string | null, externalCommentsToCustomer: string | null, internalCommentsToLogistic: string | null, internalCommentsToWarehouse: string | null, shipTo: string | null, billTo: string | null, shippingPoint: string | null, route: string | null } | null> | null } | null } | null };

export type DeleteContractOrderLinesDomesticMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteContractOrderLinesDomesticMutation = { __typename: 'Mutation', deleteContractOrderLines: { __typename: 'ContractOrderLinesDelete', errors: Array<{ __typename: 'ContractCheckoutError', code: ContractCheckoutErrorCode, field: string | null, message: string | null }> } | null };

export type DeleteAndSyncOrderLineMutationVariables = Exact<{
  soNo?: InputMaybe<Scalars['String']>;
}>;


export type DeleteAndSyncOrderLineMutation = { __typename: 'Mutation', deleteAndSyncOrderLine: { __typename: 'DeleteAndSyncOrderLine', status: string | null } | null };

export type UpdateAllContractOrderLineDomesticMutationVariables = Exact<{
  id: Scalars['ID'];
  plant?: InputMaybe<Scalars['String']>;
  requestDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateAllContractOrderLineDomesticMutation = { __typename: 'Mutation', updateAllContractOrderLine: { __typename: 'ContractOrderLineALlUpdate', orderline: Array<{ __typename: 'TempOrderLine', id: string | null } | null> | null } | null };

export type UpdateRequireAttentionItemsParameterDomesticMutationVariables = Exact<{
  input?: InputMaybe<RequireAttentionItemParameterUpdateInput>;
  itemsId: Scalars['String'];
}>;


export type UpdateRequireAttentionItemsParameterDomesticMutation = { __typename: 'Mutation', updateRequireAttentionItemsParameter: { __typename: 'RequireAttentionItemsUpdateParameter', errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', field: string | null, message: string | null, code: ScgpRequireAttentionItemsErrorCode }>, requireAttentionItems: { __typename: 'OrderLineIPlan', inquiryMethodCode: string | null, transportationMethod: string | null, typeOfDeliveryValue: string | null, fixSourceAssignment: string | null, splitOrderItemValue: string | null, partialDeliveryValue: string | null, consignmentValue: string | null } | null } | null };

export type UpdateContractOrderDomesticMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ContractOrderUpdateInput;
}>;


export type UpdateContractOrderDomesticMutation = { __typename: 'Mutation', updateContractOrder: { __typename: 'ContractOrderUpdate', success: boolean | null, order: { __typename: 'TempOrder', id: string | null } | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, errorMessage: string | null, itemNo: string | null } | null> | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }>, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null, eorWarnings: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type ChangeParameterIPlanMutationVariables = Exact<{
  orderLineId: Scalars['ID'];
}>;


export type ChangeParameterIPlanMutation = { __typename: 'Mutation', changeParameterIPlan: { __typename: 'ChangeParameterIPlan', errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', field: string | null, message: string | null, code: ScgpRequireAttentionItemsErrorCode }>, dropdown: { __typename: 'ChangeParameterIPlanType', dropdownDomesticOrExport: string | null, dropdownAsapClearStock: string | null } | null } | null };

export type PassParameterToIPlanMutationVariables = Exact<{
  inquiryMethodCode: Scalars['String'];
  orderLineId: Scalars['ID'];
}>;


export type PassParameterToIPlanMutation = { __typename: 'Mutation', passParameterToIPlan: { __typename: 'PassParameterToIPlan', status: boolean | null } | null };

export type Get_Realtime_PartnerMutationVariables = Exact<{
  distributionChannel: Scalars['String'];
  division: Scalars['String'];
  saleOrgCode: Scalars['String'];
  soldToCode: Scalars['String'];
  piMessageId: Scalars['String'];
  orderType?: InputMaybe<OrderType>;
  type: Array<InputMaybe<RealtimePartnerType>> | InputMaybe<RealtimePartnerType>;
}>;


export type Get_Realtime_PartnerMutation = { __typename: 'Mutation', getSapRealtimePartner: { __typename: 'CallAPISapRealtimePartner', rawResponse: string | null, response: Array<{ __typename: 'RealtimePartner', partnerFunction: string | null, partnerFunctionDesc: string | null, partnerNo: string | null, partnerName: string | null, displayText: string | null, addressText: string | null } | null> | null } | null };

export type AddProductsToDomesticOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: Array<DomesticOrderLineAddProductInput> | DomesticOrderLineAddProductInput;
}>;


export type AddProductsToDomesticOrderMutation = { __typename: 'Mutation', addProductsToDomesticOrder: { __typename: 'AddProductsToDomesticOrder', errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }>, order: { __typename: 'TempOrder', id: string | null } | null, orderLines: Array<{ __typename: 'TempOrderLine', id: string | null, paymentTerm: string | null, itemNo: string | null, inquiryMethod: string | null, requestDate: any | null, requestDateChangeReason: string | null, confirmedDate: any | null, shippingMark: string | null, quantity: number | null, unit: string | null, weight: number | null, weightUnit: string | null, plant: string | null, price: number | null, netPrice: number | null, priceCurrency: string | null, paymentCondition: string | null, itemCategory: string | null, shippingPoint: string | null, route: string | null, poNo: string | null, poNoExternal: string | null, poDate: any | null, overDeliveryTol: number | null, underDeliveryTol: number | null, deliveryTolUnlimited: boolean | null, prcGroup1: string | null, shipTo: string | null, internalCommentsToWarehouse: string | null, externalCommentsToCustomer: string | null, internalCommentsToLogistic: string | null, productInformation: string | null, status: string | null, product: { __typename: 'TempProduct', id: string | null, code: string | null, description: string | null, salesUnit: string | null } | null, iplan: { __typename: 'OrderLineIPlan', atpCtp: string | null, atpCtpDetail: string | null, block: string | null, run: string | null, paperMachine: string | null, iplantConfirmQuantity: number | null, salesUnit: string | null } | null, variant: { __typename: 'TempProductVariant', id: string | null, weight: string | null, code: string | null, descriptionTh: string | null, descriptionEn: string | null } | null, contractProduct: { __typename: 'TempContractProduct', id: string | null, remain: number | null, price: number | null, currency: string | null, matGroup1: string | null, matGroup1Desc: string | null } | null } | null> | null } | null };

export type PreviewDomesticPageOrderQueryVariables = Exact<{
  id: Scalars['ID'];
  sortBy?: InputMaybe<DomesticOrderLinesSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type PreviewDomesticPageOrderQuery = { __typename: 'Query', previewDomesticPageOrder: { __typename: 'PreviewDomesticOrderLines', id: string | null, soNo: string | null, poNumber: string | null, createdAt: any | null, paymentTerm: string | null, paymentTermKey: string | null, paymentTermDescTh: string | null, poDate: any | null, poNo: string | null, shipTo: string | null, billTo: string | null, totalPrice: number | null, taxAmount: number | null, totalPriceIncTax: number | null, currency: string | null, contract: { __typename: 'TempContract', projectName: string | null, code: string | null } | null, soldTo: { __typename: 'SoldToMaster', soldToCode: string | null, soldToName: string | null, addressText: string | null } | null, previewOrderLines: { __typename: 'DomesticOrderLinesCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'DomesticOrderLinesCountableEdge', node: { __typename: 'PreviewTempOrderLine', id: string | null, itemNo: string | null, prcGroup1: string | null, unit: string | null, salesUnit: string | null, weightUnit: string | null, weightUnitTon: string | null, netWeightTon: string | null, logErrors: string | null, logOldProduct: string | null, descriptionEn: string | null, quantity: number | null, orderQuantityTon: number | null, requestDate: any | null, originalRequestDate: any | null, confirmedDate: any | null, plant: string | null, variant: { __typename: 'TempProductVariant', code: string | null, salesUnit: string | null } | null } }> } | null } | null };

export type SearchSuggestionDomesticSoldTosQueryVariables = Exact<{
  bu?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DomesticSoldToFilterInput>;
}>;


export type SearchSuggestionDomesticSoldTosQuery = { __typename: 'Query', searchSuggestionDomesticSoldTos: { __typename: 'DomesticSoldToCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'DomesticSoldToCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, displayText: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type CreateExportCartMutationVariables = Exact<{
  input: ExportCartCreateInput;
}>;


export type CreateExportCartMutation = { __typename: 'Mutation', createExportCart: { __typename: 'ExportCartCreate', cart: { __typename: 'ExportCart', id: string | null, items: Array<{ __typename: 'ExportCartItem', id: string | null } | null> | null } | null, errors: Array<{ __typename: 'ScgpExportError', message: string | null }> } | null };

export type CreateExportOrderMutationVariables = Exact<{
  input: ExportOrderCreateInput;
}>;


export type CreateExportOrderMutation = { __typename: 'Mutation', createExportOrder: { __typename: 'ExportOrderCreate', order: { __typename: 'ExportOrderExtended', id: string | null } | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type DeleteExportCartItemsMutationVariables = Exact<{
  cartItemIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteExportCartItemsMutation = { __typename: 'Mutation', deleteExportCartItems: { __typename: 'ExportCartItemsDelete', status: string | null, errors: Array<{ __typename: 'ScgpExportError', code: ScgpExportErrorCode, message: string | null, field: string | null }> } | null };

export type AddProductsToExportOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: Array<ExportOrderLineAddProductInput> | ExportOrderLineAddProductInput;
}>;


export type AddProductsToExportOrderMutation = { __typename: 'Mutation', addProductsToExportOrder: { __typename: 'ExportOrderAddProducts', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, order: { __typename: 'ExportOrderExtended', id: string | null, lines: { __typename: 'ExportOrderLineCountableConnection', edges: Array<{ __typename: 'ExportOrderLineCountableEdge', node: { __typename: 'ExportOrderLine', id: string | null, itemNo: number | null, materialCode: string | null, materialDescription: string | null, quantity: number | null, quantityUnit: string | null, weight: number | null, weightUnit: string | null, salesUnit: string | null, itemCatEo: string | null, plant: string | null, refPiNo: string | null, requestDate: any | null, confirmedDate: any | null, rejectReason: string | null, conditionGroup1: string | null, route: string | null, rollQuantity: string | null, rollDiameter: string | null, rollCoreDiameter: string | null, remark: string | null, palletSize: string | null, palletNo: string | null, rollPerPallet: string | null, packageQuantity: string | null, packingList: string | null, commissionPercent: number | null, commissionAmount: number | null, commissionUnit: string | null, shippingPoint: string | null, deliveryTolOver: number | null, deliveryTolUnder: number | null, deliveryTolUnlimited: boolean | null, materialGroup2: string | null, inquiryMethod: string | null, piProduct: { __typename: 'ContractMaterial', id: string | null, materialCode: string | null, pricePerUnit: number | null, matGroup1: string | null, currency: string | null, remainingQuantity: number | null, remainingQuantityEx: number | null, limitQuantity: number | null, weight: number | null, weightUnit: string | null, calculation: string | null, product: { __typename: 'MaterialMaster', materialGroup: string | null, widthOfRoll: string | null, lengthOfRoll: string | null, id: string | null, name: string | null, salesUnit: string | null, slug: string | null } | null } | null } }> } | null } | null } | null };

export type UpdateAllExportOrderLineMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ExportOrderLineUpdateAllInput;
}>;


export type UpdateAllExportOrderLineMutation = { __typename: 'Mutation', updateAllExportOrderLine: { __typename: 'ExportOrderLineUpdateAll', errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, order: { __typename: 'ExportOrderExtended', id: string | null } | null } | null };

export type UpdateExportCartMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ExportCartUpdateInput;
}>;


export type UpdateExportCartMutation = { __typename: 'Mutation', updateExportCart: { __typename: 'ExportCartUpdate', cart: { __typename: 'ExportCart', id: string | null, pi: { __typename: 'ExportPI', id: string | null, code: string | null, poNo: string | null } | null, soldTo: { __typename: 'SoldToMaster', id: string | null } | null, createdBy: { __typename: 'ScgUser', id: string } | null, items: Array<{ __typename: 'ExportCartItem', id: string | null, quantity: number | null, piProduct: { __typename: 'ExportPIProduct', id: string | null } | null } | null> | null } | null } | null };

export type UpdateExportOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ExportOrderUpdateInput;
}>;


export type UpdateExportOrderMutation = { __typename: 'Mutation', updateExportOrder: { __typename: 'ExportOrderUpdate', success: boolean | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }>, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, errorMessage: string | null, itemNo: string | null } | null> | null, order: { __typename: 'ExportOrderExtended', id: string | null, soNo: string | null } | null, iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null } | null> | null, warningMessages: Array<{ __typename: 'WarningMessage', message: string | null, order: string | null, source: string | null } | null> | null } | null };

export type DeleteExportOrderLinesMutationVariables = Exact<{
  deleteAll?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteExportOrderLinesMutation = { __typename: 'Mutation', deleteExportOrderLines: { __typename: 'ExportOrderLinesDelete', status: boolean | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type UpdateExportOrderLinesMutationVariables = Exact<{
  id: Scalars['ID'];
  input: Array<ExportOrderLineUpdateInput> | ExportOrderLineUpdateInput;
}>;


export type UpdateExportOrderLinesMutation = { __typename: 'Mutation', updateExportOrderLines: { __typename: 'ExportOrderLineUpdate', order: { __typename: 'ExportOrderExtended', id: string | null, totalPrice: number | null, taxAmount: number | null, currency: string | null, status: string | null, requestDeliveryDate: any | null, orderType: string | null, shippingMark: string | null, contactPerson: string | null, pi: { __typename: 'SapContract', id: string | null, code: string | null, poNo: string | null, soldToName: string | null, shipToName: string | null, shipToCountry: string | null, incoterm: string | null, paymentTerm: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, addressText: string | null } | null } | null, lines: { __typename: 'ExportOrderLineCountableConnection', edges: Array<{ __typename: 'ExportOrderLineCountableEdge', node: { __typename: 'ExportOrderLine', id: string | null, quantity: number | null, quantityUnit: string | null, weight: number | null, weightUnit: string | null, vatPercent: number | null, itemCatEo: string | null, plant: string | null, refPiNo: string | null, requestDate: any | null, route: string | null, deliveryTolOver: number | null, deliveryTolUnder: number | null, deliveryTolUnlimited: boolean | null, rollDiameter: string | null, rollCoreDiameter: string | null, rollQuantity: string | null, rollPerPallet: string | null, palletSize: string | null, palletNo: string | null, packageQuantity: string | null, packingList: string | null, shippingPoint: string | null, remark: string | null, rejectReason: string | null, conditionGroup1: string | null, materialGroup2: string | null, commissionPercent: number | null, commissionAmount: number | null, commissionUnit: string | null, piProduct: { __typename: 'ContractMaterial', id: string | null, totalQuantity: number | null, remainingQuantity: number | null, pricePerUnit: number | null, quantityUnit: string | null, currency: string | null, weight: number | null, weightUnit: string | null, pi: { __typename: 'SapContract', id: string | null, code: string | null, poNo: string | null, soldToName: string | null, shipToName: string | null, shipToCountry: string | null, incoterm: string | null, paymentTerm: string | null } | null, product: { __typename: 'MaterialMaster', id: string | null, name: string | null, description: string | null } | null } | null } }> } | null } | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type UpdateDraftExportCartMutationVariables = Exact<{
  cartId: Scalars['ID'];
  input: ExportCartDraftUpdateInput;
}>;


export type UpdateDraftExportCartMutation = { __typename: 'Mutation', updateDraftExportCart: { __typename: 'ExportCartDraftUpdate', cart: { __typename: 'ExportCart', id: string | null } | null, errors: Array<{ __typename: 'ScgpExportError', message: string | null }> } | null };

export type ExportSoldTosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExportSoldToFilterInput>;
}>;


export type ExportSoldTosQuery = { __typename: 'Query', exportSoldTos: { __typename: 'ExportSoldToCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'ExportSoldToCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, displayText: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type ExportPisQueryVariables = Exact<{
  filter?: InputMaybe<ExportPiFilterInput>;
  sortBy?: InputMaybe<ExportPIsSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type ExportPisQuery = { __typename: 'Query', exportPis: { __typename: 'ExportPICountableConnection', totalCount: number | null, latestPageItemNumber: number | null, edges: Array<{ __typename: 'ExportPICountableEdge', node: { __typename: 'ExportPI', id: string | null, code: string | null, poNo: string | null, shipToName: string | null, shipToCountry: string | null, incoterm: string | null, paymentTerm: string | null, paymentTermKey: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, displayText: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type ExportPiQueryVariables = Exact<{
  id: Scalars['ID'];
  sortBy?: InputMaybe<ExportPiProductsSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type ExportPiQuery = { __typename: 'Query', exportPi: { __typename: 'ExportPI', id: string | null, code: string | null, salesOrganizationCode: string | null, soldToName: string | null, poNo: string | null, incoterm: string | null, paymentTerm: string | null, shipToCountry: string | null, shipToName: string | null, currency: string | null, soldTo: { __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null, piProducts: { __typename: 'ExportPIProductCountTableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'ExportPIProductCountTableEdge', node: { __typename: 'ExportPIProduct', id: string | null, salesUnit: string | null, weight: number | null, quantityUnit: string | null, totalQuantity: number | null, remainingQuantity: number | null, weightUnit: string | null, pricePerUnit: number | null, currency: string | null, calculation: string | null, limitQuantity: number | null, limitQuantityOrderLine: number | null, cartQuantity: number | null, remainingQuantityEx: number | null, product: { __typename: 'ExportProduct', id: string | null, name: string | null, description: string | null } | null } }> } | null } | null };

export type ExportCartsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CartPiFilterInput>;
  sortBy?: InputMaybe<ExportCartSortingInput>;
}>;


export type ExportCartsQuery = { __typename: 'Query', exportCarts: { __typename: 'ExportCartExtended', totalPi: number | null, totalSoldTo: number | null, totalCartItem: number | null, carts: { __typename: 'ExportCartCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'ExportCartCountableEdge', node: { __typename: 'ExportCart', id: string | null, totalItems: number | null, pi: { __typename: 'ExportPI', code: string | null } | null, soldTo: { __typename: 'SoldToMaster', code: string | null, name: string | null } | null } }> } | null } | null };

export type ExportCartsSearchQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CartFilterInput>;
  sortBy?: InputMaybe<ExportCartSortingInput>;
}>;


export type ExportCartsSearchQuery = { __typename: 'Query', exportCartsSearch: { __typename: 'ExportCartSearchExtended', totalPi: number | null, totalSoldTo: number | null, totalCartItem: number | null, exportCarts: { __typename: 'ExportCartCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'ExportCartCountableEdge', node: { __typename: 'ExportCart', id: string | null, totalItems: number | null, pi: { __typename: 'ExportPI', code: string | null } | null, soldTo: { __typename: 'SoldToMaster', code: string | null, name: string | null } | null } }> } | null } | null };

export type TotalCountExportCartQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalCountExportCartQuery = { __typename: 'Query', exportCarts: { __typename: 'ExportCartExtended', totalPi: number | null, totalSoldTo: number | null, totalCartItem: number | null } | null };

export type GetCartDetailDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<ExportCartItemSortingInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type GetCartDetailDataQuery = { __typename: 'Query', exportCart: { __typename: 'ExportCartDetail', id: string | null, totalItems: number | null, pi: { __typename: 'ExportPI', id: string | null, code: string | null, currency: string | null } | null, soldTo: { __typename: 'SoldToMaster', name: string | null, code: string | null } | null, items: { __typename: 'ExportCartItemsCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'ExportCartItemsCountableEdge', node: { __typename: 'ExportCartItem', id: string | null, quantity: number | null, piProduct: { __typename: 'ExportPIProduct', id: string | null, totalQuantity: number | null, remainingQuantity: number | null, remainingQuantityEx: number | null, weight: number | null, pricePerUnit: number | null, quantityUnit: string | null, currency: string | null, weightUnit: string | null, salesUnit: string | null, calculation: string | null, limitQuantity: number | null, limitQuantityOrderLine: number | null, product: { __typename: 'ExportProduct', name: string | null, slug: string | null } | null } | null } }> } | null } | null };

export type GetDataSelectAgencyTabQueryVariables = Exact<{
  saleOrg?: InputMaybe<Scalars['String']>;
}>;


export type GetDataSelectAgencyTabQuery = { __typename: 'Query', salesOrganizations: Array<{ __typename: 'SalesOrganization', id: string | null, code: string | null, name: string | null } | null> | null, distributionChannelsExport: Array<{ __typename: 'DistributionChannel', id: string | null, name: string | null, code: string | null } | null> | null, scgDivisions: Array<{ __typename: 'ScgDivision', id: string | null, name: string | null, code: string | null } | null> | null, salesOffices: Array<{ __typename: 'SalesOffice', id: string | null, name: string | null, code: string | null } | null> | null, salesGroups: Array<{ __typename: 'SalesGroup', id: string | null, name: string | null, code: string | null } | null> | null };

export type ExportCustomerMaterialTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportCustomerMaterialTemplateMutation = { __typename: 'Mutation', exportCustomerMaterialTemplate: { __typename: 'CustomerMaterialTemplateExport', fileName: string | null, contentType: string | null, exportedFileBase64: string | null, errors: Array<{ __typename: 'ContractCheckoutError', field: string | null, message: string | null, code: ContractCheckoutErrorCode }> } | null };

export type UploadCustomerMaterialsMutationVariables = Exact<{
  file: Scalars['Upload'];
  input: CustomerMaterialUploadInput;
}>;


export type UploadCustomerMaterialsMutation = { __typename: 'Mutation', uploadCustomerMaterials: { __typename: 'UploadCustomerMaterials', status: boolean | null, rows: string | null, errors: Array<{ __typename: 'CustomerMaterialUploadError', field: string | null, message: string | null, data: { __typename: 'CustomerMaterialErrorData', soldToCode: string | null, salesOrganizationCode: string | null, distributionChannelCode: string | null, soldToMaterialCode: string | null, materialCode: string | null } | null }> } | null };

export type DownloadCustomerMaterialExcelMutationVariables = Exact<{
  distributionChannelId?: InputMaybe<Scalars['ID']>;
  saleOrganizationId?: InputMaybe<Scalars['String']>;
  soldToCode?: InputMaybe<Scalars['String']>;
}>;


export type DownloadCustomerMaterialExcelMutation = { __typename: 'Mutation', downloadCustomerMaterialExcel: { __typename: 'DownloadCustomerMaterialExcel', success: boolean | null, fileName: string | null, exportedFileBase64: string | null, errorMessage: string | null } | null };

export type UpdateCustomerMaterialsMutationVariables = Exact<{
  id: Scalars['ID'];
  soldToMaterialCode: Scalars['String'];
  materialCode: Scalars['String'];
}>;


export type UpdateCustomerMaterialsMutation = { __typename: 'Mutation', updateCustomerMaterials: { __typename: 'UpdateCustomerMaterials', status: boolean | null, items: Array<{ __typename: 'CustomerMaterialData', soldToMaterialCode: string | null, materialCode: string | null } | null> | null, itemErrors: Array<{ __typename: 'ItemErrorType', soldToMaterialCode: boolean | null, materialCode: boolean | null } | null> | null } | null };

export type AddCustomerMaterialsMutationVariables = Exact<{
  soldTo: Scalars['String'];
  saleOrg: Scalars['String'];
  distribution: Scalars['String'];
  items: Array<CustomerMaterialItemInput> | CustomerMaterialItemInput;
}>;


export type AddCustomerMaterialsMutation = { __typename: 'Mutation', addCustomerMaterials: { __typename: 'AddCustomerMaterials', status: boolean | null, items: Array<{ __typename: 'CustomerMaterialData', distributionChannelCode: string | null, id: string | null, materialCode: string | null, soldToMaterialCode: string | null, salesOrganization: { __typename: 'SalesOrganization', code: string | null, displayText: string | null } | null, soldTo: { __typename: 'SoldToMaster', code: string | null, displayText: string | null } | null } | null> | null, itemErrors: Array<{ __typename: 'ItemErrorType', soldToMaterialCode: boolean | null, materialCode: boolean | null } | null> | null } | null };

export type SearchSuggestionSoldTosCustMatQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DomesticSoldToFilterInput>;
}>;


export type SearchSuggestionSoldTosCustMatQuery = { __typename: 'Query', searchSuggestionSoldTosCustMat: { __typename: 'DomesticSoldToCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'DomesticSoldToCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, name: string | null, code: string | null, domesticSoldToSearchFilterDisplayText: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetSaleOrgAndDistChannelBySoldToQueryVariables = Exact<{
  soldTo: Scalars['String'];
}>;


export type GetSaleOrgAndDistChannelBySoldToQuery = { __typename: 'Query', getSaleOrgAndDistChannelBySoldTo: { __typename: 'GetSaleOrgDistChannelBySoldToRes', salesOrganization: Array<{ __typename: 'SalesOrganization', id: string | null, code: string | null, shortName: string | null, displayText: string | null } | null> | null, distributionChannel: Array<{ __typename: 'DistributionChannel', id: string | null, code: string | null, name: string | null, displayText: string | null } | null> | null, salesOrgByDistChannel: Array<{ __typename: 'SaleOrgByDistChannelRes', salesOrg: string | null, distributionChannel: Array<{ __typename: 'DistributionChannel', id: string | null, code: string | null, name: string | null, displayText: string | null } | null> | null } | null> | null, distChannelBySalesOrg: Array<{ __typename: 'DistChannelBySalesOrgRes', distributionChannel: string | null, salesOrg: Array<{ __typename: 'SalesOrganization', id: string | null, code: string | null, shortName: string | null, displayText: string | null } | null> | null } | null> | null } | null };

export type CustomerMaterialsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerMaterialInput>;
}>;


export type CustomerMaterialsQuery = { __typename: 'Query', customerMaterials: Array<{ __typename: 'CustomerMaterialData', id: string | null, distributionChannelCode: string | null, soldToMaterialCode: string | null, materialCode: string | null, soldTo: { __typename: 'SoldToMaster', code: string | null, name: string | null, displayText: string | null } | null, salesOrganization: { __typename: 'SalesOrganization', code: string | null, name: string | null, displayText: string | null } | null, sapMaterial: { __typename: 'SAPMaterialData', materialCode: string | null, materialDescription: string | null, displayText: string | null } | null } | null> | null };

export type ListCustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerFilterInput>;
  sort?: InputMaybe<UserSortingInput>;
  PERMISSION_MANAGE_ORDERS: Scalars['Boolean'];
}>;


export type ListCustomersQuery = { __typename: 'Query', customers: { __typename: 'UserCountableConnection', edges: Array<{ __typename: 'UserCountableEdge', node: { __typename: 'User', id: string, email: string, firstName: string, lastName: string } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type CustomerDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  PERMISSION_MANAGE_ORDERS: Scalars['Boolean'];
}>;


export type CustomerDetailsQuery = { __typename: 'Query', user: { __typename: 'User', dateJoined: any, lastLogin: any | null, note: string | null, isActive: boolean, id: string, email: string, firstName: string, lastName: string, defaultShippingAddress: { __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } } | null, defaultBillingAddress: { __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } } | null, metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> } | null };

export type CustomerAddressesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerAddressesQuery = { __typename: 'Query', user: { __typename: 'User', id: string, email: string, firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } }> | null, defaultBillingAddress: { __typename: 'Address', id: string } | null, defaultShippingAddress: { __typename: 'Address', id: string } | null } | null };

export type CustomerCreateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCreateDataQuery = { __typename: 'Query', shop: { __typename: 'Shop', countries: Array<{ __typename: 'CountryDisplay', code: string, country: string }> } };

export type DeliverySoldToQueryVariables = Exact<{
  filter?: InputMaybe<DomesticSoldToFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type DeliverySoldToQuery = { __typename: 'Query', deliverySoldTo: { __typename: 'DomesticSoldToCountableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'DomesticSoldToCountableEdge', node: { __typename: 'SoldToMaster', soldToCode: string | null, soldToName: string | null } }> } | null };

export type DeliveryMaterialCodeDescriptionQueryVariables = Exact<{
  filter?: InputMaybe<MaterialCodeDescriptionFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type DeliveryMaterialCodeDescriptionQuery = { __typename: 'Query', deliveryMaterialCodeDescription: { __typename: 'MaterialCodeDescriptionCountableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'MaterialCodeDescriptionCountableEdge', node: { __typename: 'TempProductVariant', code: string | null, descriptionEn: string | null } }> } | null };

export type DeliverySalesOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliverySalesOrganizationQuery = { __typename: 'Query', deliverySalesOrganization: Array<{ __typename: 'SalesOrganization', code: string | null, name: string | null } | null> | null };

export type GetSalesOrgBySoldToQueryVariables = Exact<{
  soldToCode: Scalars['String'];
}>;


export type GetSalesOrgBySoldToQuery = { __typename: 'Query', getSalesOrgBySoldTo: Array<{ __typename: 'salesOrgSoldTo', name: string | null, code: string | null, shortName: string | null, fullName: string | null, businessUnit: { __typename: 'BusinessUnits', id: string | null, code: string | null, name: string | null } | null } | null> | null };

export type GetLmsReportCsCustomerQueryVariables = Exact<{
  filter?: InputMaybe<LmsReportCsCustomerInput>;
}>;


export type GetLmsReportCsCustomerQuery = { __typename: 'Query', getLmsReportCsCustomer: Array<{ __typename: 'LMSReportCSCustomer', dnNo: string | null, soldToCode: string | null, soldToName: string | null, destinationName: string | null, cutOffDate: string | null, cutOffTime: string | null, truckNo: string | null, originName: string | null, planDelivery: string | null, statusId: string | null, statusText: string | null, boxPosition: string | null, etaDistance: string | null, estimatedTime: string | null, carrierName: string | null, boxSpeed: string | null, boxGpsTime: string | null, shipment: string | null, accDistance: string | null, goodIssueTime: string | null, destinationInbound: string | null, eta: string | null, etaDuration: string | null, status: string | null, message: string | null, shippingPoint: string | null, returnFlag: string | null, phoneNo: string | null, contractId: string | null, contractAbbr: string | null, giTime: string | null, summaryGrandTotal: number | null, dataItem: Array<{ __typename: 'DataItems', poNo: string | null, soNo: string | null, itemNo: string | null, materialDescription: string | null, deliveryQty: number | null, saleUnit: string | null, lmsStatus: string | null, matNumber: string | null, deliveryWeight: string | null, weightUnitTon: string | null, parentItemNo: string | null, delivery: string | null, deliveryGrp: string | null, deliveryItem: string | null, billNo: string | null } | null> | null } | null> | null };

export type GetListLmsReportCsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListLmsReportCsAdminQuery = { __typename: 'Query', listLmsReportCsAdmin: Array<{ __typename: 'LMSReportCSAdmin', dpNo: string | null, poNo: string | null, soNo: string | null, itemNo: string | null, materialDescription: string | null, quantity: number | null, saleUnit: string | null, soldToCodeName: string | null, shipToName: string | null, giDateTime: string | null, carRegistrationNo: string | null, departurePlacePosition: string | null, estimateDateTime: string | null, transportationStatus: string | null, currentPosition: string | null, remainingDistanceAsKilometers: string | null, estimatedArrivalDateAndTime: string | null } | null> | null };

export type GetGpsTrackingQueryVariables = Exact<{
  gpsTracking: Scalars['String'];
}>;


export type GetGpsTrackingQuery = { __typename: 'Query', getGpsTracking: { __typename: 'GPSTracking', shipmentNo: string | null, carRegistrationNo: string | null, currentPosition: string | null, carrier: string | null, speed: number | null, dateAndTimeOfTheLastSignalReceived: string | null, paymentNo: string | null, placeOfDelivery: string | null, carStatus: string | null, destinationReachTime: string | null, estimateToCustomersFromTheirCurrentLocation: string | null, approximateRemainingDistance: number | null, estimatedTime: string | null, estimatedArrivalTime: string | null, distanceFromFactoryToCustomer: number | null, dateOfIssuanceOfInvoice: string | null, deliveryDeadline: string | null } | null };

export type GetDpHyperlinkQueryVariables = Exact<{
  dpNo: Scalars['String'];
}>;


export type GetDpHyperlinkQuery = { __typename: 'Query', getDpHyperlink: { __typename: 'DPHyperLink', totalQuantity: number | null, dpNoLines: Array<{ __typename: 'DPHyperLinkDetail', dpNo: string | null, poNo: string | null, soNo: string | null, materialDescription: string | null, quantity: number | null, saleUnit: string | null } | null> | null } | null };

export type GetgpsReportCsCustomerQueryVariables = Exact<{
  filter?: InputMaybe<GpsReportCsCustomerInput>;
}>;


export type GetgpsReportCsCustomerQuery = { __typename: 'Query', getGpsReportCsCustomer: Array<{ __typename: 'GPSReportCSCustomer', truckNo: string | null, boxPosition: string | null, carrierName: string | null, boxSpeed: string | null, boxGpsTime: string | null, shipment: string | null, dnNo: string | null, destinationName: string | null, statusId: string | null, destinationInbound: string | null, eta: string | null, etaDistance: string | null, etaDuration: string | null, estimatedTime: string | null, accDistance: string | null, goodIssueTime: string | null, planDelivery: string | null, statusText: string | null } | null> | null };

export type GetCustomerLmsReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerLmsReportQuery = { __typename: 'Query', customerLmsReport: Array<{ __typename: 'LmsReportCustomer', dpNo: string | null, poNo: string | null, soNo: string | null, itemNo: string | null, departurePlacePositions: string | null, materialDescription: string | null, quantity: number | null, shipTo: string | null, giDate: any | null, carRegistrationNo: string | null, estimateDateTime: any | null, transportStatus: string | null, currentPosition: string | null, remainingDistanceAsKilometer: string | null, estimatedArrivalDatetime: string | null, saleUnit: string | null, gpsTracking: { __typename: 'CustomerGpsTracking', shipmentNo: string | null, estimatedTime: string | null, carRegistrationNo: string | null, currentPosition: string | null, carrier: string | null, velocity: number | null, lastSignalReceivedDatetime: any | null, paymentNumber: string | null, deliveryPlace: string | null, carStatus: string | null, destinationReachTime: any | null, estimatedToCustomerFromCurrentLocation: any | null, remainingDistanceAsKilometer: string | null, estimateArrivalTime: any | null, distanceFromFactoryToCustomer: number | null, isssuanceOfInvoiceDate: any | null, deliveryDeadline: any | null } | null } | null> | null };

export type ExportExcelUploadTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportExcelUploadTemplateMutation = { __typename: 'Mutation', exportExcelUploadTemplate: { __typename: 'ExcelUploadTemplateExport', exportedFileBase64: string | null, fileName: string | null } | null };

export type ExcelUploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  orderType: Scalars['String'];
  saleOrg: Scalars['String'];
  uploadType: UploadType;
  distributionChannel: Scalars['String'];
  division: Scalars['String'];
}>;


export type ExcelUploadFileMutation = { __typename: 'Mutation', uploadExcel: { __typename: 'ExcelUploadFileMutation', status: boolean | null, rows: string | null, errors: Array<{ __typename: 'ScgpPoUploadError', field: string | null, code: ScgpPoUploadErrorCode, message: string | null }> } | null };

export type ValidExcelFileMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type ValidExcelFileMutation = { __typename: 'Mutation', validExcelFile: { __typename: 'CheckExcelFileNameInvalid', valid: boolean | null, errors: Array<{ __typename: 'ScgpPoUploadError', field: string | null, code: ScgpPoUploadErrorCode, message: string | null }> } | null };

export type AddressFragment = { __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } };

export type UserPermissionFragment = { __typename: 'UserPermission', code: PermissionEnum, name: string };

export type UserFragment = { __typename: 'User', id: string, email: string, firstName: string, lastName: string, isStaff: boolean, displayName: string | null, isSuperuser: boolean | null, userPermissions: Array<{ __typename: 'UserPermission', code: PermissionEnum, name: string }> | null, avatar: { __typename: 'Image', url: string } | null };

export type UserBaseFragment = { __typename: 'User', id: string, firstName: string, lastName: string };

export type CustomerFragment = { __typename: 'User', id: string, email: string, firstName: string, lastName: string };

export type CustomerDetailsFragment = { __typename: 'User', dateJoined: any, lastLogin: any | null, note: string | null, isActive: boolean, id: string, email: string, firstName: string, lastName: string, defaultShippingAddress: { __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } } | null, defaultBillingAddress: { __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } } | null, metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> };

export type CustomerAddressesFragment = { __typename: 'User', id: string, email: string, firstName: string, lastName: string, addresses: Array<{ __typename: 'Address', city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, id: string, lastName: string, phone: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename: 'CountryDisplay', code: string, country: string } }> | null, defaultBillingAddress: { __typename: 'Address', id: string } | null, defaultShippingAddress: { __typename: 'Address', id: string } | null };

export type AccountErrorFragment = { __typename: 'AccountError', code: AccountErrorCode, field: string | null, message: string | null };

export type ShopErrorFragment = { __typename: 'ShopError', code: ShopErrorCode, field: string | null, message: string | null };

export type UploadErrorFragment = { __typename: 'UploadError', code: UploadErrorCode, field: string | null, message: string | null };

export type ShopSettingsUpdateErrorFragmentFragment = { __typename: 'ShopError', code: ShopErrorCode, field: string | null, message: string | null };

export type ShopFetchTaxRatesErrorFragmentFragment = { __typename: 'ShopError', code: ShopErrorCode, field: string | null, message: string | null };

export type ProductTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type ProductVariantTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type CategoryTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type CollectionTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type PageTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type VoucherTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type SaleTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type AttributeTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type AttributeValueTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type ShippingPriceTranslateErrorFragmentFragment = { __typename: 'TranslationError', code: TranslationErrorCode, field: string | null, message: string | null };

export type FileFragment = { __typename: 'File', url: string, contentType: string | null };

export type GiftCardsSettingsFragment = { __typename: 'GiftCardSettings', expiryType: GiftCardSettingsExpiryTypeEnum, expiryPeriod: { __typename: 'TimePeriod', type: TimePeriodTypeEnum, amount: number } | null };

export type MetadataItemFragment = { __typename: 'MetadataItem', key: string, value: string };

type Metadata_SapCustomer_Fragment = { __typename: 'SAPCustomer', metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> };

type Metadata_ScgUser_Fragment = { __typename: 'ScgUser', metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> };

type Metadata_ScgUserDetail_Fragment = { __typename: 'ScgUserDetail', metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> };

type Metadata_User_Fragment = { __typename: 'User', metadata: Array<{ __typename: 'MetadataItem', key: string, value: string }>, privateMetadata: Array<{ __typename: 'MetadataItem', key: string, value: string }> };

export type MetadataFragment = Metadata_SapCustomer_Fragment | Metadata_ScgUser_Fragment | Metadata_ScgUserDetail_Fragment | Metadata_User_Fragment;

export type OrderSettingsFragment = { __typename: 'OrderSettings', automaticallyConfirmAllNewOrders: boolean, automaticallyFulfillNonShippableGiftCard: boolean };

export type ShopOrderSettingsFragment = { __typename: 'Shop', fulfillmentAutoApprove: boolean, fulfillmentAllowUnpaid: boolean };

export type PageInfoFragment = { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null };

export type PermissionGroupFragment = { __typename: 'Group', id: string, name: string, users: Array<{ __typename: 'User', id: string, firstName: string, lastName: string }> | null };

export type PermissionFragment = { __typename: 'Permission', code: PermissionEnum, name: string };

export type PermissionGroupMemberFragment = { __typename: 'User', id: string, email: string, firstName: string, isActive: boolean, lastName: string, avatar: { __typename: 'Image', url: string } | null };

export type PermissionGroupDetailsFragment = { __typename: 'Group', id: string, name: string, permissions: Array<{ __typename: 'Permission', code: PermissionEnum, name: string }> | null, users: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string, isActive: boolean, avatar: { __typename: 'Image', url: string } | null }> | null };

export type CountryWithCodeFragment = { __typename: 'CountryDisplay', country: string, code: string };

export type LanguageFragment = { __typename: 'LanguageDisplay', code: LanguageCodeEnum, language: string };

export type LimitInfoFragment = { __typename: 'Limits', channels?: number | null, orders?: number | null, productVariants?: number | null, staffUsers?: number | null, warehouses?: number | null };

export type ShopLimitFragment = { __typename: 'Shop', limits: { __typename: 'LimitInfo', currentUsage: { __typename: 'Limits', channels?: number | null, orders?: number | null, productVariants?: number | null, staffUsers?: number | null, warehouses?: number | null }, allowedUsage: { __typename: 'Limits', channels?: number | null, orders?: number | null, productVariants?: number | null, staffUsers?: number | null, warehouses?: number | null } } };

export type ShopFragment = { __typename: 'Shop', customerSetPasswordUrl: string | null, defaultMailSenderAddress: string | null, defaultMailSenderName: string | null, description: string | null, name: string, reserveStockDurationAnonymousUser: number | null, reserveStockDurationAuthenticatedUser: number | null, limitQuantityPerCheckout: number | null, countries: Array<{ __typename: 'CountryDisplay', code: string, country: string }>, domain: { __typename: 'Domain', host: string } };

export type StaffMemberFragment = { __typename: 'User', id: string, email: string, firstName: string, isActive: boolean, lastName: string };

export type StaffMemberDetailsFragment = { __typename: 'User', id: string, email: string, firstName: string, isActive: boolean, lastName: string, permissionGroups: Array<{ __typename: 'Group', id: string, name: string }> | null, userPermissions: Array<{ __typename: 'UserPermission', code: PermissionEnum, name: string }> | null, avatar: { __typename: 'Image', url: string } | null };

export type CountryFragment = { __typename: 'CountryDisplay', country: string, code: string };

export type CountryWithTaxesFragment = { __typename: 'CountryDisplay', country: string, code: string, vat: { __typename: 'VAT', standardRate: number | null, reducedRates: Array<{ __typename: 'ReducedRate', rateType: string, rate: number }> } | null };

export type ShopTaxesFragment = { __typename: 'Shop', chargeTaxesOnShipping: boolean, includeTaxesInPrices: boolean, displayGrossPrices: boolean };

export type TimePeriodFragment = { __typename: 'TimePeriod', amount: number, type: TimePeriodTypeEnum };

export type FilterMaterialCodeNameCustomerOrderQueryVariables = Exact<{
  distributionChannelType: DistributionChannelType;
  filter?: InputMaybe<CustomerMaterialCodeNameFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterMaterialCodeNameCustomerOrderQuery = { __typename: 'Query', filterMaterialCodeNameCustomerOrder: { __typename: 'CustomerMaterialCodeNameCountTableConnection', edges: Array<{ __typename: 'CustomerMaterialCodeNameCountTableEdge', node: { __typename: 'CustomerProductVariant', name: string | null, slug: string | null, code: string | null, descriptionEn: string | null } }> } | null };

export type FilterCustomerBusinessUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterCustomerBusinessUnitQuery = { __typename: 'Query', filterCustomerBusinessUnit: Array<{ __typename: 'CustomerBusinessUnit', isDefaultForInquirySearch: boolean | null, label: string | null, value: string | null } | null> | null };

export type FilterCustomerCompanyByBuQueryVariables = Exact<{
  filter?: InputMaybe<CustomerCompanyFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterCustomerCompanyByBuQuery = { __typename: 'Query', filterCustomerCompanyByBu: { __typename: 'CustomerCompanyCountTableConnection', edges: Array<{ __typename: 'CustomerCompanyCountTableEdge', node: { __typename: 'CustomerCompany', name: string | null, shortName: string | null, code: string | null } }> } | null };

export type FilterCustomerSalesGroupByCompanyQueryVariables = Exact<{
  filter?: InputMaybe<CustomerSalesGroupFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterCustomerSalesGroupByCompanyQuery = { __typename: 'Query', filterCustomerSalesGroupByCompany: { __typename: 'CustomerSalesGroupCountTableConnection', edges: Array<{ __typename: 'CustomerSalesGroupCountTableEdge', node: { __typename: 'CustomerSalesGroup', name: string | null, code: string | null } }> } | null };

export type CustomerOrdersQueryVariables = Exact<{
  sortBy?: InputMaybe<CustomerOrderSortingInput>;
  filter?: InputMaybe<CustomerOrderFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerOrdersQuery = { __typename: 'Query', customerOrders: { __typename: 'CustomerOrderCountTableConnection', totalCount: number | null, latestPageItemNumber: number | null, edges: Array<{ __typename: 'CustomerOrderCountTableEdge', node: { __typename: 'CustomerOrder', id: string | null, soNo: string | null, poNo: string | null, customerSoldToOrder: string | null, paymentTerm: string | null, orderDate: any | null, status: string | null, contract: { __typename: 'CustomerContract', code: string | null, projectName: string | null, soldTo: { __typename: 'SoldToMaster', displayText: string | null } | null } | null, soldTo: { __typename: 'SoldToMaster', displayText: string | null } | null, company: { __typename: 'CustomerCompany', name: string | null, code: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type CustomerOrdersFromSapQueryVariables = Exact<{
  input?: InputMaybe<SapOrderRequest>;
}>;


export type CustomerOrdersFromSapQuery = { __typename: 'Query', customerOrdersFromSap: Array<{ __typename: 'SAPOrderMapping', sdDoc: string | null, status: string | null, createDate: string | null, createTime: string | null, poNo: string | null, salesOrg: string | null, descriptionInContract: string | null, creditStatus: string | null, deliverStatus: string | null, soldTo: string | null, soldToName1: string | null, shipTo: string | null, shipToName1: string | null, countrySh: string | null, countryName: string | null, incotermS1: string | null, incotermS2: string | null, paymentTerm: string | null, paymentTermDesc: string | null, eOrderingStatus: string | null, contractPi: string | null, id: string | null } | null> | null };

export type FilterRequireAttentionSalesOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterRequireAttentionSalesOrganizationQuery = { __typename: 'Query', filterRequireAttentionSalesOrganization: Array<{ __typename: 'SalesOrganization', name: string | null, code: string | null, shortName: string | null } | null> | null };

export type DropDownListOrderTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type DropDownListOrderTypeQuery = { __typename: 'Query', dropDownListOrderType: Array<{ __typename: 'ExportOrder', orderType: string | null } | null> | null };

export type FilterRequireAttentionSalesGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterRequireAttentionSalesGroupQuery = { __typename: 'Query', filterRequireAttentionSalesGroup: Array<{ __typename: 'SalesGroup', name: string | null, code: string | null } | null> | null };

export type FilterRequireAttentionSoldToQueryVariables = Exact<{
  filter?: InputMaybe<RequireAttentionSoldToFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterRequireAttentionSoldToQuery = { __typename: 'Query', filterRequireAttentionSoldTo: { __typename: 'RequireAttentionSoldToCountTableConnection', totalCount: number | null, edges: Array<{ __typename: 'RequireAttentionSoldToCountTableEdge', node: { __typename: 'RequireAttentionSoldTo', name: string | null, code: string | null } }> } | null };

export type FilterRequireAttentionSaleEmployeeQueryVariables = Exact<{
  filter?: InputMaybe<RequireAttentionSaleEmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterRequireAttentionSaleEmployeeQuery = { __typename: 'Query', filterRequireAttentionSaleEmployee: { __typename: 'RequireAttentionSaleEmployeeCountTableConnection', edges: Array<{ __typename: 'RequireAttentionSaleEmployeeCountTableEdge', node: { __typename: 'ScgpSalesEmployee', name: string | null, code: string | null } }> } | null };

export type DropdownListMaterialGroup1QueryVariables = Exact<{
  bu?: InputMaybe<Scalars['String']>;
}>;


export type DropdownListMaterialGroup1Query = { __typename: 'Query', dropdownListMaterialGroup1: Array<{ __typename: 'MaterialSaleMaster', materialGroup1: string | null, materialGroup1Desc: string | null, salesOrganizationCode: string | null } | null> | null };

export type DropDownMaterialPricingGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type DropDownMaterialPricingGroupQuery = { __typename: 'Query', dropDownMaterialPricingGroup: Array<{ __typename: 'RequireAttentionItems', materialPricingGroup: string | null } | null> | null };

export type SuggestionSearchCreateBySaleOrderQueryVariables = Exact<{
  filter?: InputMaybe<SuggestionSearchUserByNameFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionSearchCreateBySaleOrderQuery = { __typename: 'Query', suggestionSearchCreateBySaleOrder: { __typename: 'CreateByCountableConnection', edges: Array<{ __typename: 'CreateByCountableEdge', node: { __typename: 'CreateBy', userId: string | null, firstName: string, lastName: string } }> } | null };

export type ListRequireAttentionFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRequireAttentionFlagQuery = { __typename: 'Query', listRequireAttentionFlag: Array<{ __typename: 'RequireAttentionFlag', key: string | null, value: string | null } | null> | null };

export type ListOfSaleOrderAndExcelQueryVariables = Exact<{
  filter?: InputMaybe<SapListOfSaleOrderInput>;
}>;


export type ListOfSaleOrderAndExcelQuery = { __typename: 'Query', listOfSaleOrderAndExcel: { __typename: 'SAPListOfSaleOrderAndExcel', listOfSaleOrderSap: Array<{ __typename: 'SAPListOfSaleOrder', totalSoldTo: number | null, soldTo: string | null, soldToName1: string | null, orderLines: Array<{ __typename: 'SAPOrderLine', createDateTime: string | null, salesOrg: string | null, salesGroup: string | null, poNo: string | null, originalRequestDate: string | null, createDate: string | null, reqDeliveryDate: string | null, orderNo: string | null, itemNo: string | null, matNo: string | null, matDesc: string | null, materialPricingGroup: string | null, orderQty: string | null, confirmOrderQty: string | null, deliveryQty: string | null, pendingQty: string | null, unit: string | null, plant: string | null, shippingPoint: string | null, orderWeight: string | null, deliveryWeight: string | null, pendingWeight: string | null, weightUnit: string | null, netPrice: string | null, netValue: string | null, currency: string | null, rejection: string | null, deliveryBlock: string | null, eOrderingOverdue1: boolean | null, eOrderingOverdue2: boolean | null, eOrderingRequiredAttentionFlag: string | null, eOrderingCreateBy: string | null, eOrderingConfirmDate: string | null, eOrderingItemStatus: string | null, sapStatus: string | null, orderTrackingStatus: string | null, priceDate: string | null, trackingUrl: string | null, bomFlag: boolean | null, parentItemNo: string | null, isNotRef: boolean | null, orderType: string | null, billTo: string | null, shipTo: string | null, unloadingPoint: string | null, paymentTerm: string | null, headerNote: string | null, itemNote: string | null, oldMaterialNo: string | null, descriptionSaleText: string | null, batchNo: string | null, productionFlag: string | null, deliveryToleranceUnder: number | null, deliveryToleranceOver: number | null, prNumberOs: string | null, prItemOs: string | null, salesEmployeeName: string | null } | null> | null, summary: { __typename: 'SAPListOfSaleOrderSummary', orderQty: string | null, confirmOrderQty: string | null, deliveryQty: string | null, pendingQty: string | null, unit: string | null, orderWeight: string | null, deliveryWeight: string | null, pendingWeight: string | null, weightUnit: string | null, netPrice: string | null, netValue: string | null, currency: string | null, quantityData: Array<{ __typename: 'QuantitySummaryData', orderQty: string | null, confirmOrderQty: string | null, deliveryQty: string | null, pendingQty: string | null, quantityUnit: string | null } | null> | null } | null } | null> | null } | null };

export type DownloadListOfSaleOrderExcelQueryVariables = Exact<{
  filter?: InputMaybe<SapListOfSaleOrderInput>;
}>;


export type DownloadListOfSaleOrderExcelQuery = { __typename: 'Query', downloadListOfSaleOrderExcel: { __typename: 'SAPListOfSaleOrderAndExcel', excel: string | null } | null };

export type DownloadReportListOfSalesOrderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SalesOrderFilterInput>;
  sortBy?: InputMaybe<Array<InputMaybe<InputSalesOrder>> | InputMaybe<InputSalesOrder>>;
}>;


export type DownloadReportListOfSalesOrderQuery = { __typename: 'Query', downloadReportSaleOrder: string | null, reportListOfSalesOrderDownload: { __typename: 'ReportListOfSalesOrderCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'ReportListOfSalesOrderCountableEdge', node: { __typename: 'ReportListOfSalesOrder', id: string | null, soldToCode: string | null, soldToName: string | null, salesOrder: { __typename: 'SalesOrderCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'SalesOrderCountableEdge', node: { __typename: 'SalesOrder', id: string | null, requireAttentionFlag: string | null, createBy: string | null, createDateTime: any | null, salesOrg: string | null, saleGroup: string | null, soldTo: string | null, poNo: string | null, originalRequestDate: any | null, createDate: any | null, reqDeliveryDate: any | null, confirmDate: any | null, orderNo: string | null, orderItem: string | null, materialCodeDescription: string | null, orderQty: number | null, confirmOrderQty: number | null, deliveryQty: number | null, pendingQty: number | null, unit: string | null, plant: string | null, shippingPoint: string | null, orderWeight: number | null, pendingWeight: number | null, deliveryWeight: number | null, weightUnit: string | null, netPrice: number | null, netValue: number | null, currency: string | null, rejection: string | null, deliveryBlock: string | null, overdue1: boolean | null, overdue2: boolean | null } }> } | null } }> } | null };

export type ListSourceOfAppQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSourceOfAppQuery = { __typename: 'Query', listSourceOfApp: Array<{ __typename: 'SourceOfApp', key: string | null, value: string | null } | null> | null };

export type ListOrderTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrderTypesQuery = { __typename: 'Query', listOrderTypes: Array<{ __typename: 'OrderTypeResponse', label: string | null, value: string | null, bu: string | null } | null> | null };

export type ListPlantsByBuQueryVariables = Exact<{
  bu: Scalars['String'];
}>;


export type ListPlantsByBuQuery = { __typename: 'Query', listPlantsByBu: Array<{ __typename: 'PlantResponse', plantCode: string | null, plantName: string | null } | null> | null };

export type OrderSettingsUpdateMutationVariables = Exact<{
  shopSettingsInput: ShopSettingsInput;
}>;


export type OrderSettingsUpdateMutation = { __typename: 'Mutation', shopSettingsUpdate: { __typename: 'ShopSettingsUpdate', errors: Array<{ __typename: 'ShopError', code: ShopErrorCode, field: string | null, message: string | null }>, shop: { __typename: 'Shop', fulfillmentAutoApprove: boolean, fulfillmentAllowUnpaid: boolean } | null } | null };

export type OrderFulfillSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderFulfillSettingsQuery = { __typename: 'Query', shop: { __typename: 'Shop', fulfillmentAutoApprove: boolean, fulfillmentAllowUnpaid: boolean } };

export type OrderSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSettingsQuery = { __typename: 'Query', orderSettings: { __typename: 'OrderSettings', automaticallyConfirmAllNewOrders: boolean, automaticallyFulfillNonShippableGiftCard: boolean } | null, shop: { __typename: 'Shop', fulfillmentAutoApprove: boolean, fulfillmentAllowUnpaid: boolean } };

export type PermissionGroupListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PermissionGroupFilterInput>;
  sort?: InputMaybe<PermissionGroupSortingInput>;
}>;


export type PermissionGroupListQuery = { __typename: 'Query', permissionGroups: { __typename: 'GroupCountableConnection', edges: Array<{ __typename: 'GroupCountableEdge', node: { __typename: 'Group', id: string, name: string, users: Array<{ __typename: 'User', id: string, firstName: string, lastName: string }> | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type PermissionGroupDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type PermissionGroupDetailsQuery = { __typename: 'Query', permissionGroup: { __typename: 'Group', id: string, name: string, permissions: Array<{ __typename: 'Permission', code: PermissionEnum, name: string }> | null, users: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string, isActive: boolean, avatar: { __typename: 'Image', url: string } | null }> | null } | null, user: { __typename: 'User', editableGroups: Array<{ __typename: 'Group', id: string }> | null, userPermissions: Array<{ __typename: 'UserPermission', code: PermissionEnum, sourcePermissionGroups: Array<{ __typename: 'Group', id: string }> | null }> | null } | null };

export type PoUploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  soldToCode?: InputMaybe<Scalars['String']>;
}>;


export type PoUploadFileMutation = { __typename: 'Mutation', uploadPo: { __typename: 'PoUploadFileMutation', status: boolean | null, errors: Array<{ __typename: 'ScgpPoUploadError', field: string | null, code: ScgpPoUploadErrorCode, message: string | null }> } | null };

export type RetryUploadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RetryUploadMutation = { __typename: 'Mutation', retryUpload: { __typename: 'PoUploadRetryUploadFile', status: boolean | null, errors: Array<{ __typename: 'ScgpPoUploadError', field: string | null, message: string | null, code: ScgpPoUploadErrorCode }> } | null };

export type PoUploadCustomerSettingsCreateMutationVariables = Exact<{
  soldToId?: InputMaybe<Scalars['ID']>;
}>;


export type PoUploadCustomerSettingsCreateMutation = { __typename: 'Mutation', poUploadCustomerSettingsCreate: { __typename: 'PoUploadCustomerSettingsCreate', errors: Array<{ __typename: 'ScgpPoUploadError', message: string | null, code: ScgpPoUploadErrorCode }> } | null };

export type PoUploadCustomerSettingsUpdateMutationVariables = Exact<{
  soldToId?: InputMaybe<Scalars['ID']>;
  useCustomerMaster?: InputMaybe<Scalars['Boolean']>;
}>;


export type PoUploadCustomerSettingsUpdateMutation = { __typename: 'Mutation', poUploadCustomerSettingsUpdate: { __typename: 'PoUploadCustomerSettingsUpdate', errors: Array<{ __typename: 'ScgpPoUploadError', message: string | null, code: ScgpPoUploadErrorCode }> } | null };

export type PoUploadCustomerSettingsDeleteMutationVariables = Exact<{
  soldToId?: InputMaybe<Scalars['ID']>;
}>;


export type PoUploadCustomerSettingsDeleteMutation = { __typename: 'Mutation', poUploadCustomerSettingsDelete: { __typename: 'PoUploadCustomerSettingsDelete', errors: Array<{ __typename: 'ScgpPoUploadError', message: string | null, code: ScgpPoUploadErrorCode }> } | null };

export type FailedFilesQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PoUploadFileLogSorterInput>;
}>;


export type FailedFilesQuery = { __typename: 'Query', failedFiles: { __typename: 'POUploadFileLogCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null }, edges: Array<{ __typename: 'POUploadFileLogCountableEdge', node: { __typename: 'POUploadFileLog', id: string | null, status: string | null, fileName: string | null, updatedAt: any | null } }> } | null };

export type PoUploadCustomerSettingsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type PoUploadCustomerSettingsQuery = { __typename: 'Query', poUploadCustomerSettings: { __typename: 'PoUploadCustomerSettingsCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'PoUploadCustomerSettingsCountableEdge', node: { __typename: 'PoUploadCustomerSettings', useCustomerMaster: boolean | null, soldTo: { __typename: 'SoldToMaster', id: string | null, soldToCode: string | null, soldToName: string | null } | null } }> } | null };

export type PoUploadSuggestionSearchSoldToQueryVariables = Exact<{
  filter?: InputMaybe<SoldToMasterFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type PoUploadSuggestionSearchSoldToQuery = { __typename: 'Query', poUploadSuggestionSearchSoldTo: { __typename: 'SoldToMasterCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'SoldToMasterCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, soldToCode: string | null, soldToName: string | null } }> } | null };

export type UpdateRequireAttentionItemsParameterMutationVariables = Exact<{
  input: RequireAttentionItemParameterUpdateInput;
  itemsId: Scalars['String'];
}>;


export type UpdateRequireAttentionItemsParameterMutation = { __typename: 'Mutation', updateRequireAttentionItemsParameter: { __typename: 'RequireAttentionItemsUpdateParameter', errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', field: string | null, message: string | null, code: ScgpRequireAttentionItemsErrorCode }>, requireAttentionItems: { __typename: 'OrderLineIPlan', inquiryMethodCode: string | null, transportationMethod: string | null, typeOfDelivery: string | null, typeOfDeliveryValue: string | null, fixSourceAssignment: string | null, splitOrderItem: string | null, splitOrderItemValue: string | null, partialDelivery: string | null, partialDeliveryValue: string | null, consignment: string | null, consignmentValue: string | null } | null } | null };

export type AcceptConfirmDateMutationVariables = Exact<{
  input: AcceptConfirmDateInput;
}>;


export type AcceptConfirmDateMutation = { __typename: 'Mutation', acceptConfirmDate: { __typename: 'AcceptConfirmDate', errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', field: string | null, message: string | null, code: ScgpRequireAttentionItemsErrorCode }>, items: { __typename: 'ConfirmDate', success: { __typename: 'RequireAttentionItemsCountTableConnection', totalCount: number | null, edges: Array<{ __typename: 'RequireAttentionItemsCountTableEdge', node: { __typename: 'RequireAttentionItems', orderNo: string | null, itemNo: number | null } }> } | null, failed: { __typename: 'RequireAttentionItemsCountTableConnection', totalCount: number | null, edges: Array<{ __typename: 'RequireAttentionItemsCountTableEdge', node: { __typename: 'RequireAttentionItems', id: number | null, orderNo: string | null, itemNo: number | null } }> } | null } | null } | null };

export type DeleteRequireAttentionItemsMutationVariables = Exact<{
  orderLineIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  reason: ReasonForRejectInput;
}>;


export type DeleteRequireAttentionItemsMutation = { __typename: 'Mutation', deleteRequireAttentionItems: { __typename: 'RequireAttentionItemsDelete', totalSuccess: number | null, totalFailed: number | null, success: Array<{ __typename: 'RequireAttentionCancelDeleteItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, confirmQuantity: number | null, confirmDate: any | null, message: string | null } | null> | null, failed: Array<{ __typename: 'RequireAttentionCancelDeleteItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, confirmQuantity: number | null, confirmDate: any | null, message: string | null } | null> | null } | null };

export type AcceptConfirmDateRequireAttentionItemsMutationVariables = Exact<{
  input: AcceptConfirmDateRequireAttentionInput;
}>;


export type AcceptConfirmDateRequireAttentionItemsMutation = { __typename: 'Mutation', acceptConfirmDateRequireAttentionItems: { __typename: 'AcceptConfirmDateRequireAttentionItems', totalFailed: number | null, totalSuccess: number | null, success: Array<{ __typename: 'RequireAttentionEditItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, confirmDate: any | null, confirmQuantity: number | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null } | null> | null, failed: Array<{ __typename: 'RequireAttentionEditItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, confirmDate: any | null, confirmQuantity: number | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null } | null> | null, errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', code: ScgpRequireAttentionItemsErrorCode, field: string | null, message: string | null }> } | null };

export type EditRequireAttentionItemsMutationVariables = Exact<{
  input: EditRequireAttentionInput;
}>;


export type EditRequireAttentionItemsMutation = { __typename: 'Mutation', editRequireAttentionItems: { __typename: 'EditRequireAttentionItems', totalSuccess: number | null, totalFailed: number | null, errors: Array<{ __typename: 'ScgpRequireAttentionItemsError', field: string | null, message: string | null }>, success: Array<{ __typename: 'RequireAttentionEditItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, requestDate: any | null, requestQuantity: number | null, originalQuantity: number | null, originalRequestDate: any | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null } | null> | null, failed: Array<{ __typename: 'RequireAttentionEditItems', orderNo: string | null, itemNo: string | null, materialCode: string | null, materialDescription: string | null, requestDate: any | null, requestQuantity: number | null, originalQuantity: number | null, originalRequestDate: any | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null } | null> | null } | null };

export type AtpCtpRequestMutationVariables = Exact<{
  orderLines: Array<InputMaybe<AtpctpRequestOrderLineInput>> | InputMaybe<AtpctpRequestOrderLineInput>;
}>;


export type AtpCtpRequestMutation = { __typename: 'Mutation', atpCtpRequest: { __typename: 'RequireAttentionATPCTPRequestMutation', items: Array<{ __typename: 'RequireAttentionATPCTPRequestResultType', orderNo: string | null, lineId: string | null, originalItemNo: string | null, materialVariantCode: string | null, materialVariantDescription: string | null, originalQuantity: number | null, originalRequestDate: any | null, originalPlant: string | null, uniqueId: string | null, listItems: Array<{ __typename: 'ATPCTPListItems', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null }> | null, iplanRequestParams: { __typename: 'IPlanResponseRequireAttentionRequestParamsOutput', inquiryMethodCode: string | null, useInventory: boolean | null, useConsignmentInventory: boolean | null, useProjectedInventory: boolean | null, useProduction: boolean | null, splitOrderItem: string | null, singleSource: boolean | null, reAtpRequired: boolean | null, fixSourceAssignment: string | null, requestType: string | null, typeOfDelivery: string | null, transportationMethod: string | null } | null }> | null, itemsFailed: Array<{ __typename: 'RequireAttentionATPCTPRequestResultType', orderNo: string | null, lineId: string | null, originalItemNo: string | null, materialVariantCode: string | null, materialVariantDescription: string | null, originalQuantity: number | null, originalRequestDate: any | null, originalPlant: string | null, listItems: Array<{ __typename: 'ATPCTPListItems', itemNo: string | null, quantity: string | null, confirmDate: string | null, plant: string | null, atpCtp: string | null, atpCtpDetail: string | null, blockCode: string | null, runCode: string | null, paperMachine: string | null, unit: string | null, onHandStock: boolean | null, orderType: string | null }> | null, iplanRequestParams: { __typename: 'IPlanResponseRequireAttentionRequestParamsOutput', inquiryMethodCode: string | null, useInventory: boolean | null, useConsignmentInventory: boolean | null, useProjectedInventory: boolean | null, useProduction: boolean | null, splitOrderItem: string | null, singleSource: boolean | null, reAtpRequired: boolean | null, fixSourceAssignment: string | null, requestType: string | null, typeOfDelivery: string | null, transportationMethod: string | null } | null }> | null } | null };

export type AtpCtpConfirmMutationVariables = Exact<{
  input: AtpctpConfirmInputType;
}>;


export type AtpCtpConfirmMutation = { __typename: 'Mutation', atpCtpConfirm: { __typename: 'ATPCTPConfirmMutation', iPlanMessages: Array<{ __typename: 'IPlanMessage', itemNo: string | null, firstCode: string | null, secondCode: string | null, message: string | null, soNo: string | null } | null> | null, sapOrderMessages: Array<{ __typename: 'SapOrderMessage', errorCode: string | null, soNo: string | null, errorMessage: string | null } | null> | null, sapItemMessages: Array<{ __typename: 'SapItemMessage', errorCode: string | null, errorMessage: string | null, itemNo: string | null } | null> | null, errors: Array<{ __typename: 'ScgpExportError', field: string | null, message: string | null, code: ScgpExportErrorCode }> } | null };

export type QueryDataInputParameterQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryDataInputParameterQuery = { __typename: 'Query', requireAttentionInquiryMethodCode: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null, requireAttentionTypeOfDelivery: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null, requireAttentionSplitOrderItemPartialDelivery: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null, requireAttentionConsignment: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null };

export type RequireAttentionItemsQueryVariables = Exact<{
  sortBy?: InputMaybe<RequireAttentionItemsSortingInput>;
  filter?: InputMaybe<RequireAttentionItemsFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  role: Scalars['String'];
}>;


export type RequireAttentionItemsQuery = { __typename: 'Query', requireAttentionItems: { __typename: 'RequireAttentionItemsViewCountTableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionItemsViewCountTableEdge', node: { __typename: 'RequireAttentionItemView', id: number | null, orderNo: string | null, itemNo: string | null, soldTo: string | null, shipTo: string | null, requestDate: any | null, confirmedDate: any | null, poNo: string | null, plant: string | null, status: string | null, unit: string | null, matCode: string | null, orderId: number | null, matDescription: string | null, requestQuantity: number | null, attentionType: string | null, iplantConfirmQuantity: number | null, assignedQuantity: number | null, itemStatus: string | null, originalDate: any | null, overdue1: boolean | null, overdue2: boolean | null, inquiryMethodCode: string | null, transportationMethod: string | null, typeOfDeliveryValue: string | null, fixSourceAssignment: string | null, splitOrderItemValue: string | null, partialDeliveryValue: string | null, consignmentValue: string | null, flagR5: boolean | null } }> } | null };

export type FilterRequireAttentionMaterialQueryVariables = Exact<{
  distributionChannelType: DistributionChannelType;
  filter?: InputMaybe<RequireAttentionMaterialFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterRequireAttentionMaterialQuery = { __typename: 'Query', filterRequireAttentionMaterial: { __typename: 'MaterialMasterCountTableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'MaterialMasterCountTableEdge', node: { __typename: 'MaterialMaster', name: string | null, code: string | null, descriptionEn: string | null } }> } | null };

export type GetFilterRequireAttentionBusinessUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterRequireAttentionBusinessUnitQuery = { __typename: 'Query', filterRequireAttentionBusinessUnit: Array<{ __typename: 'BusinessUnit', id: string | null, name: string | null, companies: Array<{ __typename: 'CheckoutCompany', id: string | null, name: string | null } | null> | null } | null> | null };

export type GetFilterRequireAttentionSalesOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterRequireAttentionSalesOrganizationQuery = { __typename: 'Query', filterRequireAttentionSalesOrganization: Array<{ __typename: 'SalesOrganization', name: string | null, code: string | null, id: string | null, businessUnit: { __typename: 'BusinessUnit', id: string | null } | null } | null> | null };

export type GetFilterRequireAttentionSalesGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterRequireAttentionSalesGroupQuery = { __typename: 'Query', filterRequireAttentionSalesGroup: Array<{ __typename: 'SalesGroup', name: string | null, code: string | null, salesOrganization: { __typename: 'SalesOrganization', id: string | null } | null } | null> | null };

export type GetRequireAttentionTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequireAttentionTypeQuery = { __typename: 'Query', requireAttentionType: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null };

export type GetFilterRequireAttentionMaterialGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterRequireAttentionMaterialGroupQuery = { __typename: 'Query', filterRequireAttentionMaterialGroup: Array<{ __typename: 'ScgpMaterialGroup', name: string | null, code: string | null } | null> | null };

export type GetRequireAttentionItemStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequireAttentionItemStatusQuery = { __typename: 'Query', requireAttentionItemStatus: Array<{ __typename: 'RequireAttentionEnums', name: string | null, value: string | null } | null> | null };

export type FilterRequireAttentionSalesOrganizationByBuQueryVariables = Exact<{
  filter?: InputMaybe<RequireAttentionSalesOrganizationFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterRequireAttentionSalesOrganizationByBuQuery = { __typename: 'Query', filterRequireAttentionSalesOrganizationByBu: { __typename: 'RequireAttentionSalesOrganizationCountTableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionSalesOrganizationCountTableEdge', node: { __typename: 'SalesOrganization', name: string | null, code: string | null } }> } | null };

export type FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables = Exact<{
  filter?: InputMaybe<RequireAttentionSalesGroupFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterRequireAttentionSalesGroupBySalesOrganizationQuery = { __typename: 'Query', filterRequireAttentionSalesGroupBySalesOrganization: { __typename: 'RequireAttentionSalesGroupCountTableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionSalesGroupCountTableEdge', node: { __typename: 'SalesGroup', name: string | null, code: string | null } }> } | null };

export type GetRequireAttentionItemsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type GetRequireAttentionItemsByIdsQuery = { __typename: 'Query', requireAttentionItemsByIds: { __typename: 'RequireAttentionItemsViewCountTableConnection', latestPageItemNumber: number | null, totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionItemsViewCountTableEdge', node: { __typename: 'RequireAttentionItemView', id: number | null, orderNo: string | null, matCode: string | null, matDescription: string | null, itemNo: string | null, requestQuantity: number | null, requestDate: any | null, plant: string | null, iplantConfirmQuantity: number | null, assignedQuantity: number | null, confirmedDate: any | null, iPlan: { __typename: 'RequireAttentionIPlan', atpCtp: string | null, atpCtpDetail: string | null, block: string | null, run: string | null } | null } }> } | null };

export type GetFilterRequireAttentionShipToQueryVariables = Exact<{
  filter?: InputMaybe<RequireAttentionShipToFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetFilterRequireAttentionShipToQuery = { __typename: 'Query', filterRequireAttentionShipTo: { __typename: 'RequireAttentionItemsCountTableConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionItemsCountTableEdge', node: { __typename: 'RequireAttentionItems', shipTo: string | null } }> } | null };

export type SuggestionSearchForMaterialGradeGramQueryVariables = Exact<{
  filter?: InputMaybe<SuggestionSearchMaterialGradeGramFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionSearchForMaterialGradeGramQuery = { __typename: 'Query', suggestionSearchForMaterialGradeGram: { __typename: 'MaterialVariantMasterCountTableConnection', totalCount: number | null, edges: Array<{ __typename: 'MaterialVariantMasterCountTableEdge', node: { __typename: 'MaterialVariantMaster', code: string | null, descriptionTh: string | null } }> } | null };

export type RequireAttentionEditItemsByIdsQueryVariables = Exact<{
  sortBy?: InputMaybe<RequireAttentionItemsSortingInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type RequireAttentionEditItemsByIdsQuery = { __typename: 'Query', requireAttentionEditItemsByIds: { __typename: 'RequireAttentionItemsViewCountTableConnection', totalCount: number | null, latestPageItemNumber: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'RequireAttentionItemsViewCountTableEdge', node: { __typename: 'RequireAttentionItemView', id: number | null, orderNo: string | null, itemNo: string | null, soldTo: string | null, originalDate: any | null, inquiryMethodCode: string | null, requestDate: any | null, confirmedDate: any | null, requestQuantity: number | null, iplantConfirmQuantity: number | null, assignedQuantity: number | null, unit: string | null, matCode: string | null, matDescription: string | null, poNo: string | null, plant: string | null, shipTo: string | null, itemStatus: string | null, status: string | null, attentionType: string | null, overdue1: boolean | null, overdue2: boolean | null } }> } | null };

export type OrderDraftsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<OrderDraftSorterInput>;
  filter?: InputMaybe<ScgOrderDraftFilterInput>;
}>;


export type OrderDraftsQuery = { __typename: 'Query', orderDrafts: { __typename: 'TempOrderCountableConnection', latestPageItemNumber: number | null, totalCount: number | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null }, edges: Array<{ __typename: 'TempOrderCountableEdge', node: { __typename: 'TempOrder', id: string | null, type: string | null, status: string | null, poNumber: string | null, contractPiNo: string | null, createdAt: any | null, updatedAt: any | null, saleOrganization: { __typename: 'SalesOrganization', code: string | null, businessUnit: { __typename: 'BusinessUnit', code: string | null, name: string | null } | null } | null, customer: { __typename: 'SoldToMaster', code: string | null, name: string | null } | null, createdBy: { __typename: 'User', id: string, email: string } | null } }> } | null };

export type SearchCustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  query: Scalars['String'];
}>;


export type SearchCustomersQuery = { __typename: 'Query', search: { __typename: 'UserCountableConnection', edges: Array<{ __typename: 'UserCountableEdge', node: { __typename: 'User', id: string, email: string, firstName: string, lastName: string } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type SearchPermissionGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  query: Scalars['String'];
}>;


export type SearchPermissionGroupsQuery = { __typename: 'Query', search: { __typename: 'GroupCountableConnection', edges: Array<{ __typename: 'GroupCountableEdge', node: { __typename: 'Group', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type SearchStaffMembersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  query: Scalars['String'];
}>;


export type SearchStaffMembersQuery = { __typename: 'Query', search: { __typename: 'UserCountableConnection', edges: Array<{ __typename: 'UserCountableEdge', node: { __typename: 'User', id: string, email: string, firstName: string, lastName: string, isActive: boolean, avatar: { __typename: 'Image', alt: string | null, url: string } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type ShopSettingsUpdateMutationVariables = Exact<{
  shopSettingsInput: ShopSettingsInput;
  isCloudInstance: Scalars['Boolean'];
}>;


export type ShopSettingsUpdateMutation = { __typename: 'Mutation', shopSettingsUpdate: { __typename: 'ShopSettingsUpdate', errors: Array<{ __typename: 'ShopError', code: ShopErrorCode, field: string | null, message: string | null }>, shop: { __typename: 'Shop', customerSetPasswordUrl: string | null, defaultMailSenderAddress: string | null, defaultMailSenderName: string | null, description: string | null, name: string, reserveStockDurationAnonymousUser: number | null, reserveStockDurationAuthenticatedUser: number | null, limitQuantityPerCheckout: number | null, countries: Array<{ __typename: 'CountryDisplay', code: string, country: string }>, domain: { __typename: 'Domain', host: string } } | null } | null };

export type SiteSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteSettingsQuery = { __typename: 'Query', shop: { __typename: 'Shop', customerSetPasswordUrl: string | null, defaultMailSenderAddress: string | null, defaultMailSenderName: string | null, description: string | null, name: string, reserveStockDurationAnonymousUser: number | null, reserveStockDurationAuthenticatedUser: number | null, limitQuantityPerCheckout: number | null, countries: Array<{ __typename: 'CountryDisplay', code: string, country: string }>, domain: { __typename: 'Domain', host: string } } };

export type SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables = Exact<{
  filter?: InputMaybe<SuggestionSearchMaterialGradeGramFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SuggestionSearchForMaterialGradeGramStockOnHandQuery = { __typename: 'Query', suggestionSearchForMaterialGradeGram: { __typename: 'MaterialVariantMasterCountTableConnection', totalCount: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename: 'MaterialVariantMasterCountTableEdge', node: { __typename: 'MaterialVariantMaster', code: string | null, descriptionEn: string | null } }> } | null };

export type GetStockOnHandReportQueryVariables = Exact<{
  input: GetOnHandReportInput;
}>;


export type GetStockOnHandReportQuery = { __typename: 'Query', getStockOnHandReport: { __typename: 'StockOnHandReport', productCode: string | null, totalUr: number | null, customerOrderQuantity: number | null, consignmentQuantity: number | null, freeQuantity: number | null, unit: string | null, summaryAsOf: string | null, allPlant: Array<string | null> | null, customerOrderList: Array<{ __typename: 'CustomerOrderList', customer: string | null, soNoSlashItem: string | null, quantity: number | null, pendingQuantity: number | null, requestDate: string | null, plant: string | null, soNo: string | null, createDate: string | null, saleRep: string | null, poNo: string | null, createBy: { __typename: 'ScgpUser', firstName: string, lastName: string } | null } | null> | null, consignmentList: Array<{ __typename: 'ConsignmentList', customerSession: string | null, quantity: number | null, futureDummyStock: number | null, plant: string | null } | null> | null, freeStockList: Array<{ __typename: 'FreeStockList', plant: string | null, quantity: number | null } | null> | null } | null };

export type ScgpUserRegisterMutationVariables = Exact<{
  input: ScgpUserRegisterInput;
}>;


export type ScgpUserRegisterMutation = { __typename: 'Mutation', scgpUserRegister: { __typename: 'ScgpUserRegister', user: { __typename: 'ScgpUser', id: string | null } | null, errors: Array<{ __typename: 'ScgpUserManagementError', field: string | null, message: string | null }> } | null };

export type ScgpUserUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ScgpUserUpdateInput;
}>;


export type ScgpUserUpdateMutation = { __typename: 'Mutation', scgpUserUpdate: { __typename: 'ScgpUserUpdate', user: { __typename: 'ScgpUser', id: string | null } | null, errors: Array<{ __typename: 'ScgpUserManagementError', field: string | null, message: string | null }> } | null };

export type ChangeScgpUserStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['Boolean'];
}>;


export type ChangeScgpUserStatusMutation = { __typename: 'Mutation', changeScgpUserStatus: { __typename: 'ChangeScgpUserStatus', user: { __typename: 'ScgpUser', id: string | null, isActive: boolean } | null } | null };

export type ScgpDeleteUserMutationVariables = Exact<{
  user_id: Scalars['ID'];
}>;


export type ScgpDeleteUserMutation = { __typename: 'Mutation', scgpDeleteUser: { __typename: 'ScgpDeleteUser', status: string | null } | null };

export type GetParentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParentGroupsQuery = { __typename: 'Query', parentGroups: { __typename: 'ParentGroupCountableConnection', edges: Array<{ __typename: 'ParentGroupCountableEdge', node: { __typename: 'ParentGroup', name: string | null, id: string | null } }> } | null };

export type GetRoleListByGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRoleListByGroupQuery = { __typename: 'Query', parentGroup: { __typename: 'ParentGroup', name: string | null, id: string | null, groups: Array<{ __typename: 'ScgpGroup', id: string | null, name: string } | null> | null } | null };

export type GetPermissionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionGroupsQuery = { __typename: 'Query', permissionGroups: { __typename: 'GroupCountableConnection', edges: Array<{ __typename: 'GroupCountableEdge', node: { __typename: 'Group', name: string, id: string } }> } | null };

export type GetListUserManagementQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ScgpUsersFilterInput>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ScgpUserSortingInput>;
}>;


export type GetListUserManagementQuery = { __typename: 'Query', scgpUsers: { __typename: 'ScgpUserCountableConnection', totalCount: number | null, latestPageItemNumber: number | null, edges: Array<{ __typename: 'ScgpUserCountableEdge', node: { __typename: 'ScgpUser', id: string | null, firstName: string, lastName: string, email: string, dateJoined: any, isActive: boolean, extendData: { __typename: 'ScgpUserExtend', employeeId: string | null, customerType: string | null, userParentGroup: { __typename: 'ParentGroup', id: string | null, name: string | null } | null, scgpBus: Array<{ __typename: 'BusinessUnits', id: string | null, name: string | null } | null> | null, scgpSalesOrganizations: Array<{ __typename: 'SalesOrganizationMaster', id: string | null, name: string | null } | null> | null, scgpSalesGroups: Array<{ __typename: 'SalesGroupMaster', id: string | null, name: string | null } | null> | null, updatedBy: { __typename: 'User', firstName: string, lastName: string } | null } | null, soldTos: Array<{ __typename: 'SoldToMaster', code: string | null, name: string | null } | null> | null, permissionGroups: Array<{ __typename: 'ScgpGroup', id: string | null, name: string } | null> | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type FilterSoldToScgCheckoutQueryVariables = Exact<{
  filter?: InputMaybe<UserManagementSoldToFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterSoldToScgCheckoutQuery = { __typename: 'Query', filterSoldToScgCheckout: { __typename: 'SoldToMasterCountableConnection', edges: Array<{ __typename: 'SoldToMasterCountableEdge', node: { __typename: 'SoldToMaster', id: string | null, addressText: string | null, code: string | null, name: string | null } }> } | null };

export type ScgpUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScgpUserQuery = { __typename: 'Query', scgpUser: { __typename: 'ScgpUser', id: string | null, email: string, firstName: string, lastName: string, lastLogin: any | null, dateJoined: any, updatedAt: any, isActive: boolean, soldTos: Array<{ __typename: 'SoldToMaster', id: string | null, code: string | null, name: string | null } | null> | null, permissionGroups: Array<{ __typename: 'ScgpGroup', id: string | null, name: string } | null> | null, extendData: { __typename: 'ScgpUserExtend', displayName: string | null, customerType: string | null, companyEmail: string | null, adUser: string | null, employeeId: string | null, saleId: string | null, sapId: string | null, updatedAt: any | null, scgpBus: Array<{ __typename: 'BusinessUnits', id: string | null, name: string | null } | null> | null, scgpSalesOrganizations: Array<{ __typename: 'SalesOrganizationMaster', id: string | null, code: string | null, name: string | null } | null> | null, scgpSalesGroups: Array<{ __typename: 'SalesGroupMaster', id: string | null, code: string | null, name: string | null } | null> | null, scgpDistributionChannels: Array<{ __typename: 'DistributionChannelMaster', id: string | null, code: string | null, name: string | null } | null> | null, scgpDivisions: Array<{ __typename: 'DivisionMaster', id: string | null, code: string | null, name: string | null } | null> | null, scgpSalesOffices: Array<{ __typename: 'SalesOfficeMaster', id: string | null, code: string | null, name: string | null } | null> | null, createdBy: { __typename: 'User', firstName: string, lastName: string } | null, updatedBy: { __typename: 'User', firstName: string, lastName: string } | null, userParentGroup: { __typename: 'ParentGroup', id: string | null, code: string | null, name: string | null } | null } | null } | null };

export type ParentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParentGroupsQuery = { __typename: 'Query', parentGroups: { __typename: 'ParentGroupCountableConnection', totalCount: number | null, edges: Array<{ __typename: 'ParentGroupCountableEdge', node: { __typename: 'ParentGroup', id: string | null, code: string | null, name: string | null } }> } | null };

export type GetScgpGdcDataQueryVariables = Exact<{
  adUser: Scalars['String'];
}>;


export type GetScgpGdcDataQuery = { __typename: 'Query', scgpGdcData: { __typename: 'GDCUserData', employeeId: string | null, email: string | null, firstName: string | null, lastName: string | null, saleOrgs: Array<{ __typename: 'SalesOrganizationMaster', id: string | null, code: string | null, name: string | null } | null> | null, bus: Array<{ __typename: 'BusinessUnits', id: string | null, code: string | null, name: string | null } | null> | null } | null };

export type FilterUserManagementSaleOrgByBuQueryVariables = Exact<{
  filter?: InputMaybe<UserManagementSaleOrgFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterUserManagementSaleOrgByBuQuery = { __typename: 'Query', filterUserManagementSaleOrgByBu: { __typename: 'UserManagementSaleOrgCountTableConnection', edges: Array<{ __typename: 'UserManagementSaleOrgCountTableEdge', node: { __typename: 'SalesOrganizationMaster', code: string | null, name: string | null, id: string | null, shortName: string | null } }> } | null };

export type FilterUserManagementSaleGroupBySaleOrgQueryVariables = Exact<{
  filter?: InputMaybe<UserManagementSalesGroupFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterUserManagementSaleGroupBySaleOrgQuery = { __typename: 'Query', filterUserManagementSaleGroupBySaleOrg: { __typename: 'UserManagementSalesGroupCountTableConnection', edges: Array<{ __typename: 'UserManagementSalesGroupCountTableEdge', node: { __typename: 'SalesGroupMaster', code: string | null, name: string | null, id: string | null, displayText: string | null } }> } | null };

export type FilterUserManagementSaleOfficeBySaleOrgQueryVariables = Exact<{
  filter?: InputMaybe<UserManagementSaleOfficeFilterInput>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type FilterUserManagementSaleOfficeBySaleOrgQuery = { __typename: 'Query', filterUserManagementSaleOfficeBySaleOrg: { __typename: 'UserManagementSaleOfficeCountTableConnection', edges: Array<{ __typename: 'UserManagementSaleOfficeCountTableEdge', node: { __typename: 'SalesOfficeMaster', code: string | null, name: string | null, id: string | null, displayText: string | null } }> } | null };

export type GetRolesAndMenuFunctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesAndMenuFunctionsQuery = { __typename: 'Query', getRolesAndMenuFunctions: { __typename: 'ParentGroupRoleMenuCountableConnection', edges: Array<{ __typename: 'ParentGroupRoleMenuCountableEdge', node: { __typename: 'ParentGroupAndRole', id: string | null, name: string | null, code: string | null, groups: Array<{ __typename: 'ScgpGroupsAndMenuFunctions', id: string | null, name: string, menuFunctions: Array<{ __typename: 'MenuFunction', code: string | null, name: string | null } | null> | null } | null> | null } }> } | null };
